// Importing Chart.js
//import * as Chart from 'chart.js/auto';
//import { Chart } from 'chart.js';
import Chart from 'chart.js/auto';
//const AirfoilFinder = require('./airfoil_finder.ts');
import { findAirfoil } from "./airfoil_finder.js";
//import {ScriptableLineSegmentContext} from "chart.js/dist/types/index.js";
const bootstrap = require('bootstrap');
// @ ts-ignore
//import Utils from './chartjs_utils.js';
const Utils = require('../chartjs_utils.js');
//const DataClasses = require('./data_classes.ts');
import { EnvironmentData, airspeedMetersPerSecond, round2dec } from "./data_classes.js";
//const XFoilAirfoils = require('./xfoil_airfoils.ts');
import { SearchConstraints, GenericSimulatedAirfoil, loadJsonFromUrl, XfoilFoils } from "./xfoil_airfoils.js";
import jquery from "jquery";
//import jquery = require("jquery");
// this helps TypeScript to understand jQuery best !!!  otherwise It will confused .
const $ = jquery;
//import { valueOrDefault } from 'chart.js/helpers';
const { List } = require('immutable');
import 'bootstrap-icons/font/bootstrap-icons.css';
class AirframeData {
    weight_without_battery_kg() {
        return this.emptyWeight + this.payloadWeight;
    }
    constructor(airplaneName, wingSpan, wingArea, zeroAoACl, oswaldEfficiencyFactor, maxCl, cd0, emptyWeight, payloadWeight) {
        this.airplaneName = airplaneName;
        this.wingSpan = wingSpan;
        this.wingArea = wingArea;
        this.zeroAoACl = zeroAoACl;
        this.oswaldEfficiencyFactor = oswaldEfficiencyFactor;
        this.maxCl = maxCl;
        this.cd0 = cd0;
        this.emptyWeight = emptyWeight;
        this.payloadWeight = payloadWeight;
    }
    aspectRatio() {
        return this.wingSpan * this.wingSpan / this.wingArea;
    }
}
function approximateClCd(airplane, angleOfAttack) {
    const airframeData = airplane.airframeData;
    // The approximateClCd function uses simplified linear models for Cl and Cd. Depending on your application, you may need more sophisticated models or empirical data.
    // Example calculations - you might need more complex models based on your requirements
    // const cl = airframeData.zeroAoACl + (airframeData.maxCl - airframeData.zeroAoACl) * angleOfAttack / 15; // Example linear model
    // const cd = airframeData.cd0 + cl * cl / (Math.PI * airframeData.aspectRatio() * airframeData.oswaldEfficiencyFactor); // Simplified model
    // Example polynomial coefficients - FIXME: these should be determined based on actual airfoil data
    const stallAngle = 15; // Define the stall angle, adjust based on airfoil data
    const clMaxAoA = 12; // Angle of attack at which Cl is maximum, adjust based on airfoil data
    let cl, cd;
    //
    // // Increase Cl with AoA up to the stall angle
    // if (angleOfAttack <= stallAngle) {
    //     cl = airframeData.zeroAoACl + (airframeData.maxCl - airframeData.zeroAoACl) * (angleOfAttack / clMaxAoA) ** 2;
    // } else {
    //     // Decrease Cl beyond the stall angle - inverted quadratic
    //     cl = airframeData.maxCl - (angleOfAttack - stallAngle) ** 2 * 0.01; // Example decrease rate, adjust as needed
    // }
    //
    // // Cd modeled as increasing with the square of the deviation from 0 AoA
    // cd = airframeData.cd0 + 0.004 * (angleOfAttack ** 2);
    //
    // // Ensure Cl doesn't go negative and doesn't exceed Max CL
    // cl = Math.max(0, Math.min(cl, airframeData.maxCl));
    // some real airfoil like this http://airfoiltools.com/airfoil/details?airfoil=prandtl-d-root-ns#polars
    cl = airframeData.zeroAoACl + (airframeData.maxCl - airframeData.zeroAoACl) * (1 - (angleOfAttack - clMaxAoA) ** 2 / clMaxAoA ** 2);
    // Cl modeled as an inverted quadratic function peaking at stall angle
    if (angleOfAttack <= stallAngle) {
    }
    else {
        cl = cl * Math.exp(-(angleOfAttack - clMaxAoA) / 5); // Exponential decrease past stall
    }
    // Cd increases with the square of the deviation from 0 AoA
    cd = (airframeData.cd0 + 0.0005 * (angleOfAttack ** 2)) * airplane.miscFactorsData.dragFudgeFactor;
    // Ensure Cl doesn't go negative
    cl = Math.min(Math.max(0, cl), airframeData.maxCl);
    // induced drag
    const Cdi = calculateCdi(airframeData, cl);
    return {
        "cl": cl,
        "cd": cd,
        "AoA": angleOfAttack,
        "Cdi": Cdi,
    };
}
function calculateLiftDragAtSpeed(airplane, airspeedKmh, angleOfAttack) {
    const airframeData = airplane.airframeData;
    const { cl, cd, Cdi } = approximateClCd(airplane, angleOfAttack);
    const dynamicPressure = airplane.environmentData.dynamicPressure(airspeedKmh);
    const lift = cl * dynamicPressure * airframeData.wingArea;
    const drag = cd * dynamicPressure * airframeData.wingArea;
    const { inducedDrag: inducedDrag } = calculateInducedDrag(airplane.environmentData, airframeData, cl, dynamicPressure);
    return { lift, drag, cl, cd, inducedDrag, Cdi };
}
function calculateCustomCdi(aspectRatio, cl, oswaldEfficiencyFactor) {
    return cl * cl / (Math.PI * aspectRatio * oswaldEfficiencyFactor);
}
function calculateCdi(airframeData, cl) {
    return cl * cl / (Math.PI * airframeData.aspectRatio() * airframeData.oswaldEfficiencyFactor);
}
function calculateInducedDrag(environmentData, airframeData, cl, dynamicPressure) {
    const Cdi = calculateCdi(airframeData, cl);
    const inducedDrag = Cdi * dynamicPressure * airframeData.wingArea;
    return { Cdi, inducedDrag };
}
function generateAerodynamicData(airplaine, minAirspeed, maxAirspeed, airspeedStep) {
    const environmentData = airplaine.environmentData;
    const airframeData = airplaine.airframeData;
    let airspeeds = [];
    let liftNs = [];
    let dragN = [];
    let totalDrag = [];
    let inducedDrag = [];
    let AoAs = [];
    let powerUsage = [];
    let flightTimeMinutes = [];
    let flightDistances = [];
    let CLs = [];
    let CDs = [];
    let CDis = [];
    let AoAs_not_stalled = [];
    let CLs_not_stalled = [];
    let CDs_not_stalled = [];
    let CDis_not_stalled = [];
    let LDratios = [];
    let efficiencyWhsPerKm = [];
    let auw = airplaine.auw_kg();
    for (let airspeedKmh = minAirspeed; airspeedKmh <= maxAirspeed; airspeedKmh += airspeedStep) {
        let aoa = -3; // Starting AoA
        const maxAoA = 12; // Maximum AoA to check, adjust as needed
        const aoaStep = 0.01; // Increment AoA in steps, adjust for precision
        // need to find lowest AoA such that L >= AUW
        var liftN = null;
        var d = null;
        var cl = null;
        var cd = null;
        var Cdi = null;
        var iDrag = null;
        var stalled = true;
        while (aoa <= maxAoA) {
            const { lift: currentLift, drag: currentDrag, cl: cl_, cd: cd_, inducedDrag: iDrag_, Cdi: Cdi_ } = calculateLiftDragAtSpeed(airplaine, airspeedKmh, aoa);
            liftN = currentLift;
            d = currentDrag;
            cl = cl_;
            cd = cd_;
            iDrag = iDrag_;
            Cdi = Cdi_;
            if (currentLift >= auw * environmentData.gravity) {
                stalled = false;
                break;
            }
            aoa += aoaStep;
        }
        if (liftN !== null && d !== null && cl !== null && cd !== null && Cdi !== null && iDrag !== null && liftNs != null && iDrag !== null) {
            airspeeds.push(airspeedKmh);
            liftNs.push((stalled) ? null : liftN);
            dragN.push((stalled) ? null : d);
            AoAs.push(aoa);
            CLs.push(cl);
            CDs.push(cd);
            CDis.push(Cdi);
            AoAs_not_stalled.push((stalled) ? null : aoa);
            CLs_not_stalled.push((stalled) ? null : cl);
            CDs_not_stalled.push((stalled) ? null : cd);
            CDis_not_stalled.push((stalled) ? null : Cdi);
            inducedDrag.push((stalled) ? null : iDrag);
            const totalDragN = d + iDrag;
            totalDrag.push((stalled) ? null : totalDragN);
            LDratios.push((stalled || !(totalDragN > 0)) ? null : (liftN / totalDragN));
            const powerW = (stalled) ? null : airplaine.totalPowerUsageWatts(totalDragN, airspeedKmh);
            powerUsage.push(powerW);
            if (powerW && powerW > 0) {
                const flightHours = airplaine.availableEnergyWhrs() / powerW;
                flightTimeMinutes.push(flightHours * 60);
                const flightDistKm = flightHours * airspeedKmh;
                flightDistances.push(flightDistKm);
                efficiencyWhsPerKm.push(airplaine.availableEnergyWhrs() / flightDistKm);
            }
            else {
                flightTimeMinutes.push(null);
                flightDistances.push(null);
                efficiencyWhsPerKm.push(null);
            }
        }
    }
    return { airspeeds, lift: liftNs, drag: dragN, totalDrag, inducedDrag, powerUsage, flightTimeMinutes,
        flightDistances: flightDistances, AoAs, CLs, CDs, CDis, LDratios: LDratios, efficiencyWhsPerKm: efficiencyWhsPerKm,
        AoAs_not_stalled, CLs_not_stalled, CDs_not_stalled, CDis_not_stalled };
}
class PropulsionData {
    constructor(propulsionType, propellerEfficiency, motorEfficiency, escEfficiency, maxMotorPower, maxThrust) {
        this.propulsionType = propulsionType;
        //                             <option value="edfSchubeler128mm">EDF Schubeler 128mm DS-94-DIA HST with DSM6740-650</option>
        //                             <option value="edfSchubeler70mm">EDF Schubeler 70mm DS-30-AXI 70mm + HET 2W-20 3400kV</option>
        switch (propulsionType) {
            case "edfSchubeler70mm":
                this.propulsionEfficiency = 0.57;
                break;
            case "edfSchubeler128mm":
                this.propulsionEfficiency = 0.71;
                break;
            case "jet_5kg_old":
                this.propulsionEfficiency = 1;
                // FIXME: update UI
                maxThrust = 50;
                maxMotorPower = 5000;
            default:
                if (motorEfficiency && propellerEfficiency) {
                    this.propulsionEfficiency = motorEfficiency * propellerEfficiency;
                }
                else {
                    // FIMXE
                    this.propulsionEfficiency = 0.01;
                }
        }
        if (escEfficiency) {
            this.escEfficiency = escEfficiency;
        }
        else {
            this.escEfficiency = 1.0;
        }
        if (maxMotorPower) {
            this.maxMotorPower = maxMotorPower;
        }
        else {
            this.maxMotorPower = 1.0;
        }
        if (maxThrust !== undefined && maxThrust > 0) {
            this.maxThrust = maxThrust;
        }
        else {
            this.maxThrust = 1000000;
        }
    }
    totalEfficiency() {
        return this.propulsionEfficiency * this.escEfficiency;
    }
}
class BatteryData {
    constructor(batteryType, batteryS, batteryP) {
        this.cellType = batteryType;
        this.batteryS = batteryS;
        this.batteryP = batteryP;
    }
    numCells() {
        return this.batteryP * this.batteryS;
    }
    energy() {
        return this.numCells() * this.cellType.cell_energy_wh;
    }
    weight_kg() {
        // FIXME: add connectors & holders weight
        return (this.numCells() * this.cellType.weight_gram) / 1000;
    }
}
class PowerUsageData {
    constructor(payloadPowerUsage, fcPower, vtxPower) {
        this.payloadPowerUsage = payloadPowerUsage;
        this.fcPower = fcPower;
        this.vtxPower = vtxPower;
    }
    usageWatts() {
        return this.payloadPowerUsage + this.fcPower + this.vtxPower;
    }
}
const KinematicViscositiesByAirTemperature = {
    "-10": 1.2462E-5,
    "0C": 1.3324E-5,
    "10C": 1.4207E-5,
    "20C": 1.5111E-5
};
// FIXME: air density dropdown!
//
// Kinematic
// Viscosity m2/s	°C	°F
// 1.2462E-5	    -10	14
// 1.3324E-5	    0	32
// 1.4207E-5	    10	50
// 1.5111E-5	    20	68
class MiscFactorsData {
    constructor(batteryUsagePercent, dragFudgeFactor) {
        this.batteryUsageFactor = batteryUsagePercent / 100;
        this.dragFudgeFactor = dragFudgeFactor;
    }
}
class AirplaneData {
    constructor(airframeData, propulsionData, batteryData, powerUsageData, environmentData, miscFactorsData) {
        this.airframeData = airframeData;
        this.propulsionData = propulsionData;
        this.batteryData = batteryData;
        this.powerUsageData = powerUsageData;
        this.environmentData = environmentData;
        this.miscFactorsData = miscFactorsData;
    }
    auw_kg() {
        return this.airframeData.weight_without_battery_kg() + this.batteryData.weight_kg();
    }
    availableEnergyWhrs() {
        return this.batteryData.energy() * this.miscFactorsData.batteryUsageFactor;
    }
    availableEnergyAfterTime(timeMinutes) {
        return this.availableEnergyWhrs() - (timeMinutes / 60) * this.powerUsageData.usageWatts();
    }
    propulsionPowerUsage(dragN, airspeedKmh) {
        return (dragN * airspeedMetersPerSecond(airspeedKmh)) / this.propulsionData.totalEfficiency();
    }
    totalPowerUsageWatts(dragN, airspeedKmh) {
        return this.propulsionPowerUsage(dragN, airspeedKmh) + this.powerUsageData.usageWatts();
    }
}
class BatteryCell {
    constructor(id, name, weight_gram, cell_energy_wh, extra) {
        this.id = id;
        this.weight_gram = weight_gram;
        this.name = name;
        this.cell_energy_wh = cell_energy_wh;
        this.extra = extra;
    }
}
function formatTimeMinutes(timeMinutes) {
    if (timeMinutes === undefined || timeMinutes === null) {
        return '-';
    }
    if (timeMinutes >= 60.0) {
        const hours = Math.floor(timeMinutes / 60);
        const minutesExtra = Math.round(timeMinutes - hours * 60);
        return `${hours} h ${minutesExtra} min`;
    }
    else if (timeMinutes >= 1.0) {
        return `${Math.round(timeMinutes)} min`;
    }
    else {
        return round2dec(timeMinutes) + ' min';
    }
}
const preset250gEfficient = {
    airplaneName: "250g AUW 2S 18650",
    extraZeroLiftDrag: 0.0,
    batteryType: "US18650VTC6", // FIXME!
    batteryS: 2,
    batteryP: 1,
    emptyWeight: 0.1,
    maxMotorPower: 350,
    minAspectRatio: 1.2,
    minChordLength: 0.06, // hard to balance CG!
    minAirspeed: 25,
    maxAirspeed: 200,
};
const presetFalconV2 = {
    airplaneName: "Titan Falcon V2 (5kg AUW 6S7P)",
    extraZeroLiftDrag: 0, // FIXME: this should work differently as its not related to wing area?!!
    batteryType: "samsung50E21700",
    batteryS: 6,
    batteryP: 7,
    emptyWeight: 2.274,
    maxMotorPower: 1400,
    minAspectRatio: 2,
    minChordLength: 0.1,
    minAirspeed: 60,
    maxAirspeed: 200,
};
const battIdCigaretteSuperlight = "sigaretteSuperlight";
const presetTiny = {
    airplaneName: "Tiny ~40g",
    extraZeroLiftDrag: 0, // FIXME: this should work differently as its not related to wing area?!!
    batteryType: battIdCigaretteSuperlight,
    batteryS: 1,
    batteryP: 1,
    // batt ~7.5g
    // servo=10g
    // rc = 2g
    // frame 20g ? (no motor+esc?)
    emptyWeight: (5 * 2 + 2 + 20) / 1000,
    maxMotorPower: 100,
    minAspectRatio: 2,
    minChordLength: 0.07,
    minAirspeed: 10,
    maxAirspeed: 20,
};
const presets = [
    preset250gEfficient,
    presetFalconV2,
    presetTiny
];
const prandlPresets = [
    {
        airplaineId: "small",
        airplaneName: "Small (44cm, 12cm span)",
        centerChord: 120,
        wingSpan: 220 * 2,
    },
    {
        airplaineId: "mid",
        airplaneName: "Mid-size (1.2m, 12cm span)",
        centerChord: 120,
        wingSpan: 1200,
    },
    // {
    //     airplaineId: "prandtlD3",
    //     // chord = 400; //mm
    //     // wingspan = 3740; //mm
    //     airplaneName: "NASA Prandtl-D 3 (3.74m span, chord 0.4m)",
    //     centerChord: 400,
    //     wingSpan: 3740,
    // },
];
export class AerodynamicsApp {
    constructor(rootId) {
        this.battery_cells = new Map();
        this.rootElement = document.getElementById(rootId);
        this.charts = new Map();
        // FIXME: add configurable connectors & holders weight
        const connectorWeightGram = 7;
        const keepowerLight = new BatteryCell("keepower25gLight", "keepower 18350 25g (~4.44Wh)", 25 + 2, 4.44, { "max_current_Amp": 15, "rated_voltage": 3.6, "max_voltage": 4.2, "min_voltage": 3.0, "type": "Li-Ion" });
        // FIXME
        const cigaretSuperlight = new BatteryCell(battIdCigaretteSuperlight, "cigarette ~8g ~1Wh", 7 + 1, 1, // FIXME:?
        { "max_current_Amp": 15, "rated_voltage": 3.6, "max_voltage": 4.2, "min_voltage": 3.0, "type": "Li-Ion" });
        const samsung = new BatteryCell("samsung50E21700", "Samsung 50E 21700 5000mAh (~18Wh)", 68.595 + connectorWeightGram, 5 * 3.6, { "max_current_Amp": 10, "rated_voltage": 3.6, "max_voltage": 4.2, "min_voltage": 3.0, "type": "Li-Ion", "selected": "selected" });
        const molicel = new BatteryCell("molicelP45B21700", "Molicel P45B - 50A 4500mAh 21700 (~16.2wh)", 68.595 + connectorWeightGram, 4.5 * 3.6, {
            "weight_gram": 68.595,
            "capacity_mah": 4500,
            "max_current_Amp": 50,
            "rated_voltage": 3.6,
            "max_voltage": 4.2,
            "min_voltage": 3.0,
            "type": "Li-Ion"
        });
        const murata = new BatteryCell("US18650VTC6", "Sony|Murata VTC6 US18650VTC6 18650 3120Ah, 30A (~10Wh)", 47 + connectorWeightGram, 
        // Nominal Capacity at 0.2ltA 3120mAh 11.23Wh discharge 2.0V cut off at 23C
        // Rated Capacity at 0.2ltA 3000mAh 10.8Wh discharge 2.0V cut off at 23*C
        // Capacity at 1ItA (typ.) 2850mAh 10.12Wh discharge 2.5V cut off at 23C
        // Capacity at 10A (typ.) 2700mAh 9.18Wh discharge 2.5V cut off at 23C
        10, { "max_current_Amp": 30, "rated_voltage": 3.6, "max_voltage": 4.2, "min_voltage": 3.0, "type": "Li-Ion" });
        this.battery_cells.set(murata.id, murata);
        this.battery_cells.set(samsung.id, samsung);
        this.battery_cells.set(molicel.id, molicel);
        this.battery_cells.set(keepowerLight.id, keepowerLight);
        this.battery_cells.set(cigaretSuperlight.id, cigaretSuperlight);
        this.init();
    }
    init() {
        this.render();
        // Usage
    }
    getById(id) {
        return document.getElementById(id);
    }
    initializeBatteryCells() {
        const batteries = this.getById('batteryType');
        this.battery_cells.forEach((cell) => {
            const selected = cell.id == "samsung50E21700";
            const elm = new Option(cell.name, cell.id, selected, selected);
            // elm.innerText = ;
            // elm.value = ;
            //elm.selected = cell.extra["selected"] == "selected";
            batteries.options.add(elm);
        });
    }
    initializeEventListeners() {
        const form = this.getById('aerodynamicsForm');
        form.addEventListener('submit', this.handleFormSubmit.bind(this));
        const self = this;
        document.addEventListener('DOMContentLoaded', () => {
            const motorPropDropdown = this.getById('propulsionType');
            motorPropDropdown.addEventListener('change', (event) => {
                event.preventDefault();
                console.log(`handleSelectMotorPropSelect...`);
                const div = this.getById('custom-motor');
                const motorPropDropdown = this.getById('propulsionType');
                if (motorPropDropdown) {
                    const optValue = motorPropDropdown.value;
                    // const selectedValue = optItem ? optItem.value : null;
                    console.log(`handleSelectMotorPropSelect: ${optValue} div:`, div);
                    if (div) {
                        if ((!optValue == null) || optValue !== 'custom') {
                            div.classList.add("d-none");
                            //div.style.display = "none";
                        }
                        else {
                            div.classList.remove("d-none");
                            //div.style.display = "block";
                        }
                    }
                }
            });
            self.initializeBatteryCells();
        });
        document.addEventListener('DOMContentLoaded', function () {
            var collapseElementList = [].slice.call(document.querySelectorAll('.collapse'));
            var collapseList = collapseElementList.map(function (collapseEl) {
                console.log(`Enabling collapse for:`, collapseEl);
                //const elm = new bootstrap.Collapse(collapseEl);
                //elm.toggle();
                //elm.toggle().toggle();
                //elm.show();
                //elm.hide();
                //return elm;
            });
            console.log(`Enabled collapses for:`, collapseList);
        });
        const url = '/airfoil_finder_v2/airfoils_v4.json?1';
        //const self = this;
        //const form = self.getById('aerodynamicsForm') as HTMLFormElement;
        document.addEventListener('DOMContentLoaded', () => {
            const form = self.getById('aerodynamicsForm');
            loadJsonFromUrl(url)
                .then((data) => {
                console.log("got airfoils: ", data);
                XfoilFoils.push(...GenericSimulatedAirfoil.createFoils(data));
                //XfoilFoils = List(GenericSimulatedAirfoil.createFoils(data));
                console.log("done loading airfoils: ", XfoilFoils.length);
                // on dom ready
                List(data)
                    .sortBy((foil) => foil.airfoil)
                    .forEach((foil) => {
                    console.log("foil: ", foil.airfoil);
                    let t = "";
                    t += foil.supportPlank ? ' <span class="badge rounded-pill text-bg-success">plank</span>\n' : "";
                    t += foil.supportTail ? ' <span class="badge rounded-pill text-bg-warning">tail</span>\n' : "";
                    t += foil.supportSweptWing ? ' <span class="badge rounded-pill text-bg-info">swept-wing</span>\n' : "";
                    t += foil.supportAerobatics ? ' <span class="badge rounded-pill text-bg-danger">aerobatics</span>\n' : "";
                    t += foil.supportPlankDS ? ' <span class="badge rounded-pill text-bg-dark">plank (dynamic soaring)</span>\n' : "";
                    let c = '';
                    c += foil.supportPlank ? ' supportPlank' : "";
                    c += foil.supportTail ? ' supportTail' : "";
                    c += foil.supportSweptWing ? ' supportSweptWing' : "";
                    c += foil.supportAerobatics ? ' supportAerobatics' : "";
                    c += foil.supportPlankDS ? ' supportPlankDS' : "";
                    const isChecked = foil.supportPlank ? "checked" : "";
                    const airfoilNameShort = foil.airfoil.replace('xf-', '')
                        .replace('-il', '')
                        .replace('-pw', '')
                        .toUpperCase();
                    //$(document).ready(function () {
                    $("#airfoils-selector-div").append($(`
                    <div class="form-check form-switch">
                      <input class="form-check-input ${c}"  type="checkbox" role="switch" id="airfoil-id-${foil.airfoil}" name="enabled-airfoils[]" value="${foil.airfoil}" ${isChecked}>
                      <label class="form-check-label" for="flexSwitchCheckChecked">${airfoilNameShort}: ${t}</label>
                      <!--<a href="" target="_blank">link</a> -->
                    </div>
                    `));
                    //});
                    jquery('input[type="checkbox"]').on('click', function () {
                        console.log("clicked:", this);
                        const inputValue = $(this).attr("id");
                        console.log("inputValue:", inputValue);
                        console.log("inputValue:", jquery("." + inputValue));
                        const checked = $(this).prop('checked');
                        jquery("." + inputValue).each(function () {
                            console.log("this:", this);
                            if (checked == true) {
                                jquery(this).prop("checked", true);
                            }
                            else {
                                jquery(this).prop("checked", false);
                            }
                        });
                    });
                });
                const spinner = self.getById('airfoils-loading-spinner');
                if (spinner) {
                    spinner.innerHTML = '';
                    spinner.className = 'd-none';
                }
                // initialize tooltips
                const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
                setTimeout(function () {
                    self.computeCharts(form);
                });
            })
                .catch(error => {
                console.error('Error loading JSON data:', error);
            });
        });
    }
    handleSelectMotorPropDropdown() {
    }
    getQueryParamValue(paramName) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(paramName);
    }
    submitPrandlForm(event) {
        event.preventDefault();
        console.log("submitPrandlForm: starting...");
        const preset = {
            airplaneName: "Prandtl",
            airplaineId: "prandtlD3",
            centerChord: parseFloat(this.getById('prandtlChordCm').value) * 10,
            wingSpan: parseFloat(this.getById('prandtlWingspanCm').value) * 10,
        };
        const iframeContainer = this.getById('prandtl-iframe-container');
        iframeContainer.innerHTML = this.renderPrandlIFrame(preset, false);
    }
    printPrandlForm(event) {
        event.preventDefault();
        console.log("submitPrandlForm: starting...");
        const preset = {
            airplaneName: "Prandtl",
            airplaineId: "prandtlD3",
            centerChord: parseFloat(this.getById('prandtlChordCm').value) * 10,
            wingSpan: parseFloat(this.getById('prandtlWingspanCm').value) * 10,
        };
        const iframeContainer = this.getById('prandtl-iframe-container');
        iframeContainer.innerHTML = this.renderPrandlIFrame(preset, true);
    }
    render() {
        const defaultPreset = presetFalconV2;
        const presetName = this.getQueryParamValue('planePreset') || defaultPreset.airplaneName;
        const prandlPresetId = this.getQueryParamValue('prandlPreset');
        if (prandlPresetId) {
            const prandlPreset = prandlPresets.find((p) => p.airplaineId === prandlPresetId);
            if (prandlPreset) {
                this.rootElement.innerHTML = `
                    ${this.renderPrandlForm(prandlPreset)}
                `;
            }
            const self = this;
            console.log("Prandtl Adding DOMContentLoaded: prandlPresetId: ");
            document.addEventListener('DOMContentLoaded', () => {
                console.log("DOMContentLoaded: prandlPresetId: ");
                const prandlSubmit = self.getById('prandtl-submit');
                prandlSubmit.onclick = self.submitPrandlForm.bind(self);
                const prandlPrint = self.getById('prandtl-print');
                prandlPrint.onclick = self.printPrandlForm.bind(self);
            });
        }
        else {
            const preset = presets.find((p) => p.airplaneName === presetName) || defaultPreset;
            this.rootElement.innerHTML = `
            ${this.renderForm(preset)}
            ${this.renderCharts()}
        `;
            this.initializeEventListeners();
            ['finder-stats-max-dist', 'finder-stats-max-dist-speed'].forEach((prefix) => {
                new bootstrap.Modal(`#${prefix}-exampleModal`, {
                    keyboard: true
                });
            });
        }
    }
    handleFormSubmit(event) {
        event.preventDefault();
        this.reportEmptyResult('Searching....');
        const self = this;
        setTimeout(function () {
            self.computeCharts(event.target);
        });
    }
    _findSingleAirfoil(airfoil_cl, airfoil_Re, useCFD) {
        // const airfoil_cl = 1.8;
        // const airfoil_Re=500000;
        const useCfd = useCFD; // FIXME: it seems there's a bug/mismatch for P in cfd with website !!! ???
        const airfoil = findAirfoil(airfoil_cl, airfoil_Re, useCfd);
        //console.log(airfoil);
        //console.log(airfoil.airfoilLink());
        return airfoil;
    }
    findBetterAirfoils(aspectRatio, chordMeters, extraZeroLiftDrag, airspeedKmh, weightKg, temperatureId, environmentData, airframeData, airplaine, // FIXME: this will not be a param maybe?
    useCFD) {
        const logEnabled = false;
        const kinematicViscosity = KinematicViscositiesByAirTemperature[temperatureId];
        // FIXME: this is maybe not fully correct? wing area would be always correct?
        const wingSpanMeters = aspectRatio * chordMeters;
        const wingArea = wingSpanMeters * chordMeters; //airframeData.wingArea;
        //
        const Re = environmentData.reynoldsNumber(airspeedKmh, chordMeters, kinematicViscosity);
        const dynamicPressure = environmentData.dynamicPressure(airspeedKmh);
        const requiredLiftNewtons = environmentData.gravity * weightKg;
        // const liftNewtons = cl * dynamicPressure * airframeData.wingArea;
        const Cl = (requiredLiftNewtons / dynamicPressure) / wingArea;
        const outOfRange = (Cl < 0.2 || Cl > 1.8 || Re < 80000 || Re > 500000);
        if (logEnabled) {
            console.log(`findBetterAirfoils(airspeedKmh=${airspeedKmh}, weightKg=${weightKg}, temperatureId=${temperatureId}): trying aspectRatio=${aspectRatio}, chord=${chordMeters}`);
        }
        const newAirfoil = this._findSingleAirfoil(Cl, Re, useCFD);
        const ApproxAirfoilCd = Cl / newAirfoil.Ld;
        const maybeWarning = outOfRange ? "CL (0.2-1.8) or RE (80K-500K) out of bounds!" : "OK";
        // below code is generic
        const result = this.computeFlightParams(aspectRatio, Cl, airframeData, dynamicPressure, wingArea, ApproxAirfoilCd, extraZeroLiftDrag, airplaine, requiredLiftNewtons, airspeedKmh, Re, maybeWarning, chordMeters, weightKg, newAirfoil, outOfRange);
        return result;
    }
    computeFlightParams(aspectRatio, Cl, airframeData, dynamicPressure, wingArea, ApproxAirfoilCd, extraZeroLiftDrag, airplaine, requiredLiftNewtons, airspeedKmh, Re, maybeWarning, chordMeters, weightKg, newAirfoil, outOfRange) {
        // induced drag at max LD
        //
        const Cdi = calculateCustomCdi(aspectRatio, Cl, airframeData.oswaldEfficiencyFactor);
        const inducedDragNewtons = Cdi * dynamicPressure * wingArea;
        const ApproxTotalCd = (ApproxAirfoilCd + extraZeroLiftDrag) * airplaine.miscFactorsData.dragFudgeFactor + Cdi;
        const finalWingLD = Cl / ApproxTotalCd;
        const ApproxTotalDragNewtons = (requiredLiftNewtons / finalWingLD);
        // flight stats with need airspeed
        // FIXME: do we need to handle some conditions where plane is stalled
        // FIXME: has not enough of power...
        const projectedPowerUsageW = airplaine.totalPowerUsageWatts(ApproxTotalDragNewtons, airspeedKmh);
        const projectedFlightHours = airplaine.availableEnergyWhrs() / projectedPowerUsageW;
        const projectedFlightDistKm = projectedFlightHours * airspeedKmh;
        const projectedFlightTimeMinutes = projectedFlightHours * 60;
        const projectedEfficiencyWhsPerKm = airplaine.availableEnergyWhrs() / projectedFlightDistKm;
        //             powerUsage.push(powerW);
        //
        //             if (powerW && powerW > 0){
        //
        //
        //
        //                 flightDistances.push(flightDistKm);
        //
        // as lift is contant to weight, Optimization should simply find one which gives minimum total drag (?)
        // or FIXME if goal max time minutes ?
        const result = {
            "CL": Cl,
            "Reynolds": Re,
            "Warning": maybeWarning,
            "aspectRatio": aspectRatio,
            "extraZeroLiftDrag": extraZeroLiftDrag,
            "chordMeters": chordMeters,
            "airspeedKmh": airspeedKmh,
            "weightKg": weightKg,
            "Cdi": Cdi,
            "ApproxAirfoilCd": ApproxAirfoilCd,
            "inducedDragNewtons": inducedDragNewtons,
            "ApproxTotalCd": ApproxTotalCd,
            "Airfoil Max L/D (approx)": newAirfoil.Ld,
            //"AirfoilLink": newAirfoil.airfoilLink(),
            "ApproxTotalDragNewtons": ApproxTotalDragNewtons,
            "wingLD": finalWingLD,
            "airfoilInfo": newAirfoil,
            projectedPowerUsageW,
            projectedFlightHours,
            projectedFlightDistKm,
            projectedFlightTimeMinutes,
            projectedEfficiencyWhsPerKm,
        };
        //if (logEnabled) console.log("airfoil(s) info:", result);
        const finalResult = {
            link: newAirfoil.airfoilLink,
            info: JSON.stringify(result, null, 4),
            airfoil: newAirfoil,
            outOfRange,
            aspectRatio,
            chordMeters,
            projectedPowerUsageW,
            projectedFlightHours,
            projectedFlightDistKm,
            projectedFlightTimeMinutes,
            projectedEfficiencyWhsPerKm,
            airspeedKmh,
            finalWingLD,
            Cl,
            Cd: ApproxTotalCd,
            Re,
            Cdi,
            ApproxTotalDragNewtons
        };
        return finalResult;
    }
    loadForm(formElement) {
        const formData = new FormData(formElement);
        console.log('printing form data...');
        for (let key of formData.keys()) {
            console.log(key, formData.get(key)); // For debugging
        }
        console.log('done form data...');
        // Instantiate AirframeData
        const airframeData = new AirframeData(formData.get('airplaneName'), parseFloat(formData.get('wingSpan')), parseFloat(formData.get('wingArea')), parseFloat(formData.get('zeroAoACl')), parseFloat(formData.get('oswaldEfficiencyFactor')), parseFloat(formData.get('maxCl')), parseFloat(formData.get('cd0')), parseFloat(formData.get('emptyWeight')), parseFloat(formData.get('payloadWeight')));
        // Instantiate PropulsionData
        const propulsionData = new PropulsionData(formData.get('propulsionType'), parseFloat(formData.get('propellerEfficiency')), parseFloat(formData.get('motorEfficiency')), parseFloat(formData.get('escEfficiency')), parseFloat(formData.get('maxMotorPower')), parseFloat(formData.get('maxThrust')));
        // Instantiate BatteryData
        const cellInfo = this.battery_cells.get(formData.get('batteryType'));
        if (!cellInfo) {
            throw new Error('Something bad happened');
        }
        const batteryData = new BatteryData(cellInfo, parseInt(formData.get('batteryS')), parseInt(formData.get('batteryP')));
        // Instantiate PowerUsageData
        const powerUsageData = new PowerUsageData(parseFloat(formData.get('payloadPowerUsage')), parseFloat(formData.get('fcPower')), parseFloat(formData.get('vtxPower')));
        // Instantiate EnvironmentData
        const environmentData = new EnvironmentData(parseFloat(formData.get('airDensity')), parseFloat(formData.get('gravity')));
        // Instantiate MiscFactorsData
        const miscFactorsData = new MiscFactorsData(parseFloat(formData.get('batteryUsage')), parseFloat(formData.get('dragFudgeFactor')));
        const maxSpeedToAnalyze = parseFloat(formData.get('maxSpeedToAnalyze'));
        const airplane = new AirplaneData(airframeData, propulsionData, batteryData, powerUsageData, environmentData, miscFactorsData);
        return { formData, airplane, maxSpeedToAnalyze };
    }
    setTxtById_(id, value, setHtml = false) {
        if (this.getById(id)) {
            const elm = this.getById(id);
            if (setHtml) {
                elm.innerHTML = value;
            }
            else {
                elm.innerText = value;
            }
        }
        else {
            console.log(`Span element with id=${id} not found, unable to set value=${value}`);
        }
    }
    loadCharts(formData, airplane, maxSpeedToAnalyze) {
        // plot estimated CL & CD
        // FIXME: check book for estimation at small angles!!
        let CLs_CDs = [];
        const maxAoA = 20.0;
        let aoa = -5.0;
        while (aoa <= maxAoA) {
            CLs_CDs.push(approximateClCd(airplane, aoa));
            aoa += 0.1;
        }
        const xDashIfOverspeed = (ctx) => ctx.p0.parsed.x > maxAchievableAirspeed ? [6, 6] : undefined;
        const speedSegmentCfg = {
            // borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
            borderDash: (ctx) => xDashIfOverspeed(ctx),
        };
        this.plotMultiYGraph('CLsCDsChart', CLs_CDs.map((item) => Math.round((item.AoA + Number.EPSILON) * 100) / 100), [
            {
                label: 'CL',
                data: CLs_CDs.map((item) => item.cl),
                borderColor: 'yellow',
                tension: 0.1,
                pointStyle: false,
            },
            {
                label: 'CD',
                data: CLs_CDs.map((item) => item.cd),
                borderColor: 'orange',
                tension: 0.1,
                pointStyle: false,
            },
            {
                label: 'CDi',
                data: CLs_CDs.map((item) => item.Cdi),
                borderColor: 'brown',
                tension: 0.1,
                pointStyle: false,
            },
            {
                label: 'CD+CDi',
                data: CLs_CDs.map((item) => item.cd + item.Cdi),
                borderColor: 'red',
                tension: 0.1,
                pointStyle: false,
            },
            {
                label: 'airfoil L/D',
                data: CLs_CDs.map((item) => item.cl / item.cd),
                borderColor: 'grey',
                tension: 0.1,
                yAxisID: 'y1',
                pointStyle: false,
            },
            {
                label: 'wing L/D',
                data: CLs_CDs.map((item) => item.cl / (item.cd + item.Cdi)),
                borderColor: 'green',
                tension: 0.1,
                yAxisID: 'y1',
                pointStyle: false,
            },
        ], "CL, CD versus AoA ° (rough approximations)", "AoA, °", "coefficient", "L/D");
        const airspeedKmhTitle = "airspeed, km/h";
        const aerodynamicData = generateAerodynamicData(airplane, 
        // minAirspeed: number, maxAirspeed: number, step: number
        0, maxSpeedToAnalyze, 1); // Example range and step
        const maxAchievableAirspeed = this.maxAirspeed(aerodynamicData, airplane);
        console.log("aerodynamicData:", aerodynamicData);
        this.plotGraph('liftChart', 'Lift', aerodynamicData.airspeeds, aerodynamicData.lift, 'green', "Lift", airspeedKmhTitle, "Lift, N");
        // FIXME: needs multiple data points here
        this.plotMultiYGraph('dragChart', aerodynamicData.airspeeds, [
            {
                label: 'Form Drag',
                data: aerodynamicData.drag,
                borderColor: 'yellow',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'Induced Drag',
                data: aerodynamicData.inducedDrag,
                borderColor: 'blue',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'Total Drag',
                data: aerodynamicData.totalDrag,
                borderColor: 'red',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'Power, W',
                data: aerodynamicData.powerUsage,
                borderColor: 'pink',
                tension: 0.1,
                yAxisID: 'y1',
                pointStyle: false,
                segment: speedSegmentCfg,
            },
        ], "Drag in Cruise", airspeedKmhTitle, "Force, N", "Power needed, W");
        // FIXME: needs multiple data points here
        this.plotMultiYGraph('flightChart', aerodynamicData.airspeeds, [
            {
                label: 'Flight Distance',
                data: aerodynamicData.flightDistances,
                borderColor: 'green',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'Flight time, minutes',
                data: aerodynamicData.flightTimeMinutes,
                borderColor: 'blue',
                tension: 0.1,
                yAxisID: 'y1',
                pointStyle: false,
                segment: speedSegmentCfg,
            },
        ], "Flight outcomes vs airspeed", airspeedKmhTitle, "distance, km", "time, minutes");
        this.plotMultiYGraph('efficiencyChart', aerodynamicData.airspeeds, [
            {
                label: 'Efficiency, wh/km',
                data: aerodynamicData.efficiencyWhsPerKm,
                borderColor: 'green',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'Power, W',
                data: aerodynamicData.powerUsage,
                borderColor: 'blue',
                tension: 0.1,
                yAxisID: 'y1',
                pointStyle: false,
                segment: speedSegmentCfg,
            },
        ], "Flight efficiency vs airspeed", airspeedKmhTitle, "power usage, wh/km", "instantenous power, W");
        this.plotMultiYGraph('aoaVsSpeed', aerodynamicData.airspeeds, [
            {
                label: 'Cruise AoA, °',
                data: aerodynamicData.AoAs_not_stalled,
                borderColor: 'green',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'Power, W',
                data: aerodynamicData.powerUsage,
                borderColor: 'blue',
                tension: 0.1,
                yAxisID: 'y1',
                pointStyle: false,
                segment: speedSegmentCfg,
            },
        ], "AoA vs airspeed", airspeedKmhTitle, "AoA, °", "power, W");
        this.plotMultiYGraph('liftDragConstChart', aerodynamicData.airspeeds, [
            {
                label: 'CD',
                data: aerodynamicData.CDs_not_stalled,
                borderColor: 'red',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'CDi',
                data: aerodynamicData.CDis_not_stalled,
                borderColor: 'orange',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'CL',
                data: aerodynamicData.CLs_not_stalled,
                borderColor: 'green',
                tension: 0.1,
                pointStyle: false,
                segment: speedSegmentCfg,
            },
            {
                label: 'L/D',
                data: aerodynamicData.LDratios,
                borderColor: 'blue',
                tension: 0.1,
                yAxisID: 'y1',
                pointStyle: false,
                segment: speedSegmentCfg,
            },
        ], "CL/CD Coefficients vs airspeed (rough approximations)", airspeedKmhTitle);
        const self = this;
        function setTxtById(id, value, setHtml = false) {
            self.setTxtById_(id, value, setHtml);
        }
        function setStats(maxDistIdx, prefix = 'stats-max-dist') {
            const maxDist = aerodynamicData.flightDistances.at(maxDistIdx);
            const maxDistSpeed = aerodynamicData.airspeeds.at(maxDistIdx);
            const maxDistFlightTime = aerodynamicData.flightTimeMinutes.at(maxDistIdx);
            const whPerKm = aerodynamicData.efficiencyWhsPerKm.at(maxDistIdx);
            const powerWatt = aerodynamicData.powerUsage.at(maxDistIdx);
            const AoA = aerodynamicData.AoAs.at(maxDistIdx);
            const dragN = aerodynamicData.totalDrag.at(maxDistIdx);
            console.log(`${prefix} - distance: ${maxDist}, flight time: ${maxDistFlightTime}, speed: ${maxDistSpeed}`);
            function setTxt(name, value) {
                setTxtById(`${prefix}-${name}`, value);
            }
            setTxt('dist', round2dec(maxDist) + ' km');
            setTxt('speed', maxDistSpeed + ' km/h');
            setTxt('flight-time', formatTimeMinutes(maxDistFlightTime));
            setTxt('wh-per-km', round2dec(whPerKm) + ' Wh/km');
            setTxt('watts', round2dec(powerWatt) + ' W');
            setTxt('drag', round2dec(dragN) + ' N');
            setTxt('aoa', round2dec(AoA) + ' °');
        }
        // max flight time
        // FIXME: this is mess and should redo with Map & .map !
        // FIXME: these should filter to make sure that the airspeed is actually achievable due to Max Power & Max Thrust
        // and warn then it's not optimal!
        const listTimes = List(aerodynamicData.flightTimeMinutes);
        const maxTimeIndexAndValue = listTimes.entrySeq().maxBy((v) => v[1]);
        console.log(`maxIndexAndValue: `, maxTimeIndexAndValue);
        const maxTimeIdx = maxTimeIndexAndValue[0];
        setStats(maxTimeIdx, 'stats-max-time');
        // const  maxTimeTime = maxTimeIndexAndValue[1];
        // const maxTimeSpeed = aerodynamicData.airspeeds.at(maxTimeIdx);
        // const maxTimeDist = aerodynamicData.flightDistances.at(maxTimeIdx);
        // console.log(`max time: ${maxTimeTime} minutes, max time speed: ${maxTimeSpeed}, distance: ${maxTimeDist}`);
        // max distance
        const listDist = List(aerodynamicData.flightDistances);
        const maxDistIndexAndValue = listDist.entrySeq().maxBy((v) => v[1]);
        console.log(`maxIndexAndValue: `, maxDistIndexAndValue);
        const maxDistIdx = maxDistIndexAndValue[0];
        setStats(maxDistIdx, 'stats-max-dist');
        const maybeStallSpeed = List(aerodynamicData.AoAs_not_stalled)
            .zip(aerodynamicData.airspeeds)
            .find((item) => item[0] !== undefined && item[0] != null);
        if (maybeStallSpeed) {
            setTxtById('stats-stall-speed', round2dec(maybeStallSpeed[1]) + ' km/h');
        }
        setTxtById('stats-auw', round2dec(airplane.auw_kg()) + ' kg');
        setTxtById('stats-max-speed', round2dec(maxAchievableAirspeed) + ' km/h');
        // setTxtById('stats-max-climb', airplane.auw_kg());
        setTxtById('stats-aspect-ratio', round2dec(airplane.airframeData.aspectRatio()) + '');
        setTxtById('stats-wingspan', round2dec(airplane.airframeData.wingSpan) + ' m');
        // <hr />
        //                             Optimal power: <span id="stats-max-dist-optimal-power">-</span><br />
        //                             Optimal thrust: <span id="stats-max-dist-optimal-thrust">-</span><br />
        //                             Optimal airspeed: <span id="stats-max-dist-optimal-speed">-</span><br />
        const batteryWeightPercent = round2dec(airplane.batteryData.weight_kg() / airplane.auw_kg() * 100);
        setTxtById('stats-energy-usable-wh', `${airplane.availableEnergyWhrs()}&nbsp;Wh`, true);
        setTxtById('stats-battery-percent-of-weight', `${batteryWeightPercent} %`);
        setTxtById('stats-battery-weight', `${round2dec(airplane.batteryData.weight_kg())} kg`);
    }
    getBoolField(formData, fName) {
        return formData.get(fName) == "1";
    }
    reportEmptyResult(msg) {
        const emptyAirfoil = {
            airfoilType: '',
            airfoilLink: '',
            nameHtml: msg,
            AirfoilCm: 0,
            AirfoilCm0: 0,
            AirfoilMaxLd: 0,
            Ld: 0,
            Alpha: 0,
            airfoilDescription: '',
            tldr: '',
            imageLinks: [],
            linksHtml: [],
        };
        const emptyResult = {
            link: "",
            info: "",
            airfoil: emptyAirfoil,
            outOfRange: false,
            aspectRatio: 1,
            chordMeters: 1,
            projectedPowerUsageW: 0,
            projectedFlightHours: 0,
            projectedFlightTimeMinutes: 0,
            projectedFlightDistKm: 0,
            projectedEfficiencyWhsPerKm: 0,
            airspeedKmh: 0,
            finalWingLD: 0,
            Cl: 0,
            Cd: 0,
            Re: 0,
            Cdi: 0,
            ApproxTotalDragNewtons: 0
        };
        const self = this;
        // FIXME: move this inside and a class function?
        function setTxtById(id, value, setHtml = false) {
            self.setTxtById_(id, value, setHtml);
        }
        this.reportAirfoilResult(emptyResult, setTxtById, 'finder-stats-max-dist-speed-');
        this.reportAirfoilResult(emptyResult, setTxtById, 'finder-stats-max-dist-');
    }
    computeCharts(formElement) {
        let { formData, airplane, maxSpeedToAnalyze } = this.loadForm(formElement);
        console.log(airplane);
        //this.loadCharts(formData, airplane, maxSpeedToAnalyze);
        const airframeData = airplane.airframeData;
        const self = this;
        function setTxtById(id, value, setHtml = false) {
            self.setTxtById_(id, value, setHtml);
        }
        // Usecase 1: Find better airfoil for same wing at given speed
        // keeping aspect ratio, weight, wing-area
        // FIXME: run this only if requested explicitly
        const desiredAirspeed = parseFloat(formData.get('desiredAirspeed'));
        const minAirspeed = parseFloat(formData.get('minAirspeed'));
        const extraZeroLiftDrag = parseFloat(formData.get('extraZeroLiftDrag'));
        setTxtById('stats-auw', round2dec(airplane.auw_kg()) + ' kg');
        const batteryWeightPercent = round2dec(airplane.batteryData.weight_kg() / airplane.auw_kg() * 100);
        setTxtById('stats-energy-usable-wh', `${airplane.availableEnergyWhrs()}&nbsp;Wh`, true);
        setTxtById('stats-battery-percent-of-weight', `${batteryWeightPercent} %`);
        setTxtById('stats-battery-weight', `${round2dec(airplane.batteryData.weight_kg())} kg`);
        const minAspectRatio = parseFloat(formData.get('minAspectRatio'));
        const maxAspectRatio = parseFloat(formData.get('maxAspectRatio'));
        const maxChordLength = parseFloat(formData.get('maxChordLength'));
        const minimumChordLength = parseFloat(formData.get('minChordLength'));
        const enabledAirfoilNames = formData.getAll('enabled-airfoils[]');
        console.log("enabledAirfoilNames:", enabledAirfoilNames);
        const checkOnlyMaxLDAlpha = this.getBoolField(formData, 'checkOnlyMaxLDAlpha');
        const planeTypes = {
            supportTail: this.getBoolField(formData, 'supportTail'),
            supportSweptWing: this.getBoolField(formData, 'supportSweptWing'),
            supportPlank: this.getBoolField(formData, 'supportPlank'),
            supportAerobatics: this.getBoolField(formData, 'supportAerobatics'),
            supportPlankDS: this.getBoolField(formData, 'supportPlankDS'),
        };
        const speeds = {
            min: minAirspeed,
            max: desiredAirspeed,
            increment: 1
        };
        const chords = {
            min: minimumChordLength,
            max: maxChordLength,
            increment: 0.01
        };
        const aspects = {
            min: minAspectRatio,
            max: maxAspectRatio,
            increment: 0.01
        };
        const enableNaca4Cfd = this.getBoolField(formData, 'enable-naca4-cfd');
        const enableNaca4Xfoil = this.getBoolField(formData, 'enable-naca4-xfoil');
        const useCFD = enableNaca4Cfd;
        console.log("useCFD:", useCFD);
        let bestDistanceKm = 0;
        let bestFlightMinutes = 0;
        let bestFlightDistanceResult = undefined;
        let bestFlightSpeedWithin15ProcDistanceResult = undefined;
        let bestFlightSpeedWithin15ProcDistanceResult_dist = 0;
        let bestFlightSpeedWithin15ProcDistanceResult_speed = 0;
        let bestFlightMinutesResult = undefined;
        let airfoils = [];
        let variantsScanned = 0;
        let variantsSucceeded = 0;
        function maybeAddResult(afResult) {
            if (!afResult.outOfRange) {
                variantsSucceeded += 1;
                let result = afResult;
                //if (variantsScanned < 10000) {
                // FIXME: this is a hack to avoid too many resulting in OOM, need a fancier datastructure? sorted limited length array? O(n long n) ?
                // airfoils.push(afResult);
                //}
                if (afResult.projectedFlightTimeMinutes > bestFlightMinutes) {
                    bestFlightMinutes = afResult.projectedFlightTimeMinutes;
                    bestFlightMinutesResult = result;
                }
                if (afResult.projectedFlightDistKm > bestDistanceKm) {
                    bestDistanceKm = afResult.projectedFlightDistKm;
                    bestFlightDistanceResult = result;
                }
                if (afResult.projectedFlightDistKm >= bestDistanceKm * 0.85) {
                    if ((afResult.airspeedKmh > bestFlightSpeedWithin15ProcDistanceResult_speed) ||
                        (afResult.airspeedKmh >= bestFlightSpeedWithin15ProcDistanceResult_speed && afResult.projectedFlightDistKm > bestFlightSpeedWithin15ProcDistanceResult_dist) ||
                        // or if current best result is not within 15% of best distance anymore, then we can replace it ignoring the speed
                        (bestFlightSpeedWithin15ProcDistanceResult_dist < bestDistanceKm * 0.85)) {
                        bestFlightSpeedWithin15ProcDistanceResult_speed = afResult.airspeedKmh;
                        bestFlightSpeedWithin15ProcDistanceResult_dist = afResult.projectedFlightDistKm;
                        bestFlightSpeedWithin15ProcDistanceResult = result;
                    }
                }
            }
        }
        if (enableNaca4Cfd || enableNaca4Xfoil) {
            for (let iterAirspeed = minAirspeed; iterAirspeed <= desiredAirspeed; iterAirspeed += 1) {
                var iterChordLength = minimumChordLength;
                while (iterChordLength <= maxChordLength) {
                    var iterAspectRatio = minAspectRatio;
                    while (iterAspectRatio <= maxAspectRatio) {
                        variantsScanned += 1;
                        let afResult = this.findBetterAirfoils(iterAspectRatio, iterChordLength, extraZeroLiftDrag, iterAirspeed, airplane.auw_kg(), "10C", airplane.environmentData, 
                        // FIXME
                        airframeData, airplane, useCFD);
                        maybeAddResult(afResult);
                        iterAspectRatio += 0.1;
                    }
                    iterChordLength += minimumChordLength;
                }
                iterAirspeed += 1;
            }
        }
        let airfoilsScanned = 0;
        enabledAirfoilNames.forEach((airfoilName) => {
            airfoilsScanned += 1;
            console.log(`airfoilsScanned: ${airfoilsScanned}, variantsScanned: ${variantsScanned}, next airfoilName: ${airfoilName}`);
            const airfoilSearcher = new SearchConstraints(checkOnlyMaxLDAlpha, [airfoilName], airplane.environmentData, planeTypes, airplane.auw_kg(), speeds, chords, aspects, {
                min: 5000,
                max: 5000000,
                increment: 0.1
            });
            const scanResults = airfoilSearcher.findMaxDistanceParams();
            variantsScanned += scanResults.variantsScanned;
            scanResults.results.forEach((r) => {
                const weightKg = airplane.auw_kg();
                const outOfRange = false;
                const wingArea = r.maxLdAspect * r.maxLdChord;
                const afResult = this.computeFlightParams(r.maxLdAspect, r.AirfoilCl, airframeData, r.dynamicPressure, wingArea, r.AirfoilCd, extraZeroLiftDrag, airplane, airplane.auw_kg() * airplane.environmentData.gravity, r.airspeedKmh, r.Re, "OK", r.maxLdChord, weightKg, r, outOfRange);
                maybeAddResult(afResult);
            });
        });
        //      let bestFlightMinutes = 0;
        //         let bestFlightDistanceResult = undefined;
        //         let bestFlightMinutesResult = undefined;
        console.log(`finished searching. bestDistanceKm: ${bestDistanceKm} `, bestFlightDistanceResult);
        console.log(`finished searching. bestFlightMinutes: ${bestFlightMinutes} `, bestFlightMinutesResult);
        if (bestFlightDistanceResult) {
            this.reportAirfoilResult(bestFlightDistanceResult, setTxtById, 'finder-stats-max-dist-');
            this.getById('airfoiler2_result').innerText = "";
            //`Here's one best result for max flight distance:\n` + bestFlightDistanceResult.info;
            //console.log("all airfoils:", airfoils);
            // FIXME: needs interface
            // const percentage = 15;
            // const fastestBestFewAirfoils = List(airfoils)
            //     .filter((a: AirfoilResult) =>
            //         a.projectedFlightDistKm >= bestDistanceKm*0.85
            //     ).sortBy((a: AirfoilResult) => -a.airspeedKmh)
            //     .toArray();
            // console.log("fastest airfoils within 15% of best distance:", fastestBestFewAirfoils);
            const bestDistSpeedResult = (bestFlightSpeedWithin15ProcDistanceResult !== undefined) ? bestFlightSpeedWithin15ProcDistanceResult : bestFlightDistanceResult;
            // FIXME: check if different
            this.reportAirfoilResult(bestDistSpeedResult, setTxtById, 'finder-stats-max-dist-speed-');
            // FIXME: Among these <b>${fastestBestFewAirfoils.length}</b> airfoils were within ${percentage}% of the max distance (but some potentially faster)
            // FIXME: finder-stats-max-dist-drag
        }
        else {
            this.getById('finder-stats-max-dist-airfoil-link').innerHTML = ``;
            this.getById('airfoiler2_result').innerText = "NO RESULT FOUND....";
            this.reportEmptyResult('NOTHING WAS FOUND.');
        }
        this.getById('airfoil-results-preamble').innerHTML =
            `<span class="text-muted"><br>Scanned <b>${variantsScanned}</b> variants of CL, Re (speed, chord, aspect, airfoil combinations),
                  and found some results for <b>${variantsSucceeded}</b> variants among them.
                 <br>the other variants were out of model limits or your requirements...
                 <br>
                 
                <br><br></span>`;
    }
    reportAirfoilResult(bestFlightDistanceResult, setTxtById_, prefix = 'finder-stats-max-dist-') {
        const { link: bestAirfoilLink, info: airfoilInfo2, airfoil: airfoil2, aspectRatio, chordMeters, projectedPowerUsageW, projectedFlightHours, projectedFlightDistKm, projectedFlightTimeMinutes, projectedEfficiencyWhsPerKm, airspeedKmh, finalWingLD, Cl, Cd, Cdi, Re } = bestFlightDistanceResult;
        console.log(`bestFlightDistanceResult`, bestFlightDistanceResult);
        const a = airfoil2;
        const nacaLink = (bestAirfoilLink) ? `<a href="${bestAirfoilLink}" target="_blank"><b>airfoil drawing and DAT file</b></a>` : '';
        // (useCFD) ? `<br> Paste Re & CL into <a href="https://aeroptimal.com/airfoil" target="_blank">https://aeroptimal.com/airfoil</a> to get correct airfoil.<br /> ${nacaLink}` :
        const maybeNacaLinkOrDescription = nacaLink;
        const airfoilStr = `${airfoil2.nameHtml}<br><b>CL</b>=${Cl},<br/><b>Re</b>=${round2dec(Re)}`;
        var printPlane = '';
        const airfoilCoordinates = {
            "JWL-065": [[1.0, 0.0], [0.99726, 7e-05], [0.98907, 0.00039], [0.97553, 0.00115], [0.95677, 0.00251], [0.93301, 0.00451], [0.90451, 0.00705], [0.87157, 0.01001], [0.83456, 0.01337], [0.79389, 0.01697], [0.74999, 0.0208], [0.70336, 0.02501], [0.6545, 0.02929], [0.60395, 0.0336], [0.55225, 0.03802], [0.49999, 0.0424], [0.44773, 0.04666], [0.39604, 0.05049], [0.34549, 0.05361], [0.29663, 0.05574], [0.25, 0.05658], [0.20611, 0.05605], [0.16544, 0.05418], [0.12844, 0.0509], [0.0955, 0.0463], [0.067, 0.04051], [0.04324, 0.03375], [0.02448, 0.02612], [0.01094, 0.0173], [0.00275, 0.00811], [0.0, -0.00013], [0.00273, -0.00321], [0.01092, -0.00707], [0.02446, -0.01064], [0.04321, -0.01364], [0.06697, -0.01615], [0.09548, -0.01813], [0.12841, -0.01983], [0.16542, -0.0212], [0.2061, -0.0223], [0.24999, -0.02302], [0.29663, -0.02348], [0.34549, -0.02364], [0.39605, -0.02339], [0.44774, -0.02289], [0.50001, -0.02214], [0.55227, -0.02104], [0.60396, -0.01988], [0.65452, -0.01862], [0.70338, -0.01734], [0.75001, -0.01603], [0.7939, -0.01457], [0.83457, -0.01319], [0.87158, -0.01203], [0.90451, -0.01088], [0.93302, -0.00942], [0.95677, -0.00753], [0.97553, -0.00524], [0.98908, -0.00275], [0.99726, -0.00075], [1.0, 0.0],],
            "HS-145": [[1.0, 0.0], [0.990242, 4.1e-05], [0.971003, 0.000544], [0.948797, 0.0016328], [0.926705, 0.0030917], [0.904005, 0.0048783], [0.880848, 0.0069346], [0.857657, 0.0091795], [0.834353, 0.0115829], [0.810921, 0.0141168], [0.787439, 0.0167469], [0.76389, 0.0194518], [0.740266, 0.0222111], [0.71661, 0.0249998], [0.692963, 0.027794], [0.669348, 0.0305731], [0.645771, 0.0333198], [0.622234, 0.0360181], [0.598735, 0.0386531], [0.57527, 0.0412106], [0.551831, 0.043677], [0.528398, 0.0460398], [0.504978, 0.0482835], [0.481604, 0.0503903], [0.458249, 0.0523481], [0.434875, 0.0541446], [0.4115, 0.0557619], [0.388174, 0.0571796], [0.364934, 0.0583787], [0.341779, 0.0593422], [0.318689, 0.0600524], [0.295662, 0.0604886], [0.272709, 0.0606272], [0.249851, 0.0604417], [0.227119, 0.0599022], [0.204554, 0.0589745], [0.182198, 0.057618], [0.16009, 0.055783], [0.138271, 0.053409], [0.116825, 0.050429], [0.095976, 0.046788], [0.076116, 0.042468], [0.057432, 0.037391], [0.04052, 0.03158], [0.027, 0.025672], [0.017337, 0.020303], [0.010778, 0.015699], [0.006358, 0.011757], [0.003409, 0.008318], [0.001508, 0.005278], [0.000401, 0.002545], [0.0, 0.0], [0.000419, -0.002216], [0.002039, -0.004343], [0.004762, -0.006198], [0.008598, -0.007864], [0.013955, -0.009485], [0.021844, -0.011201], [0.034132, -0.013131], [0.052002, -0.015153], [0.073596, -0.016936], [0.09661, -0.01837], [0.120062, -0.019505], [0.143687, -0.0204128], [0.16742, -0.0211449], [0.191203, -0.0217319], [0.215019, -0.0221971], [0.238865, -0.0225592], [0.262735, -0.0228324], [0.28662, -0.0230278], [0.310506, -0.0231538], [0.334389, -0.0232169], [0.358259, -0.0232222], [0.382117, -0.0231736], [0.405968, -0.023074], [0.429808, -0.0229254], [0.453637, -0.0227293], [0.477455, -0.0224868], [0.501265, -0.0221987], [0.525066, -0.0218654], [0.548861, -0.0214868], [0.572643, -0.0210623], [0.596413, -0.0205907], [0.62017, -0.0200705], [0.643919, -0.0195], [0.667654, -0.0188775], [0.691368, -0.0182011], [0.71506, -0.0174682], [0.738731, -0.0166749], [0.762372, -0.0158157], [0.785964, -0.014883], [0.809515, -0.0138663], [0.833007, -0.0127552], [0.856384, -0.0115403], [0.879675, -0.0102067], [0.902947, -0.0087324], [0.925762, -0.0071142], [0.94803, -0.0053211], [0.970684, -0.0032262], [0.990261, -0.001128], [1.0, 0.0],],
            "HS-147": [[1.0, 0.0], [0.990258, 0.000189], [0.971057, 0.000887], [0.948893, 0.002059], [0.92684, 0.0034953], [0.904174, 0.0051801], [0.881045, 0.0070689], [0.857879, 0.0090945], [0.834595, 0.0112332], [0.811179, 0.0134621], [0.787709, 0.0157533], [0.764168, 0.0180909], [0.740551, 0.020461], [0.716898, 0.0228475], [0.693254, 0.0252342], [0.669644, 0.0276069], [0.64607, 0.0299538], [0.622537, 0.0322627], [0.599044, 0.0345221], [0.575586, 0.036721], [0.552156, 0.0388484], [0.528735, 0.040894], [0.505328, 0.042845], [0.48197, 0.0446861], [0.458633, 0.0464068], [0.435279, 0.0479962], [0.411926, 0.049438], [0.388625, 0.0507132], [0.365409, 0.0518041], [0.342281, 0.0526943], [0.319218, 0.0533675], [0.296218, 0.0538051], [0.273292, 0.0539862], [0.25046, 0.0538865], [0.227753, 0.0534758], [0.20521, 0.0527182], [0.182873, 0.051573], [0.160782, 0.049993], [0.138974, 0.047921], [0.117533, 0.045291], [0.096686, 0.042053], [0.076816, 0.038191], [0.058116, 0.03363], [0.041173, 0.028396], [0.027608, 0.023072], [0.017875, 0.018253], [0.011232, 0.014134], [0.006719, 0.010613], [0.003665, 0.007526], [0.001659, 0.004791], [0.000463, 0.00233], [0.0, 0.0], [0.000471, -0.001891], [0.002029, -0.00374], [0.004667, -0.005431], [0.008385, -0.007001], [0.013624, -0.008625], [0.02139, -0.010453], [0.033561, -0.012631], [0.051346, -0.015036], [0.072896, -0.017269], [0.095901, -0.019147], [0.119363, -0.020697], [0.143006, -0.021981], [0.166764, -0.023043], [0.190576, -0.0239102], [0.214423, -0.0246066], [0.2383, -0.0251529], [0.262202, -0.0255659], [0.28612, -0.0258592], [0.310036, -0.0260439], [0.333947, -0.0261289], [0.357842, -0.0261214], [0.381725, -0.0260274], [0.405601, -0.0258517], [0.429465, -0.0255984], [0.453315, -0.0252713], [0.477154, -0.0248731], [0.500981, -0.024406], [0.524799, -0.023872], [0.54861, -0.023273], [0.572406, -0.0226105], [0.596189, -0.0218853], [0.619954, -0.0210982], [0.643711, -0.0202493], [0.667454, -0.0193391], [0.691172, -0.0183683], [0.714869, -0.017337], [0.738544, -0.0162455], [0.762188, -0.0150946], [0.785782, -0.0138856], [0.809335, -0.0126185], [0.832828, -0.0112948], [0.856207, -0.0099182], [0.879501, -0.0084879], [0.902784, -0.0069999], [0.925615, -0.0054836], [0.947908, -0.0039483], [0.970601, -0.00232], [0.99023, -0.0007952], [1.0, 0.0],],
            "HS-132": [[1.0, 0.0], [0.99726, 7e-05], [0.98907, 0.00028], [0.97553, 0.00087], [0.95677, 0.00204], [0.93301, 0.00397], [0.90451, 0.00683], [0.87157, 0.01071], [0.83457, 0.01554], [0.79389, 0.02117], [0.75, 0.02744], [0.70337, 0.03405], [0.65451, 0.04073], [0.60396, 0.04714], [0.55226, 0.05304], [0.5, 0.0581], [0.44774, 0.06214], [0.39604, 0.06501], [0.34549, 0.0666], [0.29663, 0.06681], [0.25, 0.06564], [0.20611, 0.0631], [0.16543, 0.05923], [0.12843, 0.05417], [0.09549, 0.048], [0.06699, 0.04085], [0.04323, 0.03296], [0.02447, 0.02453], [0.01093, 0.01571], [0.00274, 0.00731], [0.0, 0.0], [0.00274, -0.00383], [0.01093, -0.00798], [0.02447, -0.01178], [0.04323, -0.01494], [0.06699, -0.01744], [0.09549, -0.01934], [0.12843, -0.02074], [0.16543, -0.02175], [0.20611, -0.02243], [0.25, -0.02283], [0.29663, -0.02294], [0.34549, -0.02282], [0.39604, -0.02262], [0.44774, -0.02244], [0.5, -0.02222], [0.55226, -0.02185], [0.60396, -0.02127], [0.65451, -0.02043], [0.70337, -0.01931], [0.75, -0.01793], [0.79389, -0.01633], [0.83457, -0.01449], [0.87157, -0.01245], [0.90451, -0.01023], [0.93301, -0.00786], [0.95677, -0.00551], [0.97553, -0.00335], [0.98907, -0.00158], [0.99726, -0.00041], [1.0, 0.0],],
            "HS-160": [[1.0, 0.0], [0.98967, -0.000404], [0.970166, -0.000609], [0.948167, -0.000118], [0.92426, 0.001066], [0.899973, 0.002842], [0.875609, 0.005144], [0.851029, 0.007949], [0.826402, 0.01119], [0.801795, 0.014796], [0.777151, 0.018705], [0.752444, 0.022871], [0.727656, 0.027265], [0.702765, 0.031862], [0.677821, 0.036588], [0.652823, 0.041363], [0.627833, 0.046105], [0.602906, 0.050751], [0.578063, 0.055247], [0.553314, 0.059556], [0.528651, 0.063647], [0.504066, 0.067492], [0.479559, 0.071064], [0.455136, 0.074336], [0.4308, 0.077284], [0.406551, 0.079883], [0.38239, 0.082104], [0.358334, 0.083922], [0.334384, 0.085306], [0.310558, 0.08623], [0.286872, 0.086662], [0.263355, 0.086565], [0.240034, 0.085905], [0.216961, 0.084647], [0.194188, 0.082749], [0.17177, 0.080167], [0.149782, 0.076847], [0.128343, 0.072736], [0.10743, 0.067737], [0.087558, 0.061898], [0.069038, 0.055276], [0.052371, 0.048071], [0.038174, 0.040671], [0.02688, 0.03358], [0.018562, 0.02732], [0.012348, 0.02173], [0.007422, 0.016346], [0.004009, 0.011658], [0.00179, 0.007588], [0.000377, 0.003407], [3e-06, 0.000294], [0.000233, -0.002388], [0.001626, -0.005884], [0.002928, -0.007773], [0.004907, -0.009858], [0.007893, -0.012055], [0.011686, -0.014137], [0.016767, -0.016273], [0.02363, -0.018462], [0.033232, -0.020806], [0.046725, -0.023292], [0.064545, -0.025707], [0.086065, -0.027949], [0.109654, -0.029917], [0.13414, -0.031597], [0.159022, -0.033035], [0.184086, -0.034277], [0.209229, -0.03535], [0.234402, -0.036277], [0.259592, -0.037075], [0.284767, -0.037755], [0.309924, -0.038322], [0.335073, -0.038781], [0.36022, -0.039137], [0.385377, -0.039386], [0.410548, -0.039532], [0.435718, -0.039573], [0.460901, -0.039509], [0.486103, -0.039336], [0.511308, -0.039053], [0.536494, -0.038658], [0.561667, -0.038147], [0.586817, -0.037518], [0.611956, -0.036765], [0.637083, -0.035888], [0.662181, -0.03488], [0.687248, -0.033735], [0.712277, -0.032448], [0.737248, -0.031009], [0.762178, -0.029402], [0.787042, -0.027617], [0.811828, -0.025639], [0.836488, -0.023455], [0.86103, -0.021048], [0.885354, -0.018398], [0.909527, -0.015452], [0.933057, -0.012226], [0.954383, -0.008909], [0.973235, -0.005517], [0.990287, -0.001989], [1.0, 0.0],],
            "HS-164": [[1.0, 0.0], [0.988944, 3e-06], [0.970907, 0.000368], [0.950823, 0.001241], [0.928413, 0.002688], [0.90359, 0.004776], [0.876735, 0.007536], [0.84872, 0.010902], [0.820416, 0.014763], [0.792228, 0.018981], [0.764064, 0.023509], [0.735704, 0.028325], [0.707003, 0.033406], [0.677887, 0.038706], [0.64836, 0.044151], [0.61851, 0.049635], [0.588512, 0.055029], [0.558609, 0.060203], [0.52903, 0.06503], [0.499972, 0.069413], [0.471571, 0.073285], [0.443876, 0.076613], [0.416823, 0.079385], [0.390276, 0.081611], [0.364093, 0.083294], [0.338227, 0.084428], [0.312713, 0.085001], [0.287665, 0.085006], [0.263186, 0.08444], [0.239249, 0.083304], [0.215758, 0.081584], [0.192738, 0.079263], [0.170321, 0.076338], [0.148653, 0.07281], [0.12791, 0.068702], [0.108505, 0.064114], [0.090963, 0.059237], [0.075582, 0.05428], [0.062327, 0.049387], [0.051025, 0.04465], [0.041466, 0.040136], [0.033449, 0.035887], [0.026748, 0.031907], [0.021126, 0.028162], [0.016353, 0.024583], [0.01227, 0.021098], [0.008826, 0.017699], [0.006009, 0.014417], [0.0038, 0.01127], [0.002152, 0.008279], [0.000985, 0.005462], [0.000274, 0.002814], [0.0, 0.0], [0.000204, -0.002189], [0.001023, -0.004547], [0.002638, -0.006754], [0.005069, -0.008818], [0.008287, -0.010788], [0.012241, -0.012681], [0.016789, -0.014462], [0.021903, -0.016148], [0.027756, -0.017806], [0.034617, -0.0195], [0.042793, -0.021266], [0.052666, -0.023125], [0.064592, -0.025076], [0.078937, -0.027096], [0.096312, -0.029184], [0.117227, -0.031302], [0.14104, -0.033315], [0.166565, -0.035101], [0.193393, -0.036649], [0.221228, -0.037953], [0.249671, -0.039015], [0.278504, -0.039843], [0.307653, -0.040447], [0.337027, -0.04081], [0.366542, -0.040945], [0.39614, -0.040867], [0.425792, -0.040587], [0.455485, -0.040116], [0.485197, -0.039466], [0.514903, -0.038645], [0.544575, -0.037662], [0.574225, -0.036523], [0.603901, -0.035231], [0.633685, -0.033783], [0.663617, -0.032173], [0.693613, -0.030399], [0.723475, -0.028466], [0.753035, -0.02637], [0.782346, -0.024101], [0.8117, -0.021628], [0.841467, -0.018908], [0.871409, -0.015936], [0.900369, -0.01278], [0.926918, -0.009601], [0.950391, -0.006591], [0.970947, -0.003814], [0.989054, -0.001397], [1.0, 0.0],],
            "HS-190": [[1.0, 0.0], [0.988764, 0.000374], [0.968013, 0.001626], [0.946494, 0.003384], [0.924634, 0.005477], [0.902565, 0.00779], [0.88041, 0.01024], [0.858309, 0.012754], [0.836171, 0.015329], [0.814028, 0.017946], [0.791835, 0.020626], [0.769604, 0.023352], [0.747326, 0.026111], [0.725016, 0.028892], [0.702651, 0.031674], [0.680257, 0.034447], [0.65786, 0.037191], [0.635469, 0.039894], [0.6131, 0.042537], [0.590761, 0.04511], [0.568463, 0.047595], [0.546163, 0.049986], [0.523843, 0.052272], [0.501502, 0.054437], [0.479169, 0.056466], [0.456838, 0.058346], [0.434514, 0.060063], [0.412188, 0.0616], [0.389874, 0.062941], [0.367565, 0.064071], [0.345273, 0.06497], [0.323, 0.065617], [0.300757, 0.065992], [0.278553, 0.06607], [0.256397, 0.06582], [0.234304, 0.065216], [0.212288, 0.06422], [0.190367, 0.06279], [0.168572, 0.060878], [0.146934, 0.058424], [0.1255, 0.055352], [0.104379, 0.051558], [0.08374, 0.046901], [0.063768, 0.041186], [0.044755, 0.034223], [0.027311, 0.025903], [0.01309, 0.016721], [0.005058, 0.009381], [0.001602, 0.004701], [0.000532, 0.002452], [0.000224, 0.00149], [4.2e-05, 0.000611], [6e-06, -0.000218], [0.000141, -0.001032], [0.000472, -0.001854], [0.001017, -0.002657], [0.001792, -0.003401], [0.002813, -0.004055], [0.005657, -0.005159], [0.013323, -0.006455], [0.029177, -0.007024], [0.050851, -0.006933], [0.073282, -0.006798], [0.095642, -0.006808], [0.11798, -0.007006], [0.140322, -0.007399], [0.162684, -0.00797], [0.185077, -0.008698], [0.207499, -0.009556], [0.229961, -0.010513], [0.252461, -0.011533], [0.274996, -0.012584], [0.29753, -0.013629], [0.320031, -0.014639], [0.342518, -0.015597], [0.364996, -0.016487], [0.387469, -0.017304], [0.409951, -0.018051], [0.432432, -0.018723], [0.454911, -0.01932], [0.477408, -0.019854], [0.499929, -0.020335], [0.522438, -0.020765], [0.544935, -0.021136], [0.567434, -0.021444], [0.589921, -0.021677], [0.612412, -0.021839], [0.634887, -0.021922], [0.657365, -0.021926], [0.67983, -0.021837], [0.702277, -0.02165], [0.724706, -0.021351], [0.747114, -0.02092], [0.769505, -0.020354], [0.791884, -0.019636], [0.81423, -0.018757], [0.836541, -0.017696], [0.858795, -0.016429], [0.88098, -0.014906], [0.903111, -0.01311], [0.925163, -0.010998], [0.946973, -0.008517], [0.968523, -0.005491], [0.989373, -0.00193], [1.0, 0.0],],
            "HS-130": [[1.0, 0.0], [0.99726, 7e-05], [0.98907, 0.00028], [0.97553, 0.00087], [0.95677, 0.00204], [0.93301, 0.00397], [0.90451, 0.00683], [0.87157, 0.01071], [0.83457, 0.01554], [0.79389, 0.02117], [0.75, 0.02744], [0.70337, 0.03405], [0.65451, 0.04073], [0.60396, 0.04714], [0.55226, 0.05304], [0.5, 0.0581], [0.44774, 0.06214], [0.39604, 0.06501], [0.34549, 0.0666], [0.29663, 0.06681], [0.25, 0.06564], [0.20611, 0.0631], [0.16543, 0.05923], [0.12843, 0.05417], [0.09549, 0.048], [0.06699, 0.04085], [0.04323, 0.03296], [0.02447, 0.02453], [0.01093, 0.01571], [0.00274, 0.00731], [0.0, 0.0], [0.00274, -0.00383], [0.01093, -0.00798], [0.02447, -0.01178], [0.04323, -0.01494], [0.06699, -0.01744], [0.09549, -0.01934], [0.12843, -0.02074], [0.16543, -0.02175], [0.20611, -0.02243], [0.25, -0.02283], [0.29663, -0.02294], [0.34549, -0.02282], [0.39604, -0.02262], [0.44774, -0.02244], [0.5, -0.02222], [0.55226, -0.02185], [0.60396, -0.02127], [0.65451, -0.02043], [0.70337, -0.01931], [0.75, -0.01793], [0.79389, -0.01633], [0.83457, -0.01449], [0.87157, -0.01245], [0.90451, -0.01023], [0.93301, -0.00786], [0.95677, -0.00551], [0.97553, -0.00335], [0.98907, -0.00158], [0.99726, -0.00041], [1.0, 0.0]],
            "MH60": [[1.0, 0.0], [0.996666, -0.000107], [0.986577, -0.000219], [0.969853, 0.000169], [0.94694, 0.001391], [0.918316, 0.003616], [0.88457, 0.007018], [0.846466, 0.011623], [0.804763, 0.01727], [0.760174, 0.023726], [0.713396, 0.030703], [0.665094, 0.037837], [0.615805, 0.044701], [0.565929, 0.050966], [0.515852, 0.056401], [0.465938, 0.060872], [0.416608, 0.064333], [0.368338, 0.066742], [0.321598, 0.068047], [0.276851, 0.068198], [0.234505, 0.067124], [0.194898, 0.064808], [0.158343, 0.061275], [0.125116, 0.056592], [0.095472, 0.050858], [0.069632, 0.044191], [0.04776, 0.036712], [0.029911, 0.028619], [0.016145, 0.020225], [0.006504, 0.011925], [0.001559, 0.005201], [0.000633, 0.003074], [0.000109, 0.001113], [1e-06, -7.7e-05], [0.000143, -0.001126], [0.000618, -0.002106], [0.001411, -0.00311], [0.003066, -0.004655], [0.005226, -0.006237], [0.006291, -0.006921], [0.017554, -0.012182], [0.033826, -0.017213], [0.054852, -0.021792], [0.080412, -0.025735], [0.110306, -0.028876], [0.144357, -0.031128], [0.182321, -0.032488], [0.223913, -0.032996], [0.268755, -0.032759], [0.316389, -0.03187], [0.366319, -0.030431], [0.418015, -0.02855], [0.470897, -0.026361], [0.52434, -0.023973], [0.577702, -0.021494], [0.630326, -0.018997], [0.681565, -0.01655], [0.730789, -0.014193], [0.777396, -0.011968], [0.820818, -0.009897], [0.860517, -0.008015], [0.89599, -0.006323], [0.92679, -0.004824], [0.95253, -0.003493], [0.972885, -0.002309], [0.987658, -0.001203], [0.996818, -0.000326], [1.0, 0.0],],
            "MH61": [[1.0, 0.0], [0.996626, -0.000213], [0.986344, -0.000589], [0.969245, -0.000474], [0.945857, 0.000563], [0.916735, 0.002695], [0.882514, 0.006093], [0.84399, 0.010774], [0.801955, 0.016569], [0.75716, 0.023227], [0.710331, 0.030426], [0.662153, 0.037752], [0.613145, 0.044713], [0.563649, 0.050954], [0.514021, 0.056257], [0.46462, 0.060476], [0.415832, 0.063541], [0.368069, 0.065408], [0.321752, 0.066063], [0.27731, 0.065497], [0.235135, 0.063698], [0.195576, 0.060686], [0.158939, 0.056513], [0.125479, 0.051292], [0.095462, 0.045209], [0.069171, 0.03845], [0.046848, 0.031193], [0.028686, 0.023639], [0.014832, 0.016037], [0.005401, 0.00872], [0.002247, 0.00513], [0.001043, 0.003236], [0.000275, 0.001482], [2.4e-05, 0.000415], [4.5e-05, -0.000526], [0.000409, -0.001417], [0.001095, -0.002352], [0.002591, -0.003811], [0.004595, -0.005329], [0.008681, -0.007813], [0.021087, -0.013143], [0.038379, -0.01834], [0.060302, -0.023189], [0.086639, -0.027487], [0.117167, -0.031066], [0.151679, -0.033816], [0.189909, -0.035698], [0.231553, -0.036699], [0.27626, -0.036858], [0.323637, -0.036243], [0.373228, -0.03497], [0.424524, -0.033162], [0.476956, -0.030964], [0.52991, -0.028494], [0.582751, -0.025864], [0.634833, -0.023156], [0.685519, -0.020441], [0.73419, -0.017769], [0.780252, -0.015185], [0.82315, -0.012725], [0.862353, -0.010429], [0.897369, -0.008312], [0.92776, -0.006386], [0.953146, -0.00464], [0.973208, -0.003065], [0.987765, -0.001598], [0.996829, -0.000437], [1.0, 0.0],],
            "PW1211-PW": [[1.0, 0.00024], [0.99644, 8e-05], [0.99011, -0.0001], [0.98279, -0.00021], [0.97494, -0.00024], [0.96687, -0.00017], [0.9587, 2e-05], [0.95043, 0.0003], [0.94209, 0.00066], [0.93371, 0.00109], [0.92529, 0.00158], [0.91682, 0.00211], [0.90832, 0.00268], [0.89982, 0.00329], [0.89129, 0.00392], [0.88275, 0.00459], [0.87419, 0.00527], [0.86564, 0.00597], [0.8571, 0.0067], [0.84856, 0.00744], [0.84, 0.00821], [0.83142, 0.009], [0.82284, 0.00979], [0.81425, 0.0106], [0.80567, 0.01142], [0.79709, 0.01225], [0.78848, 0.01309], [0.77987, 0.01393], [0.77125, 0.01478], [0.76265, 0.01563], [0.75406, 0.01648], [0.74547, 0.01734], [0.73686, 0.01822], [0.72825, 0.01909], [0.71963, 0.01996], [0.71101, 0.02083], [0.7024, 0.0217], [0.69379, 0.02258], [0.68517, 0.02345], [0.67657, 0.02432], [0.66796, 0.02519], [0.65936, 0.02605], [0.65075, 0.0269], [0.64216, 0.02775], [0.63357, 0.02859], [0.62499, 0.02941], [0.6164, 0.03023], [0.6078, 0.03104], [0.59921, 0.03184], [0.59061, 0.03263], [0.58202, 0.03342], [0.57341, 0.03419], [0.56481, 0.03496], [0.55622, 0.03572], [0.54764, 0.03647], [0.53907, 0.0372], [0.53048, 0.03792], [0.52189, 0.03863], [0.51329, 0.03933], [0.50469, 0.04002], [0.4961, 0.04069], [0.48752, 0.04136], [0.47893, 0.04201], [0.47035, 0.04264], [0.46178, 0.04326], [0.45321, 0.04386], [0.44466, 0.04444], [0.43609, 0.045], [0.42752, 0.04554], [0.41895, 0.04606], [0.41038, 0.04656], [0.40181, 0.04705], [0.39324, 0.04751], [0.38467, 0.04795], [0.3761, 0.04838], [0.36755, 0.04878], [0.359, 0.04915], [0.35046, 0.0495], [0.3419, 0.04982], [0.33335, 0.05011], [0.3248, 0.05038], [0.31627, 0.05062], [0.30773, 0.05083], [0.29918, 0.05101], [0.29064, 0.05117], [0.28211, 0.0513], [0.27361, 0.05139], [0.26512, 0.05144], [0.25661, 0.05145], [0.2481, 0.05142], [0.23961, 0.05136], [0.23114, 0.05126], [0.22267, 0.0511], [0.21419, 0.05091], [0.20572, 0.05067], [0.1973, 0.05039], [0.18892, 0.05005], [0.18052, 0.04964], [0.17213, 0.04917], [0.16377, 0.04865], [0.15547, 0.04806], [0.14717, 0.04739], [0.13887, 0.04665], [0.13064, 0.04583], [0.12247, 0.04492], [0.1143, 0.04392], [0.10617, 0.04282], [0.09813, 0.04163], [0.09017, 0.04032], [0.08227, 0.03889], [0.07449, 0.03735], [0.06684, 0.03566], [0.0593, 0.03381], [0.05196, 0.03182], [0.04483, 0.02966], [0.03798, 0.02735], [0.03156, 0.02491], [0.02563, 0.02235], [0.02038, 0.01981], [0.01594, 0.01738], [0.01233, 0.01513], [0.00947, 0.01306], [0.0072, 0.01118], [0.0054, 0.00951], [0.00397, 0.00799], [0.00287, 0.00658], [0.00203, 0.00526], [0.00136, 0.00404], [0.00082, 0.00292], [0.0004, 0.00189], [0.00011, 0.00092], [0.0, 0.0], [9e-05, -0.00092], [0.00039, -0.00184], [0.00089, -0.00277], [0.00158, -0.00368], [0.00247, -0.00456], [0.0036, -0.00535], [0.005, -0.00607], [0.00671, -0.00674], [0.00879, -0.00744], [0.01136, -0.00819], [0.01461, -0.009], [0.01879, -0.00988], [0.02405, -0.01088], [0.03032, -0.01189], [0.03746, -0.01285], [0.04507, -0.01373], [0.053, -0.01448], [0.06117, -0.01517], [0.06935, -0.01578], [0.07764, -0.01627], [0.08605, -0.01672], [0.09443, -0.01713], [0.10284, -0.01745], [0.11133, -0.01773], [0.11984, -0.01799], [0.12831, -0.0182], [0.13681, -0.01836], [0.14538, -0.0185], [0.15396, -0.01862], [0.1625, -0.01871], [0.17105, -0.01877], [0.17965, -0.01881], [0.18825, -0.01884], [0.19684, -0.01885], [0.20542, -0.01884], [0.21403, -0.0188], [0.22267, -0.01876], [0.2313, -0.01872], [0.23991, -0.01867], [0.24852, -0.0186], [0.25716, -0.01852], [0.2658, -0.01843], [0.27445, -0.01835], [0.28307, -0.01825], [0.2917, -0.01815], [0.30034, -0.01803], [0.30899, -0.01791], [0.31764, -0.0178], [0.32629, -0.01768], [0.33493, -0.01755], [0.34358, -0.01742], [0.35223, -0.01729], [0.36089, -0.01715], [0.36954, -0.01701], [0.37819, -0.01687], [0.38684, -0.01672], [0.39549, -0.01657], [0.40415, -0.01642], [0.41281, -0.01627], [0.42146, -0.01613], [0.43011, -0.01597], [0.43876, -0.01581], [0.44741, -0.01566], [0.45606, -0.0155], [0.46471, -0.01535], [0.47336, -0.01519], [0.482, -0.01503], [0.49065, -0.01487], [0.4993, -0.0147], [0.50795, -0.01454], [0.5166, -0.01437], [0.52525, -0.01421], [0.53389, -0.01404], [0.54254, -0.01387], [0.55119, -0.01369], [0.55984, -0.01352], [0.56849, -0.01335], [0.57714, -0.01318], [0.58579, -0.013], [0.59444, -0.01282], [0.60309, -0.01264], [0.61174, -0.01247], [0.6204, -0.01229], [0.62904, -0.01211], [0.63769, -0.01193], [0.64634, -0.01174], [0.65499, -0.01155], [0.66366, -0.01136], [0.67231, -0.01116], [0.68097, -0.01097], [0.68962, -0.01077], [0.69828, -0.01057], [0.70694, -0.01037], [0.71559, -0.01017], [0.72425, -0.00996], [0.7329, -0.00974], [0.74156, -0.00953], [0.75022, -0.00932], [0.75887, -0.0091], [0.76751, -0.00888], [0.77616, -0.00865], [0.78481, -0.00842], [0.79346, -0.00818], [0.80211, -0.00794], [0.81076, -0.0077], [0.81941, -0.00745], [0.82806, -0.0072], [0.83671, -0.00694], [0.84535, -0.00669], [0.85399, -0.00642], [0.86264, -0.00615], [0.87128, -0.00587], [0.87993, -0.0056], [0.88857, -0.00531], [0.8972, -0.00503], [0.90582, -0.00473], [0.91444, -0.00442], [0.92305, -0.0041], [0.93165, -0.00377], [0.94025, -0.00342], [0.94882, -0.00307], [0.95732, -0.00269], [0.96576, -0.00227], [0.97411, -0.00182], [0.98225, -0.00132], [0.98987, -0.00084], [0.99641, -0.00045], [1.0, -0.00024],],
            "PW75-PW": [[1.0, 0.00047], [0.99655, 0.00046], [0.98638, 0.00068], [0.96991, 0.0014], [0.94761, 0.00273], [0.91998, 0.0047], [0.88752, 0.00734], [0.85073, 0.01064], [0.81018, 0.01456], [0.7664, 0.01905], [0.71996, 0.02404], [0.67144, 0.02927], [0.62141, 0.03458], [0.57048, 0.03979], [0.5192, 0.04475], [0.46812, 0.04925], [0.41776, 0.0531], [0.3686, 0.05614], [0.32105, 0.05823], [0.27556, 0.05925], [0.23256, 0.05911], [0.19244, 0.05774], [0.1555, 0.0551], [0.122, 0.0512], [0.0922, 0.04613], [0.0663, 0.04002], [0.04448, 0.03302], [0.02687, 0.02538], [0.01357, 0.01744], [0.00472, 0.00958], [0.00042, 0.00171], [3e-05, 0.00017], [0.0, 0.0], [6e-05, -0.00021], [0.00025, -0.00085], [0.00056, -0.00179], [0.001, -0.00293], [0.00156, -0.00402], [0.00224, -0.00486], [0.00305, -0.00549], [0.00398, -0.00617], [0.00504, -0.00692], [0.00622, -0.00765], [0.00752, -0.00835], [0.00895, -0.00904], [0.01049, -0.00974], [0.01216, -0.01045], [0.01395, -0.01112], [0.01587, -0.01179], [0.0179, -0.01245], [0.02005, -0.0131], [0.02233, -0.01374], [0.02472, -0.01437], [0.02723, -0.01499], [0.02985, -0.01559], [0.0326, -0.01619], [0.03546, -0.01677], [0.03844, -0.01734], [0.04153, -0.0179], [0.04474, -0.01844], [0.04806, -0.01897], [0.05149, -0.01948], [0.05504, -0.01998], [0.05869, -0.02046], [0.06246, -0.02094], [0.06633, -0.02139], [0.07031, -0.02183], [0.0744, -0.02227], [0.0786, -0.02268], [0.0829, -0.02309], [0.08731, -0.02348], [0.09181, -0.02386], [0.09642, -0.02422], [0.10113, -0.02457], [0.10594, -0.0249], [0.11085, -0.02523], [0.11585, -0.02554], [0.12095, -0.02584], [0.12615, -0.02613], [0.13144, -0.02639], [0.13682, -0.02664], [0.14229, -0.0269], [0.14785, -0.02714], [0.15349, -0.02737], [0.15922, -0.02758], [0.16504, -0.02779], [0.17095, -0.02797], [0.18299, -0.02834], [0.19536, -0.02865], [0.20803, -0.02892], [0.22099, -0.02916], [0.23422, -0.02937], [0.24772, -0.02952], [0.26148, -0.02964], [0.27547, -0.02973], [0.28969, -0.02978], [0.30411, -0.02981], [0.31873, -0.02979], [0.33353, -0.02975], [0.3485, -0.02968], [0.36361, -0.02958], [0.37887, -0.02945], [0.39424, -0.02928], [0.40972, -0.02909], [0.42529, -0.02886], [0.44094, -0.02861], [0.45664, -0.02832], [0.47239, -0.02802], [0.48816, -0.02768], [0.50395, -0.02731], [0.51973, -0.02691], [0.53549, -0.0265], [0.55122, -0.02605], [0.56689, -0.02558], [0.5825, -0.02507], [0.59803, -0.02456], [0.61346, -0.02402], [0.62877, -0.02347], [0.64396, -0.02289], [0.65901, -0.0223], [0.67389, -0.02169], [0.6886, -0.02105], [0.70313, -0.02041], [0.71745, -0.01976], [0.73156, -0.01909], [0.74543, -0.01842], [0.75906, -0.01774], [0.77243, -0.01703], [0.78553, -0.01631], [0.79835, -0.01555], [0.81086, -0.01479], [0.82307, -0.01403], [0.83496, -0.01324], [0.84651, -0.01247], [0.85771, -0.01169], [0.86856, -0.01091], [0.87905, -0.01014], [0.88915, -0.00939], [0.89887, -0.00866], [0.90819, -0.00793], [0.9171, -0.00723], [0.9256, -0.00656], [0.93367, -0.00591], [0.94131, -0.0053], [0.94851, -0.00471], [0.95526, -0.00415], [0.96156, -0.00364], [0.9674, -0.00316], [0.97277, -0.00272], [0.97768, -0.00232], [0.9821, -0.00193], [0.98605, -0.00161], [0.98951, -0.00131], [0.99248, -0.00107], [0.99496, -0.00087], [0.99695, -0.00071], [0.99844, -0.00059], [0.99944, -0.00051], [0.99975, -0.00049], [0.99994, -0.00048], [1.0, -0.00047],],
        };
        const airfoilName = airfoil2.nameHtml.toUpperCase().trim().replace(" ", "-");
        switch (airfoil2.airfoilType) {
            case 'naca4':
                const naca = airfoil2;
                //setTxtById_(prefix + 'airfoil-link', airfoilStr + maybeNacaLinkOrDescription, true);
                const naca_camber_max = naca.m; //SOL75
                // /10 compared to airfoiltools
                const naca_camber_pos = naca.p / 10; //SOL75
                const naca_thickness_max = naca.t; //SOL75
                const printLink = this.makePrintPlaneLink(airfoilName, chordMeters, aspectRatio, naca_camber_max, naca_camber_pos, naca_thickness_max, []);
                printPlane = printLink;
                break;
            default:
                const airfoilPoints = airfoilCoordinates[airfoilName];
                if (airfoilPoints !== undefined) {
                    // FIXME: do I need to change these numbers
                    // FIXME: figure out thickness
                    printPlane = this.makePrintPlaneLink(airfoilName, chordMeters, aspectRatio, 4, 2.5, 3, airfoilPoints);
                }
                else {
                    printPlane = 'preview plane &amp; get STLs - not yet supported this airfoil yet, use HS130';
                }
                break;
        }
        const CmInfo = (airfoil2.AirfoilCm) ? `<span class="text-muted"><b>Cm</b>=${round2dec(airfoil2.AirfoilCm, 4)} (dont trust XFoil Cm)</span><br>` : "";
        const Cm0Info = (airfoil2.AirfoilCm0) ? `<br><b>Cm0</b>=${round2dec(airfoil2.AirfoilCm0, 4)}<br>` : "";
        this.getById(prefix + 'airfoil-link').innerHTML =
            `<!--<b>Airfoil:</b> ${airfoilStr}<br/>--> 
                ${maybeNacaLinkOrDescription}
                ${Cm0Info}
                ${CmInfo}
                ${printPlane}
                `;
        // ${prefix}-modal-airfoil-details
        function setTxtById(id_suffix, value, setHtml = false) {
            setTxtById_(prefix + id_suffix, value, setHtml);
        }
        setTxtById('modal-airfoil-name', airfoil2.nameHtml + '', true);
        setTxtById('airfoil-name', airfoil2.nameHtml + '', true);
        const airfoilTldr = airfoil2.tldr ? `<strong class="text-muted">${airfoil2.tldr}</strong><br/><br/>` : "";
        const airfoilLinks = (airfoil2.linksHtml.length > 0) ?
            `<strong>Links:</strong><br/>
             <ul>${airfoil2.linksHtml
                .map((l) => `<li>${l}</li>`)
                .join("\n")}
             </ul><br/>` : "";
        const airfoilImages = (airfoil2.imageLinks.length > 0) ?
            `${airfoil2.imageLinks.map((img) => `<img src="${img}" width="100%" /><br/>`).join("<br/>")}<br/>` : "";
        const airfoilDescr = `
            ${airfoilTldr}
            ${airfoilLinks}
            ${airfoilImages}
            <div style="white-space: pre-wrap">${airfoil2.airfoilDescription.trim()}</div>
        `;
        setTxtById('modal-airfoil-details', airfoilDescr, true);
        // FIXME: ADD RE!
        setTxtById('dist', round2dec(bestFlightDistanceResult.projectedFlightDistKm) + 'km');
        setTxtById('aoa', round2dec(airfoil2.Alpha) + ' deg');
        setTxtById('airfoil-ld', round2dec(airfoil2.Ld) + '');
        setTxtById('airfoil-max-ld', round2dec(airfoil2.AirfoilMaxLd) + '');
        setTxtById('re', round2dec(Re, 1) + '');
        setTxtById('speed', round2dec(airspeedKmh, 1) + ' km/h');
        setTxtById('flight-time', formatTimeMinutes(projectedFlightTimeMinutes) + '');
        setTxtById('watts', round2dec(projectedPowerUsageW) + ' W');
        setTxtById('cl', round2dec(Cl, 4) + '');
        setTxtById('cd', round2dec(Cd, 4) + '');
        setTxtById('cdi', round2dec(Cdi, 4) + '');
        setTxtById('ld', round2dec(finalWingLD, 4) + '');
        setTxtById('aspect', round2dec(aspectRatio) + '');
        setTxtById('airfoil-chord', round2dec(chordMeters) + ' m');
        setTxtById('wingspan', round2dec(chordMeters * aspectRatio) + ' m');
        setTxtById('drag', round2dec(bestFlightDistanceResult.ApproxTotalDragNewtons) + ' N');
        setTxtById('wh-per-km', round2dec(projectedEfficiencyWhsPerKm) + ' Wh/km');
    }
    makePrintPlaneLink(airfoilName, chordMeters, aspectRatio, naca_camber_max, naca_camber_pos, naca_thickness_max, airfoil_points) {
        const stlConstants = this.getStlConstants(airfoilName, chordMeters, aspectRatio, naca_camber_max, naca_camber_pos, naca_thickness_max, airfoil_points);
        const printUrl = this.printUriForCode(stlConstants, this.getWingSource());
        const printLink = `<br/><b><a href="${printUrl}" target="_blank">preview plane &amp; get STLs <i class="bi bi-badge-3d-fill"></i><i class="bi bi-printer"></i></a></b>`;
        return printLink;
    }
    getWingSource() {
        const s = `
        
        
        /* 
    This work is licensed under a Creative Commons Attribution 4.0 International License.
    Downloaded from www.sol75.com
*/

$fs = 1;
include <constants.scad>;
use<printable_structures.scad>;
use<printable_airfoil_segments.scad>;



translate([20,0,100]) A0_glider_s0_NULL();

print_parts();


module A0A1_NACA_4d_0_NULL_new(chord = chord, perimeter_t = perimeter_t, h= rib_base_h, N=camber_max,A=camber_pos,CA=thickness_max,spar_x_extra_offset=0.0, twist=twist){
   //A rib, with a perimeter and spar attachment point
   translate([-spar_x_extra_offset,-spar_y_offset,0])color("LightSteelBlue"){
   max_chamber =  (N+A ==0)? 0.3*chord: A*0.1*chord;
   leading_edge_x = -max_chamber ;
   max_t = CA*0.01*chord;

   //n_sections = 5;
   section_step = chord/n_sections;
   section_span = section_step + perimeter_t;

   rotate([0,0,-twist]){
   difference(){
      //linear_extrude(h,center = true) scale(chord) NACA_4digit_points(N,A,CA);
      union(){
          //Basic shape
          linear_extrude(h,center = true) scale(chord) NACA_4digit_points(N,A,CA);
          //Nose
          intersection(){
              hull(){
                  //Consider sweep also for nose and tail
              translate([0,0,-h/2])linear_extrude(p0,center = true) scale(chord) NACA_4digit_points(N,A,CA);
              translate([-protrusion_h*tan(sweep),0,protrusion_h])linear_extrude(p0,center = false) scale(chord) NACA_4digit_points(N,A,CA);
              }
              translate([leading_edge_x,0,-h/2]) cylinder(d1 =10, d2=5, h=protrusion_h*1.1, center = false);
          }
          //Trailing edge
          intersection(){
                 hull(){
                  //Consider sweep also for nose and tail
              translate([0,0,+h/2])linear_extrude(p0,center = true) scale(chord) NACA_4digit_points(N,A,CA);
              translate([-protrusion_h*tan(sweep),0,protrusion_h])linear_extrude(p0,center = false) scale(chord) NACA_4digit_points(N,A,CA);
              }
              translate([leading_edge_x+ chord,0,0]) cylinder(d1 =30, d2=5, h=protrusion_h*1.1, center = false);
          }
      }


      //add proper holes
      for(i=[0:n_sections]){
           linear_extrude(2.1*protrusion_h,center = true) offset(r = perimeter_t ) offset(r = -2*perimeter_t ) intersection(){
                scale(chord) NACA_4digit_points(N,A,CA);
                translate([leading_edge_x+section_span/2 + i*section_step,0,0])square([section_span,max_t*2],center = true);
                }
      }
      //hole for spar
     translate([spar_x_extra_offset,spar_y_offset,0]) rotate([0,-sweep,0])rotate([0,0,twist])cube([spar_width + min_tol,spar_height + min_tol,8*h],center =true);

   }

   //Spar attachment, in the middle section
   difference(){
       union(){
       intersection(){
           linear_extrude(h,center = true) scale(chord) NACA_4digit_points(N,A,CA);
           rotate([0,0,twist]) translate([spar_x_extra_offset,spar_y_offset,0])cube([spar_width + 2*perimeter_t+ min_tol + p0,2*max_t ,2*h],center =true);
           }
           //Add lateral support, but make sure it can not exit from below
           intersection(){
                rotate([0,-sweep,0])rotate([0,0,twist])translate([spar_x_extra_offset,spar_y_offset,0])cube([spar_width + 2*perimeter_t+min_tol,spar_height + 2*perimeter_t+min_tol,2*protrusion_h],center =true);
                translate([0,0,protrusion_h])cube([chord,2*max_t, protrusion_h*2],center = true);
               }
        }
        //Take out spar volume
        rotate([0,-sweep,0])rotate([0,0,twist])translate([spar_x_extra_offset,spar_y_offset,0])cube([spar_width + min_tol,spar_height + min_tol,3*protrusion_h],center =true);
   }

  }
  }
}


module print_parts(){
    //chordA0A0_wing_struct_0_NULL();

    module ribs_in_place(){
        //rotate([0,0,sweep]) rotate([0,-theta,0])
        {
        //First with an offset
        translate([20,0,spar_h/2]) 
        mirror([-1,0,0])rotate([0,0,0]) rotate([0,0,90]) 
          A0A1_NACA_4d_0_NULL();

        for(i = [1:rib_n-1]){
            span_location = ((i+1)/rib_n) * (spar_l + 20);
            total_wingspan = spar_l *2 + 2*20;
            root_chord = chord;
            chord_percentage = sqrt(1 - pow((2 * span_location / total_wingspan), 2));
            echo("i:", i, "half_wingspan:", total_wingspan/2, "Span location: ", span_location, ", Chord: ", chord_percentage);

            translate([spar_l/(rib_n-1)*i + 18,0,spar_h/2]) mirror([-1,0,0]) rotate([0,0,0]) rotate([0,0,90])  A0A1_NACA_4d_0_NULL(chord = chord*chord_percentage);
       }
    }

    }
    //one wing ribs
    ribs_in_place();
   //mirror for the other
    mirror([1,0,0])ribs_in_place();

 }



module A0_glider_s0_NULL(){
    A0A0_wing_struct_0_NULL();

    module ribs_in_place(){
        spar_pos = 0.15;

        rotate([0,0,sweep]) rotate([0,-theta,0]){
        //First with an offset
        translate([20,0,spar_h/2]) mirror([-1,0,0])rotate([0,90,0]) rotate([0,0,90]) 
          A0A1_NACA_4d_0_NULL_new(spar_x_extra_offset=spar_pos);

        for(i = [1:rib_n-1]){
            span_location = ((i)/rib_n) * spar_l + 20;
            total_wingspan = spar_l *2 + 2*20;
            root_chord = chord;
            chord_percentage = sqrt(1 - pow((2 * span_location / total_wingspan), 2));
            echo("i:", i, "total_wingspan:", total_wingspan, "Span location: ", span_location, ", Chord: ", chord_percentage);
            new_chord = chord*chord_percentage;

            translate([spar_l/(rib_n-1)*i + 18,0,spar_h/2]) mirror([-1,0,0]) rotate([0,90,0]) rotate([0,0,90]) A0A1_NACA_4d_0_NULL_new(chord = chord*chord_percentage, spar_x_extra_offset=(chord-new_chord)*spar_pos);
       }
    }

    }
    //one wing ribs
    ribs_in_place();
   //mirror for the other
    mirror([1,0,0])ribs_in_place();

 }

module A0_glider_s0_STAND_ALONE_PRINT(){
   //nothing to do here
}

module A0_glider_s0_NEGATIVE(){
   //nothing to do here
}

module A0_glider_s0_POSITIVE(){
   //nothing to do here
}

                `;
        return s;
    }
    printUriForCode(stlConstants, wingSource) {
        const stlCfg = {
            "params": {
                "sourcePath": "/wing_model.scad",
                "source": wingSource,
                "features": [
                    "manifold",
                    "fast-csg",
                    "lazy-union"
                ],
                "constantsSource": stlConstants,
            },
            "view": {
                "layout": {
                    "mode": "multi",
                    "editor": false,
                    "viewer": true,
                    "customizer": false
                },
                "color": "#f9d72c",
                "showAxes": true,
                "showShadows": true
            }
        };
        const stlCfgJson = JSON.stringify(stlCfg);
        // FIXME: host!!!
        const printUrl = "https://www.flyuav.lt/make_3d_model/#" + encodeURIComponent(stlCfgJson);
        return printUrl;
    }
    getStlConstants(airfoilName, chordMeters, aspectRatio, naca_camber_max, naca_camber_pos, naca_thickness_max, airfoil_points) {
        const airfoilPointsJson = JSON.stringify(airfoil_points);
        return `

// ------- main ------------

chord = ${chordMeters * 1000};//SOL75
body_d = 5;//SOL75
theta = 5;//SOL75 // FIXME
sweep = 0;//SOL75  // FIXME
// 20 is the distance from the symmetry axis to the start of the spar
spar_l = ${chordMeters * 1000 * aspectRatio / 2 - 20};//SOL75
spar_w = 3;//SOL75
spar_h = 3;//SOL75
// differencial twist not implemented yet in this preview at least?
twist = 0;//SOL75
root_l = 8;//SOL75
rib_n = 8;//SOL75


use_skid = 1;//SOL75

//True DOF
skin_t = 1;//SOL75 // Upper and lower element of the beam
iso_el_t = 1.3;//SOL75 // ~ number of layers
iso_el_width = 0.5;//SOL75 // ~ nozzle thickness
perimeter_t = 0.8;//SOL75 // was 0.5

// FIXME
tube_z_pos = 1;//SOL75 //Position of the tube axis in z: How "negative" is the body tube position

insertion_l = 15;//SOL75
body_l = 12;//SOL75
pin_d = 2;//SOL75 // diameter of the pin which helds the beam in place
stand_off_l = 4;//SOL75// distance from the symmetry axis to the start of the spar

skid_l = 12; // skid lenght
hole_d = 3; //hole in the skid

// printer settings
min_tol = 0.4;//SOL75
p0 = 0.01;//SOL75

// ---------- NACA Airfoil ------------

spar_width = 3;//SOL75
//7.3
spar_height = 3;//SOL75
// mm
//chord = 80;//SOL75

// FIXME!!!
// NACA params
camber_max = ${naca_camber_max};//SOL75
// /10 compared to airfoiltools
camber_pos = ${naca_camber_pos};//SOL75
thickness_max = ${naca_thickness_max};//SOL75

// Real DOF
//. was 4
n_sections = 15;//SOL75
//perimeter_t = 0.8;//SOL75
//1.7 - height of whole rib
rib_base_h = 0.2*8;//SOL75
spar_y_offset = 1*1.5;//SOL75
protrusion_h = 5; // spar holder length (Z), was 5

//Machine settings
//min_tol = 0.4;//SOL75
//p0 = 0.01; //0.01 - is this minimum part size?

// ${airfoilName} airfoil
airfoil_points = ${airfoilPointsJson};
use_custom_airfoil_points = ${airfoil_points.length > 0 ? "true" : "false"};
        `;
    }
    maxAirspeed(aerodynamicData, airplane) {
        const zipped = List(aerodynamicData.powerUsage)
            .zip(List(aerodynamicData.totalDrag))
            .zip(List(aerodynamicData.airspeeds));
        console.log("zipped:", zipped.asMutable().toArray());
        const filtered = zipped
            .filter((item) => item[0] && item[0][0] && (item[0][0] <= airplane.propulsionData.maxMotorPower))
            .filter((item) => item[0] && item[0][1] && (item[0][1] <= airplane.propulsionData.maxThrust));
        console.log("filtered:", filtered.asMutable().toArray());
        const maxAchievableAirspeed_ = filtered
            .maxBy((item) => item[1]);
        console.log("maxAchievableAirspeed_:", maxAchievableAirspeed_);
        const maxAchievableAirspeed = maxAchievableAirspeed_[1];
        return maxAchievableAirspeed;
    }
    renderPresetSelector() {
        const options = presets.map((preset) => {
            return `<a href="?planePreset=${preset.airplaneName}" class="btn btn-primary">${preset.airplaneName}</a>`;
        }).join("\n");
        return options;
    }
    renderPrandlSelector() {
        const options = prandlPresets.map((preset) => {
            return `<a href="?prandlPreset=${preset.airplaineId}" class="btn btn-primary">${preset.airplaneName}</a>`;
        }).join("\n");
        return options;
    }
    renderPrandlIFrame(preset, printStl) {
        const url = this.prandlIframeUrl(preset, printStl);
        return `
        <div id="prandtl-iframe-container"><iframe src="${url}" width="100%" height="800" id="prandtl-iframe"></iframe></div>
        `;
    }
    prandlIframeUrl(preset, printStl) {
        const stlConstants = `
//  path_extrude.scad -- Extrude a path in 3D space
//  usage: add "use <path_extrude.scad>;" to the top of your OpenSCAD source code

//  Copyright (C) 2014-2019  David Eccles (gringer) <bioinformatics@gringene.org>

//  This program is free software: you can redistribute it and/or modify
//  it under the terms of the GNU General Public License as published by
//  the Free Software Foundation, either version 3 of the License, or
//  (at your option) any later version.

//  This program is distributed in the hope that it will be useful,
//  but WITHOUT ANY WARRANTY; without even the implied warranty of
//  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
//  GNU General Public License for more details.

//  You should have received a copy of the GNU General Public License
//  along with this program.  If not, see <https://www.gnu.org/licenses/>.

// Determine the projection of a point on a plane centered at c1 with normal n1
function project(p, c, n) =
    p - (n * (p - c)) * n / (n * n);

// determine angle between two points with a given normal orientation
// see https://stackoverflow.com/questions/14066933/
//        direct-way-of-computing-clockwise-angle-between-2-vectors
//    dot = p1 * p2;
//    det = (p1[0]*p2[1]*n1[2] + p2[0]*n1[1]*p1[2] + n1[0]*p1[1]*p2[2]) -
//          (n1[0]*p2[1]*p1[2] + p1[0]*n1[1]*p2[2] + p2[0]*p1[1]*n1[2]);
//    atan2(det, dot);
// determine angle between two planar points and a centre
// with a given normal orientation
function getPlanarAngle(p1, p2, c1, n1) =
    let(p1 = p1-c1, n1=n1 / norm(n1), p2=p2-c1)
    atan2((p1[0]*p2[1]*n1[2] + p2[0]*n1[1]*p1[2] + n1[0]*p1[1]*p2[2]) -
          (n1[0]*p2[1]*p1[2] + p1[0]*n1[1]*p2[2] + p2[0]*p1[1]*n1[2]), p1 * p2);

function c3D(tPoints) =
    (len(tPoints[0]) == undef) ? // single point
        c3D([tPoints])[0] :
        (len(tPoints[0]) < 3) ?  // collection of 2D points
            tPoints * [[1,0,0],[0,1,0]] :
            tPoints;             // 3D points

// translate a point (or points)
function myTranslate(ofs, points, acc = []) =
    (len(points[0]) == undef) ?
        myTranslate(ofs, [points])[0] :
        [ for(i = [0:(len(points) - 1)])
          [ for(d = [0:(len(points[0])-1)]) (ofs[d] + points[i][d])]];

// rotate a point (or points)
function myRotate(rotVec, points) =
    let(rotX = [[1,              0,               0],
                [0, cos(rotVec[0]), -sin(rotVec[0])],
                [0, sin(rotVec[0]),  cos(rotVec[0])]],
        rotY = [[ cos(rotVec[1]), 0,-sin(rotVec[1])],
                [              0, 1,              0],
                [ sin(rotVec[1]), 0, cos(rotVec[1])]],
        rotZ = [[ cos(rotVec[2]), sin(rotVec[2]), 0],
                [ sin(rotVec[2]), -cos(rotVec[2]), 0],
                [0,              0,               1]])
    (len(points[0]) == undef) ?
        myRotate(rotVec, [points])[0] :
        c3D(points) * rotX * rotY * rotZ;

// Determine spherical rotation for cartesian coordinates
function rToS(pt) =
    [-acos((pt[2]) / norm(pt)),
         0,
         -atan2(pt[0],pt[1])];

function calcPreRot(p1, p2, p3) =
  let(n1=p2-p1, // normal between the two points (i.e. the plane that the polygon sits on)
      n2=p3-p2,
      rt1=rToS(n1),
      rt2=rToS(n2),
      pj1=(p2 + myRotate(rt2, [[2,0,0.5]])[0]),
      pj2=project(p=(p1 + myRotate(rt1, [[2,0,0.5]])[0]), c=p2, n=n2))
  getPlanarAngle(p1=pj1, p2=pj2, c1=p2, n1=n2);

function cumSum(x, res=[]) =
  (len(x) == len(res)) ? concat([0], res) :
    (len(res) == 0) ? cumSum(x=x, res=[x[0]]) :
        cumSum(x=x, res=concat(res, [x[len(res)] + res[len(res)-1]]));

// Create extrusion side panels for one polygon segment as triangles.
// Note: panels are not necessarily be planar due to path twists
function makeSides(shs, pts, ofs=0) =
  concat(
    [for(i=[0:(shs-1)]) [i+ofs, ((i+1) % shs + ofs + shs) % (shs * pts),
                         (i+1) % shs + ofs]],
    [for(i=[0:(shs-1)]) [((i+1) % shs + ofs + shs) % (shs * pts),
                         i+ofs, (i + ofs + shs) % (shs * pts)]]);

// Concatenate the contents of the outermost list
function flatten(A, acc = [], aDone = 0) =
    (aDone >= len(A)) ? acc :
       flatten(A, acc=concat(acc, A[aDone]), aDone = aDone + 1);

// Linearly interpolate between two shapes
function makeTween(shape1, shape2, t) =
    (t == 0) ? shape1 :
      (t == 1) ? shape2 :
        [for (i=[0:(len(shape1)-1)])
          (shape1[i]*(1-t) + shape2[i % len(shape2)]*(t))];

// Extrude a 2D shape through a 3D path
// Note: merge has two effects:
//   1) Removes end caps
//   2) Adjusts the rotation of each path point
//      so that the end and start match up
module path_extrude(exPath, exShape, exShape2=[],
    exRots = [0], exScale = [1], merge=false){
  echo(len(exShape2));
  exShapeTween = (len(exShape2) == 0) ?
    exShape : exShape2;
  shs = len(exShape); // shs: shape size
  pts = len(exPath);  // pts: path size
  exPathX = (merge) ? concat(exPath, [exPath[0], exPath[1]]) :
      concat(exPath,
            [exPath[pts-1] + (exPath[pts-1] - exPath[pts-2]),
             exPath[pts-1] + 2*(exPath[pts-1] - exPath[pts-2])]);
  exScaleX = (len(exScale) == len(exPath)) ? exScale :
      [for (i = [0:(pts-1)]) exScale[i % len(exScale)]];
  preRots = [for(i = [0:(pts-1)])
    calcPreRot(p1=exPathX[i], // "current" point on the path
               p2=exPathX[(i+1)], // "next" point on the path
               p3=exPathX[(i+2)]) ];
  cumPreRots = cumSum(preRots);
  seDiff = cumPreRots[len(cumPreRots)-1]; // rotation difference (start - end)
  // rotation adjustment to get start to look like end
  seAdj = -seDiff / (len(cumPreRots));
  adjPreRots = (!merge) ? cumPreRots :
    [for(i = [0:(pts-1)]) (cumPreRots[i] + seAdj * i)];
  adjExRots = (len(exRots) == 1) ?
    [for(i = [0:(len(adjPreRots)-1)]) (adjPreRots[i] + exRots[0])] :
    [for(i = [0:(len(adjPreRots)-1)]) (adjPreRots[i] + exRots[i % len(exRots)])];
  phPoints = flatten([
    for(i = [0:(pts-1)])
      let(p1=exPathX[i],
          p2=exPathX[(i+1)],
          n1=p2-p1, // normal between the two points
          rt1=rToS(n1))
      myTranslate(p1, myRotate(rt1, myRotate([0,0,-adjExRots[i]],
                  c3D(makeTween(exShape, exShapeTween, i / (pts-1)) * exScaleX[i]))))
    ]);
  if(merge){ // just the surface, no end caps
      polyhedron(points=phPoints,
        faces=flatten([
              for(i = [0:(pts-1)])
                makeSides(shs, pts, ofs=shs*i)
              ])
          );
  } else {
      polyhedron(points=phPoints,
        faces=concat(
            flatten([
              for(i = [0:(pts-2)])
                makeSides(shs, pts, ofs=shs*i)
              ]),
            concat( // add in start / end covers
              [[for(i= [0:(shs-1)]) i]],
              [[for(i= [(len(phPoints)-1):-1:(len(phPoints)-shs)]) i]]
            )
          ));
  }
}

myPathTrefoil = [ for(t = [0:(360 / 101):359]) [ // trefoil knot
    5*(.41*cos(t) - .18*sin(t) - .83*cos(2*t) - .83*sin(2*t) -
       .11*cos(3*t) + .27*sin(3*t)),
    5*(.36*cos(t) + .27*sin(t) - 1.13*cos(2*t) + .30*sin(2*t) +
       .11*cos(3*t) - .27*sin(3*t)),
    5*(.45*sin(t) - .30*cos(2*t) +1.13*sin(2*t) -
       .11*cos(3*t) + .27*sin(3*t))] ];

myPointsOctagon =
  let(ofs1=15)
  [ for(t = [0:(360/8):359])
     ((t==90)?1:2) * [cos(t+ofs1),sin(t+ofs1)]];
myPointsChunkOctagon =
  let(ofs1=15)
  [ for(t = [0:(360/8):359])
    ((t==90)?0.4:1.9) *
     [cos((t * 135/360 + 45)+ofs1+45)+0.5,sin((t * 135/360 + 45)+ofs1+45)]];
//myPoints = [ for(t = [0:(360/8):359]) 2 * [cos(t+45),sin(t+45)]];

pts=[2,0,0.5];

translate([0,0,0]) {
    path_extrude(exRots = [$t*360], exShape=myPointsOctagon,
                 exPath=myPathTrefoil, merge=true);
}
`;
        const prandtlSource = `
        $fs = 1;
use <constants.scad>;

//use <printable_structures.scad>;
//use<printable_airfoil_segments.scad>;

//use <path_extrude.scad>;

// https://github.com/Irev-Dev/Round-Anything/blob/master/roundAnythingExamples.scad
//use <polyround.scad>;

// FIXME:
// - add ailerons
// - add optional servo mounts / cuttouts


// original values from paper were:
//chord = 200; //mm
//wingspan = 3740; //mm

print_stl_mode = ${printStl ? "true" : "false"};

// configurable params
chord = ${preset.centerChord}; // centerline chord
wingspan = ${preset.wingSpan}; // wingspan

// NASA/TP—2016–219072
// On Wings of the Minimum Induced Drag: Spanload Implications for Aircraft and Birds
// paper https://ntrs.nasa.gov/api/citations/20160003578/downloads/20160003578.pdf
// The control surfaces are located in the outboard 14 percent of each wing, in the trailing 25 percent of
//the chord; the round tips are included as part of the control surfaces. The wingspan is 12.3 ft, the wing area
//is 10.125 ft2
//, the centerline chord is 15.75 in., and the wingtip chord is 3.94 in. The wing had 2.5 deg of
//dihedral.


// https://ntrs.nasa.gov/api/citations/20210014683/downloads/H3284FINAL.pdf

// prandlt constants, should not be changed to preserve
// bell shaped lift distribution and proverse yaw
sweep = 24; // deg
dihedral = 2.5;
debug = false;


prandtl_twists = [
    8.3274,
    8.5524,
    8.7259,
    8.8441,
    8.9030,
    8.8984,
    8.8257,
    8.6801,
    8.4565,
    8.1492,
    7.7522,
    7.2592,
    6.6634,
    5.9579,
    5.1362,
    4.1927,
    3.1253,
    1.9394,
    0.6589,
    -0.6417,
    -1.6726
];
is_prandtl = true;
rootChordInches = 15.75; // inches
tipChordInches = 3.94; // inches
prandtl_tapper_ratio = rootChordInches/tipChordInches;

// Define your root and tip airfoil points
root_points = [[0.99839, 0.01595], [0.9983455334022425, 0.01594920521504058], [0.9982121412909327, 0.015946821192629225], [0.9979898467043281, 0.015942850100499742], [0.9976786880141058, 0.015937299449820974], [0.997278718887289, 0.015930187932712003], [0.9967900082330534, 0.015921553574974694], [0.996212640134517, 0.01591146418429805], [0.9955467137656593, 0.01590003006860857], [0.9947923432935303, 0.015887418993706808], [0.9939496577659557, 0.01587387334385204], [0.9930188009849601, 0.01585972944354494], [0.9919999313661698, 0.01584543899342178], [0.9908932217844801, 0.01583159256792309], [0.9896988594063004, 0.01581894511724403], [0.988417045508722, 0.015808443411022957], [0.9870479952859743, 0.01580125535628754], [0.9855919387672866, 0.015798753914568402], [0.9840491319561442, 0.015802072885789505], [0.9824198563216252, 0.01581215313585056], [0.9807044143868667, 0.01582995386406084], [0.9789031304272011, 0.015856450261530368], [0.9770163512620885, 0.01589262818396662], [0.9750444470724849, 0.015939478635076627], [0.97298781224149, 0.015997992072470896], [0.9708468662160562, 0.01606915254838534], [0.9686220543874594, 0.01615393169793604], [0.966313848988173, 0.016253282587997422], [0.9639227500027205, 0.01636813344014746], [0.9614492860900264, 0.016499381241452723], [0.9588940155147325, 0.016647885257170984], [0.9562575270848948, 0.016814460459729258], [0.9535404410934406, 0.01699987088858947], [0.9507434084118139, 0.017204828436637034], [0.9478670684463232, 0.017430113537880515], [0.9449120404835406, 0.017676596841518025], [0.9418789607459486, 0.017945125355267627], [0.9387684841642118, 0.018236513158576606], [0.9355812843591679, 0.01855153740784195], [0.9323180536180348, 0.01889093435115754], [0.9289795028644787, 0.019255395361036702], [0.9255663616221995, 0.019645562993570495], [0.9220793779716865, 0.02006202708247919], [0.9185193184997991, 0.020505320876497264], [0.9148869682418383, 0.020975917228499147], [0.9111831306157724, 0.021474224844725904], [0.9074086273482882, 0.022000584602411437], [0.9035642983923499, 0.022555265944029262], [0.899651001835945, 0.023138463356290495], [0.8956696126545683, 0.02375029209402627], [0.8916209469904599, 0.02439072896634711], [0.8875057051132326, 0.025059567046386743], [0.8833245722036763, 0.025756487156251156], [0.879078228062178, 0.02648106216658169], [0.8747673464481389, 0.027232753770673728], [0.8703925944440335, 0.028010909422669844], [0.8659546318454395, 0.028814759447886185], [0.8614541105783519, 0.029643414333075685], [0.8568916741450266, 0.030495862204163966], [0.8522679570995716, 0.03137096649871051], [0.8475835845544438, 0.032267463840050345], [0.8428391717189688, 0.03318396211976286], [0.8380353234709393, 0.034118938794790596], [0.8331726339623007, 0.035070739405197005], [0.8282516862598741, 0.03603757631820439], [0.8232730520513645, 0.037017528044696824], [0.8182373158756726, 0.0380088231520347], [0.8131451220990673, 0.03901038811668243], [0.807997121692093, 0.04002123142127922], [0.8027939619295758, 0.04104031409783118], [0.7975363974347456, 0.042066952708713544], [0.7922253761326832, 0.04310113141198747], [0.7868618774320699, 0.04414291621507409], [0.7814468945471783, 0.04519239152909967], [0.7759814332052546, 0.04624965494423094], [0.7704664429025868, 0.047314497932156294], [0.7649027723043984, 0.04838619898533789], [0.7592912639501809, 0.049463965439070924], [0.7536327633971743, 0.05054697688921546], [0.7479281203343958, 0.05163439162111121], [0.7421782467576769, 0.05272563732654668], [0.7363841464278276, 0.053820558760479247], [0.7305468391609145, 0.05491904145592466], [0.7246673542012847, 0.05602097961911314], [0.7187467289469117, 0.05712627034895974], [0.7127859682618325, 0.05823459876996911], [0.7067860302015676, 0.059345363301641474], [0.7007478741835478, 0.060457932223280185], [0.6946724643461338, 0.06157166251124911], [0.6885607703925929, 0.06268590522046981], [0.6824137938500682, 0.06380014242434513], [0.6762325725960505, 0.06491401167377013], [0.6700181524114636, 0.06602715979130269], [0.6637715852013553, 0.06713923470666916], [0.6574939267762405, 0.06824987333480213], [0.6511861939620355, 0.06935844546105988], [0.6448493644807158, 0.07046405422987732], [0.6384844174239525, 0.07156578017157568], [0.632092334960112, 0.07266269266289084], [0.6256741033470002, 0.07375385434253927], [0.6192307287483901, 0.07483837329257868], [0.6127632343985031, 0.07591539507440614], [0.6062726475340324, 0.07698406177556105], [0.59975999894291, 0.07804351176555589], [0.5932263208536559, 0.07909286110166021], [0.5866726245388459, 0.08013099052082692], [0.5800999082342125, 0.0811566229778757], [0.5735091725984467, 0.08216847345718634], [0.5669014209976111, 0.08316525334906612], [0.560277661119606, 0.08414565981327417], [0.5536389172901172, 0.08510828221411999], [0.5469862238709052, 0.08605165524009516], [0.5403206182472045, 0.08697431523226072], [0.5336431407495685, 0.08787480277291065], [0.5269548432496106, 0.08875168054524038], [0.5202568335332696, 0.08960361640355405], [0.5135502426736187, 0.09042932612432587], [0.5068362049201703, 0.09122753897112852], [0.5001158574967094, 0.09199699954179189], [0.493390354609903, 0.09273649738803462], [0.48666091282837987, 0.09344495795360847], [0.4799287668848224, 0.09412135839910282], [0.4731951536448366, 0.09476469847684792], [0.4664613118054428, 0.09537400224800881], [0.45972850007352445, 0.09594843410951148], [0.4529980294254682, 0.09648750191552247], [0.4462712200361889, 0.09699079406783931], [0.43954939200773574, 0.097457925675604], [0.43283386500440263, 0.09788853580408194], [0.42612596642813116, 0.09828199407457777], [0.4194270375648154, 0.09863717635490375], [0.412738419093743, 0.09895294286334048], [0.40606144899672736, 0.09922819431157907], [0.39939746341018495, 0.09946189965616858], [0.39274783266961266, 0.09965379746854955], [0.3861139644481946, 0.09980446719265047], [0.37949726264791234, 0.09991455314649439], [0.37289912455523666, 0.09998472092221017], [0.36632094190498193, 0.10001557826538313], [0.35976411912496303, 0.10000678914206397], [0.353230065601993, 0.09995740890425907], [0.3467201812388085, 0.09986653518700268], [0.3402358555755811, 0.0997333219927063], [0.33377846933817734, 0.09955714694349814], [0.3273494050320654, 0.09933847438381567], [0.32095003777593173, 0.09907819459036478], [0.31458172945745483, 0.09877721770209444], [0.3082458281522189, 0.09843647191923394], [0.3019436653740814, 0.09805685683341964], [0.2956765506329783, 0.09763914033816588], [0.2894457768636519, 0.09718408140717752], [0.2832526214507433, 0.0966924608213469], [0.2770983454653897, 0.0961650824404065], [0.2709841678234426, 0.0956029342009832], [0.26491124678324923, 0.09500730251547247], [0.25888072149700186, 0.09437950456891482], [0.2528937163692861, 0.09372085745427117], [0.24695134567907562, 0.09303264147118269], [0.2410548128828216, 0.09231537835556018], [0.2352054009975152, 0.09156889790184104], [0.22940437203522462, 0.09079306292007357], [0.22365296240304505, 0.08998779983468183], [0.21795237408975313, 0.08915317472051068], [0.21230371006217416, 0.08828997113009321], [0.20670801332577507, 0.0873993361290317], [0.2011663057091054, 0.08648242902168848], [0.19567958802444413, 0.08554041753414235], [0.19024889075046197, 0.08457424502354821], [0.18487542734263082, 0.08358392950134182], [0.17956042787591697, 0.08256932141597904], [0.17430508308556317, 0.08153035779307087], [0.16911054384866517, 0.08046706421802965], [0.16397786593987596, 0.07937990346803755], [0.1589079587067809, 0.07827009953348521], [0.15390168974979002, 0.07713897424752343], [0.14895989896331038, 0.07598785790658388], [0.14408340908039677, 0.07481805227523418], [0.13927326528617326, 0.07363000351987126], [0.1345307210074116, 0.0724233508120844], [0.12985697635620844, 0.07119782825439605], [0.12525316630591093, 0.06995330545124981], [0.12072037426361011, 0.06868978584410487], [0.11625973150478246, 0.06740741027025918], [0.11187235404593172, 0.06610644996987049], [0.10755928146012364, 0.06478729949952383], [0.10332147762032129, 0.06345047337083998], [0.09915981106043671, 0.06209678975764351], [0.095074997185869, 0.06072789449227814], [0.09106766974823512, 0.059345635202995205], [0.08713840434662944, 0.05795186311426722], [0.0832877196506976, 0.05654842894071332], [0.07951604842219344, 0.055136926887609454], [0.07582371603921634, 0.05371850054427895], [0.07221099922341308, 0.05229431567463864], [0.06867813444034628, 0.05086561374647199], [0.06522546651039979, 0.04943346275326372], [0.06185636257706091, 0.047993907469361156], [0.05857664193185884, 0.046538915999161996], [0.05539147493003218, 0.045061536795306674], [0.05230528571899794, 0.043556058419951985], [0.049320868756241275, 0.042019703243664684], [0.04643285823114799, 0.040465110568924545], [0.04363267778305594, 0.03891088576717153], [0.04091276303309353, 0.037373538885238526], [0.038266545509392784, 0.035867521583010716], [0.03569007504937465, 0.03440201165496653], [0.03318817858367915, 0.032968699359897526], [0.030767420109199847, 0.03155575451246903], [0.028433259311312527, 0.030153465283807506], [0.026190124599768102, 0.028754105962533236], [0.024043730965173662, 0.02735124466198054], [0.02200392159385087, 0.02593892113022261], [0.020079063668664816, 0.02451292525458295], [0.0182752519732802, 0.023070881002487865], [0.01659644107954132, 0.021612147397486767], [0.01503962043893195, 0.020143197345540844], [0.013592487877056122, 0.018680234636523085], [0.012243462404123532, 0.017238173171828415], [0.010982651029104442, 0.015829612608277217], [0.009801705369037487, 0.014465039948702334], [0.008693485283907152, 0.013152967564977148], [0.007650959864893083, 0.01189983784741596], [0.0066681947072228555, 0.010710540134573005], [0.005740776614681136, 0.009588752571764949], [0.00486562427458335, 0.00853709308132216], [0.004040918571559106, 0.007557170151168054], [0.0032738765113363585, 0.006643176008742693], [0.002581507664332284, 0.005781257872453963], [0.0019743223871529687, 0.004962925970304577], [0.0014561846318394054, 0.0041851694899503345], [0.001025739476446993, 0.0034492817277798175], [0.0006804141031025154, 0.0027618830696098584], [0.0004195893756219328, 0.002135479435617461], [0.00023619930680603715, 0.001580139682414787], [0.00011787640557531214, 0.0011028504339959148], [4.9613290784764215e-05, 0.0007082576768127885], [1.6025759354449786e-05, 0.0003992973354941886], [3.2118569258821213e-06, 0.0001777132973051381], [2.024769596253688e-07, 4.446162815815987e-05], [-1.0842021724855044e-19, 4.0657581468206416e-20], [5.301118212667146e-08, -4.3570355570511265e-05], [8.556462001707946e-07, -0.00017448985579883902], [4.3946921949535184e-06, -0.0003933056431688931], [1.416793380523373e-05, -0.000700669283660511], [3.5463385301134784e-05, -0.0010969469197251358], [7.57492625171742e-05, -0.0015816748036494256], [0.0001451737436102946, -0.002152861527637178], [0.000257173298927122, -0.002806138638931689], [0.00042918810374149483, -0.0035337616972384613], [0.0006834827838038226, -0.004323464196910322], [0.0010480704830073558, -0.005157167137156562], [0.0015533799991663097, -0.006012401731713348], [0.0022123715107539334, -0.00687449961583419], [0.0030248778060968633, -0.0077328448963990565], [0.0039798303035417405, -0.008578442630457525], [0.005055328995074023, -0.009404379116820892], [0.006241857705519091, -0.010205470095464957], [0.007539829002089365, -0.01097886927705368], [0.00894770853618779, -0.01172504543913854], [0.010461669882454304, -0.012448115217130594], [0.01207832452526194, -0.013151648150963048], [0.013795078176203499, -0.013838148701417117], [0.015607818937100632, -0.014512671181304325], [0.01751066649757635, -0.01518323994843043], [0.019498905179034104, -0.015855770802359493], [0.02157300161644564, -0.016527114143900058], [0.023734242195864542, -0.017192610274164705], [0.025984097728358847, -0.01784719025957341], [0.02832410429023262, -0.01848522573669064], [0.030754821761404684, -0.019099491296525405], [0.033276171136338586, -0.019681452683374612], [0.03588791257259317, -0.02022169018479882], [0.038589634320903, -0.020709880330575588], [0.041380299042550445, -0.021141234707585742], [0.04425755038724356, -0.02152646850402207], [0.04721841766437818, -0.0218811842402275], [0.05025941455846893, -0.022224178545708552], [0.053376676876016424, -0.022576488548674924], [0.056568589997940344, -0.022943430993132875], [0.05983572198266505, -0.023315046889587965], [0.06317886843445653, -0.02367944508804843], [0.0665989998436672, -0.024023150129926715], [0.07009698186393859, -0.02433330213459444], [0.07367216363087375, -0.02460877158056167], [0.07732324456255249, -0.02485332996439894], [0.08104880051200569, -0.025071503386002423], [0.08484728093591937, -0.025268593788483083], [0.0887172861927752, -0.025449159073264303], [0.09265805569924196, -0.025614332101371887], [0.0966689237565829, -0.025764823231725735], [0.10074921153071735, -0.025901521298020997], [0.1048982265610722, -0.026025482331868], [0.10911523810891427, -0.026137181036872417], [0.11339946451035418, -0.02623612799785576], [0.11775010270602793, -0.026321772823917424], [0.12216633060191978, -0.026393578240366037], [0.1266473085745692, -0.026451031215055446], [0.13119220436310064, -0.026493811048159004], [0.13580019128738954, -0.026521778181928007], [0.14047042853683048, -0.02653484245980422], [0.14520206062105112, -0.02653295995999703], [0.14999422029275208, -0.026516194158001515], [0.15484605211680888, -0.026485215729438332], [0.15975670254770358, -0.02644109010945871], [0.16472530710187014, -0.02638500302125714], [0.169750990378539, -0.026318258863007885], [0.17483286605559825, -0.0262420543308078], [0.17997003630982394, -0.026156385664771152], [0.1851615924763064, -0.026060804377227784], [0.19040661549758034, -0.025954853128177108], [0.19570417608541052, -0.025838066471605765], [0.2010533393520348, -0.02571014882680421], [0.20645317805070718, -0.025571494846647225], [0.21190276061696037, -0.025422707129113205], [0.21740114738694447, -0.02526443913145179], [0.22294739075781603, -0.025097394649160214], [0.22854053307477698, -0.02492214238671376], [0.2341796027196172, -0.02473878421646363], [0.23986361915911067, -0.02454735152980806], [0.24559159412476658, -0.024347887027302024], [0.25136253184549356, -0.024140445979643366], [0.25717543736269494, -0.02392527460534415], [0.26302932560660724, -0.02370300508844965], [0.26892320756658955, -0.02347434846012205], [0.2748560884887582, -0.023240051070078857], [0.2808269677404719, -0.02300088638516032], [0.28683482132274446, -0.02275719568820381], [0.292878590919119, -0.02250859865281595], [0.2989572089190437, -0.02225463902727162], [0.3050696010386061, -0.021994847933608615], [0.31121468735867885, -0.021728763059799126], [0.3173914114544617, -0.021456578520094038], [0.3235987491705424, -0.02117933770321101], [0.32983567487874516, -0.02089817152321926], [0.3361011592999027, -0.02061424530425912], [0.3423941680193927, -0.020328720855012868], [0.34871362507365855, -0.020041926371509606], [0.35505841133666044, -0.019753315543671757], [0.3614274009222473, -0.019462288801356642], [0.3678194631218375, -0.01916823292148325], [0.3742334645136954, -0.018870562869025324], [0.380668299490044, -0.01856938323074398], [0.38712288601874034, -0.018265391627294594], [0.3935961401074059, -0.01795931775125275], [0.40008697512203084, -0.017651904306359913], [0.40659430084380466, -0.017343882193630478], [0.4131170105346817, -0.017035683864234638], [0.4196539851170249, -0.01672753033715624], [0.4262041029293532, -0.016419639957719348], [0.4327662401098237, -0.01611223250935787], [0.43933926969295495, -0.015805505773582664], [0.44592205161668697, -0.015499418237671219], [0.45251343740906624, -0.01519378485076216], [0.45911227691643847, -0.014888416310614964], [0.4657174186053941, -0.01458312129985688], [0.4723277122817081, -0.014277761602370166], [0.4789420278644428, -0.01397265820528326], [0.48555924514515225, -0.013668363088645809], [0.49217824352864314, -0.01336543060924088], [0.4987979021132819, -0.013064414920383058], [0.50541709730597, -0.012765814711305317], [0.512034687810221, -0.01246974794291958], [0.5186495250117149, -0.012176169662841057], [0.5252604607026219, -0.011885032916014152], [0.5318663473158424, -0.011596289495528416], [0.538466039013812, -0.011309909602177967], [0.5450583961708081, -0.011025976504773853], [0.5516422822468562, -0.010744613057677129], [0.5582165620978279, -0.010465939963682983], [0.5647801021648641, -0.010190075576433985], [0.5713317703831364, -0.009917130754568092], [0.5778704352527293, -0.009647188897218217], [0.5843949670194707, -0.00938032332007057], [0.5909042383109184, -0.009116604999034056], [0.5973971243308189, -0.008856102510288441], [0.6038725029569986, -0.008598879140242731], [0.610329254622049, -0.008344983609664248], [0.6167662628148046, -0.00809445910807984], [0.6231824143854031, -0.007847346557018098], [0.6295765997382937, -0.007603684589469331], [0.6359477145843758, -0.00736355686271503], [0.6422946642740789, -0.007127217713811718], [0.6486163594328417, -0.0068949538974986055], [0.6549117147905736, -0.006667043272283284], [0.66117964935807, -0.006443754389247774], [0.6674190832721867, -0.006225256716560948], [0.673628930769713, -0.006011427009216196], [0.6798081091954086, -0.005802085954036448], [0.6859555413751858, -0.005597056806541786], [0.6920701558142701, -0.005396165679092199], [0.6981508882872326, -0.005199268315048186], [0.7041966844717645, -0.005006296729369771], [0.7102064967875521, -0.00481719567023348], [0.7161792838862494, -0.004631909514228969], [0.7221140108411994, -0.004450382706252207], [0.7280096518606384, -0.004272683377831657], [0.7338651940237451, -0.004099176928449876], [0.7396796319295008, -0.003930256293618232], [0.7454519668976232, -0.0037662943730214274], [0.751181207094496, -0.003607641704285289], [0.7568663597050725, -0.003454246094506083], [0.7625064221298647, -0.003305225972220254], [0.7681003981114378, -0.0031596288611842574], [0.7736473003034308, -0.0030165454492824366], [0.7791461506051661, -0.0028751185320733314], [0.7845959989262588, -0.002735551159514312], [0.7899959397561883, -0.0025999958808807216], [0.7953450782847249, -0.002470709179453299], [0.8006425261839543, -0.0023498139926309185], [0.8058874008475381, -0.0022392427024654563], [0.8110787502451345, -0.002136071477525551], [0.8162155028202146, -0.0020294063297486647], [0.8212965943538841, -0.001908254635622284], [0.8263209944505182, -0.001765718827130072], [0.8312877174882803, -0.001601889980428818], [0.8361957995824095, -0.0014176544388439384], [0.8410442957147612, -0.001213899797453748], [0.8458322798115203, -0.0009915142394289255], [0.8505588448036621, -0.0007513858784488992], [0.8552231026704663, -0.000494402107524602], [0.8598241844664178, -0.00022144895454488753], [0.8643612403318505, 6.658955514809376e-05], [0.8688334394877122, 0.00036883202886073946], [0.8732399702148547, 0.0006844003290456324], [0.8775800398182669, 0.0010124201879246311], [0.8818528745767027, 0.0013520218139795007], [0.8860577196781557, 0.0017023404900627713], [0.8901938391416725, 0.002062517162893787], [0.8942605157260007, 0.0024316990237158017], [0.8982570552478473, 0.002809021088895395], [0.9021828285956964, 0.0031934258390786865], [0.9060372478328326, 0.003583765847169113], [0.9098197354336311, 0.003978935837958908], [0.9135297239413677, 0.004377874050708971], [0.9171666560725369, 0.0047795616319972305], [0.9207299848216856, 0.005183021976525517], [0.9242191735666332, 0.005587320018895913], [0.9276336961739517, 0.005991561479423125], [0.9309730371045726, 0.006394892067100193], [0.9342366915193832, 0.006796496642877638], [0.937424165384685, 0.007195598346454862], [0.9405349755773694, 0.007591457689813078], [0.9435686499896783, 0.007983371620743734], [0.9465247276334064, 0.008370672559645152], [0.9494027587434135, 0.008752727412872084], [0.9522023048769506, 0.009128936610845642], [0.954922936969029, 0.00949876054354727], [0.9575642325048257, 0.009861757815762111], [0.9601257809962412, 0.010217512044078478], [0.9626071850064959, 0.01056561836785601], [0.9650080601547621, 0.010905683622443995], [0.9673280351196162, 0.011237326505351187], [0.9695667516413962, 0.011560177735475668], [0.9717238645235614, 0.011873880205503978], [0.9737990416331445, 0.012178089127589893], [0.9757919639003783, 0.012472472172422245], [0.977702325317591, 0.012756709601792], [0.9795298329374498, 0.013030494394767236], [0.981274206870633, 0.013293532367583974], [0.9829351802830161, 0.013545542287359033], [0.9845124993924415, 0.013786255979729569], [0.9860059234651519, 0.014015418430520975], [0.9874152254101644, 0.014232784141059255], [0.9887402001232729, 0.014438065019536848], [0.9899806589319453, 0.014630965174280624], [0.9911364208192892, 0.014811235840857596], [0.9922073130746841, 0.014978671360459793], [0.9931931721658208, 0.015133103768745245], [0.994093844554663, 0.015274397730556862], [0.9949091874554034, 0.015402445832985443], [0.9956390695326203, 0.015517164248331345], [0.9962833715379863, 0.015618488777584861], [0.9968419868840328, 0.015706371284095216], [0.99731482215362, 0.015780776526125643], [0.9977017975439145, 0.01584167939600783], [0.9980028472438367, 0.01588906257260884], [0.9982179197440936, 0.015922914592811328], [0.998346978079067, 0.015943228346685295], [0.99839, 0.01595]];
tip_points = [[1.0, 0.0007], [0.9999564480405243, 0.0007040372659859428], [0.9998257996867542, 0.0007161483627861223], [0.9996080775094155, 0.0007363311655051455], [0.9993033191155765, 0.0007645820612944001], [0.9989115771324534, 0.0008008958424999174], [0.9984329191847718, 0.0008452655574334052], [0.9978674278657192, 0.0008976823191299206], [0.9972152007015327, 0.0009581350725579947], [0.9964763501097745, 0.0010266103208502123], [0.995651003351361, 0.0011030918112227108], [0.9947393024764147, 0.0011875601813518771], [0.9937414042640238, 0.001279992567074609], [0.9926574801560002, 0.001380362172375034], [0.9914877161847333, 0.0014886378027157618], [0.9902323128952535, 0.0016047833628641658], [0.9888914852616184, 0.001728757320455515], [0.987465462597751, 0.0018605121366230591], [0.9859544884628627, 0.0019999936651114263], [0.9843588205616032, 0.002147140521373221], [0.9826787306390881, 0.0023018834232295432], [0.9809145043709624, 0.0024641445047530954], [0.9790664412486619, 0.0026338366051074334], [0.9771348544600482, 0.002810862534147545], [0.97512007076559, 0.0029951143166556116], [0.9730224303702824, 0.003186472417150352], [0.970842286791487, 0.0033848049472701793], [0.9685800067228956, 0.003589966857787882], [0.9662359698948135, 0.0038017991173684464], [0.9638105689309739, 0.004020127880231694], [0.9613042092020898, 0.004244763644927653], [0.9587173138591332, 0.004475558002909774], [0.9560503541868072, 0.004712741798836598], [0.9533038355023762, 0.004956769290928369], [0.9504782857984981, 0.005208192832335729], [0.94757425593906, 0.0054676659595295635], [0.9445922896968029, 0.005735610356444495], [0.9415328893951584, 0.006011833848662586], [0.9383965602443131, 0.006296025566457095], [0.9351838160452254, 0.006587820537047329], [0.9318951855258942, 0.006886872861828845], [0.9285312234389694, 0.007192983070685377], [0.9250924981349948, 0.0075059579553188975], [0.921579589295539, 0.007825585850569167], [0.9179930973037885, 0.008151740036630979], [0.9143336468752673, 0.008484419520718538], [0.9106018768273098, 0.00882363856157026], [0.9067984393078109, 0.009169419456168478], [0.9029239997120923, 0.00952179286021781], [0.898979236596543, 0.009880798096916705], [0.8949648389589211, 0.010246454478948272], [0.8908814805945198, 0.010618480108338268], [0.8867298281453918, 0.010996381881633899], [0.8825105579254687, 0.01137964221509569], [0.8782243822262629, 0.011768010439265555], [0.873872044440667, 0.012161450439256314], [0.8694543004851945, 0.012559937258501247], [0.8649719182539287, 0.01296345252278784], [0.8604256775013877, 0.01337198461472889], [0.8558163697223201, 0.013785528835859878], [0.8511447980284198, 0.014204087555912265], [0.8464117769740207, 0.014627669805686189], [0.8416181193775792, 0.015056143489756457], [0.8367646170270133, 0.015489018294531101], [0.8318520649257776, 0.015925722148300576], [0.8268812653573883, 0.016365648945792125], [0.8218530277281821, 0.01680815843980594], [0.8167681906345297, 0.017252827589070388], [0.8116276808834662, 0.01770011999781153], [0.8064324532063271, 0.018150705554562795], [0.8011834208387982, 0.01860467611940306], [0.7958814615078226, 0.019061615100572388], [0.7905274661977609, 0.019521150041640994], [0.785122350541137, 0.019983081167758363], [0.7796670423715614, 0.020447246550424184], [0.7741624857016477, 0.02091357723816161], [0.7686096363056234, 0.021382044029744623], [0.7630094542267081, 0.021852565957025488], [0.7573629037470176, 0.022325011994956147], [0.7516709570940712, 0.02279924939728444], [0.745934594422949, 0.02327514559696013], [0.7401548036492647, 0.023752568263814614], [0.7343325802807055, 0.02423138536202112], [0.7284689265417057, 0.0247114575299955], [0.7225648480072432, 0.02519260336751765], [0.7166213566926288, 0.025674635665589696], [0.7106394787892475, 0.02615745266007539], [0.704620251123477, 0.026640998855608222], [0.6985647173319816, 0.027125222558834382], [0.6924739271249566, 0.02761006916305066], [0.6863489271897797, 0.02809537302731923], [0.6801907625863788, 0.028580876782988998], [0.6740004990969519, 0.029066507963896794], [0.6677792226160805, 0.02955237352401213], [0.6615279844455829, 0.030038081270495263], [0.6552477949408875, 0.03052266221315275], [0.6489396916208194, 0.031005399193669583], [0.6426047468714974, 0.031485920374528686], [0.6362440393052313, 0.031963870843494044], [0.6298586518578863, 0.03243889296816556], [0.6234496716205055, 0.03291062678797073], [0.6170181930321338, 0.03337875792703515], [0.6105653960214212, 0.03384412486225502], [0.6040925414741961, 0.03430865920981333], [0.5976007329092843, 0.03477204880501543], [0.5910909302331321, 0.035231929868832806], [0.5845641910039115, 0.035687229827793224], [0.5780216557746344, 0.036137971137910806], [0.5714644704275376, 0.03658421171089916], [0.56489378332412, 0.037026012132436344], [0.5583107412250742, 0.03746341005768129], [0.5517164839364774, 0.03789632303945075], [0.5451121045881387, 0.03832391739763561], [0.538498687815192, 0.03874519057268799], [0.5318773736013492, 0.03915991551604997], [0.5252493209508895, 0.03956812028317171], [0.5186156903568577, 0.03996983843563674], [0.5119776435676456, 0.04036510873887653], [0.5053363432169271, 0.04075397261113097], [0.4986929279215254, 0.0411360700763097], [0.49204848468558693, 0.041510191417284716], [0.4854041322026245, 0.04187563036442331], [0.4787610491989058, 0.042232643861404254], [0.4721203969885732, 0.0425812254378059], [0.4654833101632396, 0.042920959758974475], [0.45885093647565217, 0.04325162062598535], [0.45222443682638297, 0.04357317688593167], [0.44560497174780583, 0.04388561032493958], [0.43899370067781057, 0.0441889087482693], [0.43239178173665394, 0.04448306594516959], [0.4258003692787961, 0.04476803370804239], [0.4192206013592782, 0.045043456560903805], [0.41265360839394494, 0.045308863069421855], [0.4061005188748392, 0.04556379369320551], [0.39956246301896603, 0.0458078446793066], [0.39304058324002683, 0.0460407882863988], [0.3865360226546139, 0.04626244665496468], [0.38004992136992566, 0.04647265348154423], [0.37358342198216404, 0.046671530663034366], [0.367137677650112, 0.0468598902154102], [0.36071381258542, 0.04703747789084855], [0.3543128903251549, 0.047201604262708], [0.3479360159064702, 0.047351424157372195], [0.3415843860184998, 0.04748999744418025], [0.33525915012599705, 0.047618618036722314], [0.3289613649741253, 0.04773494309977379], [0.32269210348803146, 0.047837369876601255], [0.3164524803130539, 0.047926013010786465], [0.3102436084960459, 0.048001149580569315], [0.30406659490403326, 0.048063061878313926], [0.2979225399943149, 0.0481120371108717], [0.2918125375982063, 0.048148363019679376], [0.2857376758135069, 0.0481719024888638], [0.27969903770674215, 0.04818174176404637], [0.2736976991547449, 0.04817692911487976], [0.26773472839147244, 0.048156566353001744], [0.2618111863041654, 0.0481202601092292], [0.2559281270876652, 0.04806888530408419], [0.25008660745670946, 0.04800292342975258], [0.24428771484806677, 0.047920661175121206], [0.2385325216273254, 0.04782061035606286], [0.23282201424185864, 0.04770496271820092], [0.22715715831132582, 0.047576659909402526], [0.2215390365532814, 0.047434462373821075], [0.21596878083094126, 0.04727506790720537], [0.21044737683766124, 0.047097600470763085], [0.20497567868898856, 0.046903377186238174], [0.19955462518424288, 0.04669308953451589], [0.19418530965333386, 0.04646624661183164], [0.18886882324124815, 0.04622230377269992], [0.18360623716655078, 0.04596078900913826], [0.17839860253774278, 0.04568130273098335], [0.1732469501916241, 0.04538351741779495], [0.16815229055348543, 0.045067177143822156], [0.16311561351893508, 0.04473209697771236], [0.15813788835711787, 0.04437816225884413], [0.15322004213122511, 0.04400557395122484], [0.14836286679688304, 0.0436159106885734], [0.14356711228213556, 0.04321107712930549], [0.13883378985612083, 0.04279036120986731], [0.13416421374852824, 0.04235004111796154], [0.1295595915232303, 0.041887303447524345], [0.12502065872357782, 0.041403976470295846], [0.12054798427720188, 0.04090339578413641], [0.11614230019536192, 0.040387346432652745], [0.11180463636371916, 0.03985494774824192], [0.10753601266535681, 0.03930520116557229], [0.10333740098653106, 0.038737305443288586], [0.09920972595647592, 0.03815065161382095], [0.0951538905799074, 0.037544838754068756], [0.09117095026353107, 0.03691981560266265], [0.0872619892975774, 0.03627576887109597], [0.08342801653358542, 0.03561302758176645], [0.0796699665802486, 0.03493205684730906], [0.07598870182403253, 0.03423345209127109], [0.07238494079405595, 0.033517947033471024], [0.06885893409585866, 0.032786469245443886], [0.06541078375867562, 0.032040073952723035], [0.06204073174370671, 0.031279742328577415], [0.058750072062163095, 0.03050521783442185], [0.055540462763584465, 0.029715872396718804], [0.05241335596700863, 0.028911422718811725], [0.04937000307724734, 0.028091916748858442], [0.04641146430009076, 0.027257714624650285], [0.04353861828352764, 0.02640946940504086], [0.04075217186067215, 0.02554810763421432], [0.0380526698700998, 0.024674809785003974], [0.03544050502933714, 0.02379099062736514], [0.032915982549925574, 0.02289818132645655], [0.030479937595289098, 0.021996918886364042], [0.028133396717420107, 0.021087352245722498], [0.02587707858061185, 0.02017013775523845], [0.023711801960439424, 0.019246090865165176], [0.021639022012045206, 0.018315723446515893], [0.01965981942154899, 0.017380042207229805], [0.017774772133815484, 0.016440575715269235], [0.015984063129482497, 0.015498945424992517], [0.014287471954432843, 0.014557152806559708], [0.012684700316332616, 0.01361754231595238], [0.01117778941082984, 0.012681210329679556], [0.009769063252485282, 0.011749277643555945], [0.008459468104150016, 0.010823909763830903], [0.007248735727120517, 0.009908171301286328], [0.00613583768773214, 0.009005699730205872], [0.005122357328756276, 0.008118556716876415], [0.004210174365997416, 0.007248648313353674], [0.0033983078071331482, 0.006399960320249892], [0.002683437130785116, 0.005578081110819286], [0.0020607507107654574, 0.004789208341742337], [0.0015246130896390772, 0.004039851665895366], [0.001076157738905062, 0.0033356466186748213], [0.0007195772222430624, 0.0026817112955447517], [0.00045106322799145354, 0.002084011018840464], [0.0002607578843086655, 0.001548975962780466], [0.0001354148914660335, 0.0010839542927348885], [6.053848518621177e-05, 0.0006969465480249175], [2.1286069577188072e-05, 0.0003930263066873207], [4.575830555795556e-06, 0.00017487598146600342], [2.999140737457528e-07, 4.373577552635342e-05], [-4.235164736271502e-22, -1.2387856853594142e-20], [3.000036337604529e-07, -4.374235554010565e-05], [4.577162998692573e-06, -0.00017490227761576761], [2.1291968725619873e-05, -0.000393085296323256], [6.0554934269122105e-05, -0.0006970507125603529], [0.00013545162361858258, -0.0010841150113030764], [0.00026082811302980633, -0.0015492024465304376], [0.00045118306475131886, -0.002084310056792425], [0.0007197647715002837, -0.002682088914608424], [0.001076430602882595, -0.00333610756215769], [0.0015249849847400459, -0.0040403997962687845], [0.002061230275978814, -0.004789846816359034], [0.002684041332302, -0.005578810640338813], [0.0033990555392559717, -0.006400780173048392], [0.004211084439609886, -0.007249556796060239], [0.005123447495061256, -0.008119551818280439], [0.0061371228459014965, -0.009006780968151763], [0.007250227630200345, -0.009909339575108022], [0.008461182398292844, -0.010825162925075259], [0.009771016270396067, -0.011750612569138943], [0.01117999601327754, -0.012682624357445894], [0.012687173267369688, -0.013619033739746291], [0.01429022154860504, -0.014558721227900563], [0.015987103265218468, -0.015500587997476202], [0.0177781183053004, -0.016442288580452893], [0.01966348649110284, -0.017381822059616865], [0.021643024163608374, -0.01831756676012833], [0.023716152429314876, -0.019247994403881953], [0.025881789332543346, -0.020172099292527623], [0.02813847964534878, -0.02108936970027037], [0.030485405943927305, -0.021998989282863472], [0.032921848813150974, -0.022900302641755268], [0.03544678097169255, -0.023793161709487413], [0.038059368790290746, -0.024677026281628312], [0.04075930733538254, -0.025550364241672736], [0.04354620350098253, -0.02641176105899714], [0.04641951198848889, -0.02726003662326011], [0.04937852542901841, -0.028094264884061068], [0.052422364558924385, -0.028913793415704863], [0.055549968472761925, -0.029718262860947503], [0.058760084978013764, -0.03050762620749339], [0.06205126107589096, -0.03128216785099225], [0.0654218379131142, -0.03204251691659609], [0.0688705247934779, -0.03278892582062033], [0.07239708146917444, -0.033520411353899146], [0.07600140600673523, -0.03423591834635089], [0.07968324642467987, -0.03493451961094268], [0.08344188302204196, -0.035615481826850266], [0.0872764530546095, -0.03627820987085047], [0.09118602152594946, -0.03692223899358978], [0.09516957916598531, -0.03754724060106077], [0.09922604127269163, -0.03815302850990451], [0.10335435294326187, -0.03873965538481105], [0.10755361126554751, -0.0393075233015057], [0.11182289130938866, -0.03985724214696037], [0.11616122086958423, -0.04038961417012071], [0.12056757972580188, -0.04090563903385219], [0.12504093834079014, -0.04140619276871945], [0.12958056622221872, -0.04188947594771816], [0.1341858944675785, -0.04235215094267701], [0.13885618547468115, -0.04279240865255083], [0.14359023009035765, -0.043213076772286266], [0.14838671417349644, -0.04361787459758414], [0.1532446285695872, -0.04400749255528052], [0.15816322352398424, -0.04438002260251496], [0.1631417064114139, -0.04473389179360231], [0.16817914960384742, -0.04506890361204233], [0.1732745836197558, -0.04538517309048286], [0.17842701834509006, -0.04568288556175985], [0.18363544313009142, -0.045962297382641994], [0.1888988269075034, -0.046223736534144994], [0.1942161183324237, -0.046467603096533486], [0.1995862459439993, -0.04669436959732996], [0.2050081183491328, -0.04690458123085529], [0.21048064241341952, -0.04709872623795548], [0.21600288038276202, -0.047276104334560205], [0.2215739779241523, -0.04743540071922217], [0.22719294792490943, -0.04757751394865025], [0.23285865810674847, -0.04770575044369712], [0.2385700264981996, -0.04782131928511628], [0.24432608768421527, -0.0479212660600617], [0.2501258546009482, -0.04800342032816399], [0.25596825438659465, -0.048069285735784305], [0.26185219960675377, -0.04812056556377876], [0.2677766335841341, -0.048156766254708], [0.273740501957073, -0.04817701774052922], [0.27974274367424024, -0.04818172201200022], [0.28578229032719044, -0.048171777987845145], [0.29185806586311025, -0.048148138045652815], [0.2979689870455324, -0.04811171379957311], [0.30411396561773124, -0.04806263555996537], [0.31029190757154834, -0.04800061514962276], [0.3165017122708147, -0.04792536526443152], [0.32274227266854094, -0.047836603516334286], [0.32901247553686924, -0.04773405273308447], [0.33531120620723254, -0.047617603907998456], [0.3416373920676434, -0.04748887760907031], [0.3479899759450651, -0.047350206041109885], [0.35436780729249157, -0.0472002577084635], [0.3607696895319741, -0.04703598435003897], [0.36719451842028394, -0.04685827051629821], [0.3736412300704149, -0.04666979800572978], [0.38010869954965315, -0.046470797609354936], [0.38659577356754565, -0.04626045963405824], [0.39310130947758026, -0.04603866836728956], [0.39962416699857645, -0.04580559034169668], [0.4061632028371325, -0.045561403531044764], [0.4127172745072461, -0.04530633696923664], [0.41928525173123327, -0.04504079583782657], [0.42586600585068063, -0.044765239925597625], [0.43245840627985765, -0.04448014084690469], [0.4390613146470198, -0.04418585110116135], [0.44567357634073373, -0.043882417211700504], [0.45229403306208493, -0.04356984539686136], [0.45892152519443746, -0.043248147860841364], [0.4655548920266265, -0.04291734282885404], [0.4721929725156732, -0.0425774619655169], [0.47883461898252655, -0.04222873494301619], [0.4854786966194529, -0.04187157641620179], [0.4921240434995957, -0.041505986080588524], [0.49876948093586454, -0.04113171049497093], [0.5054138909324263, -0.04074946994591072], [0.5120561860933914, -0.04036047062039632], [0.5186952269746565, -0.03996506185624665], [0.5253298507417885, -0.039563201848265006], [0.5319588954680445, -0.03915485180764765], [0.5385812004824206, -0.03873997815210971], [0.5451956066074238, -0.038318552870396705], [0.5518009742902622, -0.037890811757591195], [0.5583962191564611, -0.0374577636442492], [0.5649802472835375, -0.03702023263269327], [0.5715519183613172, -0.0365782960795537], [0.5781100853890934, -0.03613191587712871], [0.5846535998046947, -0.03568103124502479], [0.5911813155510006, -0.035225584245361305], [0.5976920921308514, -0.0347655555455323], [0.6041848738219242, -0.034302045183635596], [0.6106587005299223, -0.033837416567814145], [0.6171124650017946, -0.03337193212572664], [0.6235449058124074, -0.03290365513774613], [0.629954844738941, -0.03243177362825534], [0.6363411874742027, -0.03195660621823829], [0.6427028467667368, -0.03147851297282721], [0.6490387395207204, -0.030997851625321975], [0.6553477869643598, -0.030514977185065052], [0.6616289167061694, -0.030030263356557927], [0.6678810917822112, -0.02954443562407455], [0.6741033015538812, -0.02905846140545318], [0.6802944934528004, -0.028572719118811242], [0.6864535813423942, -0.028087100804292227], [0.6925794996889626, -0.027601683989107943], [0.6986712033090476, -0.027116726504576784], [0.7047276451231714, -0.02663239117105184], [0.7107477752169545, -0.026148732042656716], [0.7167305497979803, -0.025665800835888836], [0.722674931892384, -0.02518365315407768], [0.728579895308104, -0.024702392568711633], [0.7344444279391535, -0.02422220703620123], [0.7402675239937455, -0.02374327727192119], [0.7460481810543911, -0.02326574219831978], [0.751785403465174, -0.022789733887466013], [0.757478203163404, -0.022315384705709415], [0.7631255998481017, -0.021842827256201854], [0.7687266211470491, -0.021372194321200404], [0.7742803026132349, -0.020903616694759545], [0.7797856839163928, -0.02043717358254573], [0.7852418091152461, -0.01997289391169952], [0.7906477342226763, -0.01951084872991561], [0.7960025313681277, -0.01905120121469617], [0.8013052849927432, -0.01859415349687427], [0.8065551042993648, -0.018140081740583312], [0.8117511111383385, -0.01768939943288711], [0.8168923903962795, -0.01724199482402514], [0.8219779870576083, -0.016797195857255046], [0.8270069756862808, -0.01635455567409005], [0.831978518829832, -0.015914512260937423], [0.836891806626717, -0.01547770286535861], [0.8417460363586254, -0.015044730759124448], [0.8465404126088995, -0.01461616535993058], [0.8512741428411411, -0.014192490281640453], [0.8559464136606766, -0.013773831687215776], [0.8605564109201349, -0.013360185356789922], [0.8651033318940601, -0.012951553568243901], [0.8695863854349362, -0.012547945296877363], [0.8740047920970823, -0.012149376071472548], [0.878357784257527, -0.011755867818139929], [0.882644606233885, -0.011367448692375009], [0.8868645148680256, -0.01098415822550714], [0.8910167960768295, -0.010606233893176668], [0.8951007673851962, -0.01023413845374255], [0.8991157561147128, -0.009868310609169484], [0.9030610879308003, -0.009509026161878402], [0.9069360829081383, -0.009156348967053252], [0.9107400717038371, -0.008810324824276848], [0.9144723971257795, -0.008470998954434828], [0.918132414251043, -0.00813841598364152], [0.9217194905423242, -0.007812619926699885], [0.9252330039686483, -0.00749363745998067], [0.9286723184449596, -0.007181271109364737], [0.9320367951716068, -0.006875193350277073], [0.9353258137737053, -0.006575122862872019], [0.9385388044454348, -0.006281123214034063], [0.9416753870659388, -0.005994900045404381], [0.9447352305142004, -0.0057184878054368565], [0.9477179851457749, -0.005453619089290351], [0.9506232179653763, -0.00520111732819767], [0.9534500068412168, -0.004957099072849386], [0.9561972922818767, -0.004716264991404437], [0.958864121681654, -0.0044741846922703365], [0.9614496456901035, -0.004227262102923167], [0.9639532597136445, -0.003974053038014509], [0.966374727031493, -0.003716411487781542], [0.9687138487592848, -0.0034564138393112075], [0.9709704192226443, -0.003195942329388294], [0.9731442272527345, -0.0029366963829569126], [0.9752350574662046, -0.002680203829925299], [0.9772426915263219, -0.0024278319707463645], [0.9791669093821578, -0.0021807984618223857], [0.9810074904827548, -0.0019401819924531026], [0.9827642149632911, -0.0017069327257681734], [0.9844368648003348, -0.0014818824768584988], [0.9860252249333803, -0.0012657546021429054], [0.9875290843499387, -0.0010591735748773504], [0.9889482371315679, -0.0008626742226297804], [0.9902824834583223, -0.0006767106035043074], [0.9915316305692177, -0.0005016644989016337], [0.9926954936764141, -0.0003378535016463199], [0.9937738968309406, -0.00018553867939425202], [0.9947666737379083, -4.493179435207284e-05], [0.995673668519278, 8.379793850507182e-05], [0.9964947364223824, 0.00020051757134529534], [0.9972297444725328, 0.00030512463693266144], [0.9978785720681749, 0.00039754186978733185], [0.998441111517195, 0.00047771244794958165], [0.9989172685131212, 0.0005455957669500029], [0.9993069625501051, 0.0006011637562738051], [0.9996101272757107, 0.0006443977472728194], [0.9998267107806891, 0.0006752859001296898], [0.999956675825065, 0.0006938211961146453], [1.0, 0.0007000000000000003]];




// code a bit too complex below but seem to work
if (debug) {
    cube_size = chord*3;
    translate([0, 0, wingspan / 2]) color("red") cube([cube_size, cube_size, 0.01], center = true);
}
scale_ratio = 1/prandtl_tapper_ratio * chord;
//height=20*wing_scale*scale_ratio;
wing_scale = wingspan/(2*20*scale_ratio) / (1-tan(2*dihedral)); //8/20;
myPath = [ for(t = [0:20]) [0,0,t*wing_scale] ];


// helpers
module line(start, end, thickness = 0.1) {
    hull() {
        translate(start) sphere(thickness);
        translate(end) sphere(thickness);
    }
}

module drawLines(path) {
    for(i = [0:len(path)-2]) {
        color("red") line(path[i], path[i+1]);
    }
}

scales = [ for(s=[0:len(myPath)-1]) 1+ (prandtl_tapper_ratio-1)*s/(len(myPath)  ) ];

// wing twists distribution - do not change
exRots = [ for(s=[0:len(myPath)-1]) -prandtl_twists[20-s] ];



// Extrude a 2D shape through a 3D path
// Note: merge has two effects:
//   1) Removes end caps
//   2) Adjusts the rotation of each path point
//      so that the end and start match up
module path_extrude_(exPath, exShape, exShape2=[],
    exRots = [0], exScale = [1], merge=false){
  echo(len(exShape2));
  exShapeTween = (len(exShape2) == 0) ?
    exShape : exShape2;
  shs = len(exShape); // shs: shape size
  pts = len(exPath);  // pts: path size
  exPathX = (merge) ? concat(exPath, [exPath[0], exPath[1]]) :
      concat(exPath,
            [exPath[pts-1] + (exPath[pts-1] - exPath[pts-2]),
             exPath[pts-1] + 2*(exPath[pts-1] - exPath[pts-2])]);
  exScaleX = (len(exScale) == len(exPath)) ? exScale :
      [for (i = [0:(pts-1)]) exScale[i % len(exScale)]];
  preRots = [for(i = [0:(pts-1)])
    calcPreRot(p1=exPathX[i], // "current" point on the path
               p2=exPathX[(i+1)], // "next" point on the path
               p3=exPathX[(i+2)]) ];
  cumPreRots = cumSum(preRots);
  seDiff = cumPreRots[len(cumPreRots)-1]; // rotation difference (start - end)
  // rotation adjustment to get start to look like end
  seAdj = -seDiff / (len(cumPreRots));
  adjPreRots = (!merge) ? cumPreRots :
    [for(i = [0:(pts-1)]) (cumPreRots[i] + seAdj * i)];
  adjExRots = (len(exRots) == 1) ?
    [for(i = [0:(len(adjPreRots)-1)]) (adjPreRots[i] + exRots[0])] :
    [for(i = [0:(len(adjPreRots)-1)]) (adjPreRots[i] + exRots[i % len(exRots)])];
  phPoints = flatten([
    for(i = [0:(pts-1)])
      let(p1=exPathX[i],
          p2=exPathX[(i+1)],
          n1=p2-p1, // normal between the two points
          rt1=rToS(n1))
        // modified here slightly to add wing sweep
      myTranslate(p1, myRotate([0,sweep,0], myRotate([0,0,-adjExRots[i]],
                  c3D(makeTween(exShape, exShapeTween, i / (pts-1))) * exScaleX[i])))
    ]);
  if(merge){ // just the surface, no end caps
      polyhedron(points=phPoints,
        faces=flatten([
              for(i = [0:(pts-1)])
                makeSides(shs, pts, ofs=shs*i)
              ])
          );
  } else {
      polyhedron(points=phPoints,
        faces=concat(
            flatten([
              for(i = [0:(pts-2)])
                makeSides(shs, pts, ofs=shs*i)
              ]),
            concat( // add in start / end covers
              [[for(i= [0:(shs-1)]) i]],
              [[for(i= [(len(phPoints)-1):-1:(len(phPoints)-shs)]) i]]
            )
          ));
  }
}

// find largest and smallest y point in root_points for dihedral
minmax = [min([for(p = root_points) p[1]]), max([for(p = root_points) p[1]])];
max_thickeness = minmax[1] - minmax[0];
// FIXME: add 2.5deg dihedral
module drawOneWing(color = "green") {
    // 1 was tip chord
    scale([scale_ratio, scale_ratio, scale_ratio])
        //translate([1, 0, 0]) // move tip end to zero
        // move front of wing to x=0
        translate([sin(sweep) * -20 * wing_scale, 0, 0]) {

            difference() {
                // add dihedral
                translate([0, 0, tan(dihedral) * 20 * wing_scale * max_thickeness]) rotate([-dihedral, 0, 0])
                    // rotate and translatate back, so it's standing straight, on Z axis at z=0
                    translate([0, 0, cos(sweep) * -20 * wing_scale]) {
                         {
                             difference() {
                                 // wing
                                 rotate([0, sweep, 0])
                                     rotate([0, 0, 180]) {
                                         //drawLines(myPath);

                                         color(color)
                                             path_extrude_(exShape = tip_points,
                                             exShape2 = root_points,
                                             exRots = exRots,
                                             exPath = myPath,
                                             exScale = scales,
                                             merge = false
                                             );
                                     }
                                 // roundings
                                 color("blue") {
                                     r = 0.2;
                                     difference() {
                                         {
                                             translate([0, 0, -0.5]) hull() {
                                                 translate([-r / 2, 0, r]) rotate([90, 0, 0])  cube([1, 1, 1],
                                                 $fs = 0.01, center = true);
                                                 translate([-1, 0, 0]) translate([r / 2, 0, r]) rotate([90, 0, 0])  cube
                                                     ([1, 1, 1],
                                                     $fs = 0.01, center = true);
                                             }
                                         }
                                         hull() {
                                             translate([-r / 2, 0, r]) rotate([90, 0, 0])  cylinder(h = 1, r1 = r, r2 =
                                             r,
                                             $fs = 0.01, center = true);
                                             translate([-1, 0, 0]) translate([r / 2, 0, r]) rotate([90, 0, 0])  cylinder
                                                 (h =
                                                 1, r1 = r, r2 = r, $fs = 0.01, center = true);
                                             //translate([0.1, 0, 0.1/2]) cylinder([-1, 0, 0]) sphere(0.1, $fs = 0.01);
                                         }
                                     }

                                 }
                             }
                        }
                    }
                // cutoff the bottom of the wing below z=0, for dihedral
                translate([0, 0, 1 * 0.5])
                    color("red")cube([20, 20, 1], center = true);
            }
        }
}


//top
mirror([0, 0, 1]) drawOneWing("yellow");
// bottom
if (!print_stl_mode) {
    drawOneWing();
} else {
    translate([0, max_thickeness*20 * wing_scale * scale_ratio * 2, 0]) rotate([180, 0, 0]) drawOneWing();
}
        `;
        const url = this.printUriForCode(stlConstants, prandtlSource);
        return url;
    }
    renderPrandlForm(preset) {
        return `
        <div id="prandltGenerator">
            <div class="container my-4">
                <h2>NASA Prandtl Generator ${this.renderPrandlSelector()}</h2>
                
                 
                <!--<br/><br>-->
                
                <div class="row mb-3">
                    <div class="input-group mb-3" id="prandtlChord-g">
                      <span class="input-group-text">Centerline Chord (cm)</span>
                          <input type="number" step="1" class="form-control" id="prandtlChordCm" name="prandtlChordCm" value="${preset.centerChord / 10}">
                      <span class="input-group-text">Wingspan (cm)</span>
                      <input type="number" step="1" class="form-control" id="prandtlWingspanCm" name="prandtlWingspanCm"  value="${preset.wingSpan / 10}">
                      <a href="#" class="btn btn-primary" id="prandtl-submit">Preview</a>
                      <a href="#" class="btn btn-secondary" id="prandtl-print">Preview STL for Printing</a>
                    </div>
<!--
                    <div class="input-group mb-3" id="prandtlWingspan-g">
                      <span class="input-group-text">Wingspan</span>
                          <input type="number" step="0.01" class="form-control" id="prandtlWingspan" name="prandtlWingspan"  value="${preset.wingSpan}">
                            <span class="input-group-text">mm</span>
                    </div>
                    -->
                  </div>
            </div>
            ${this.renderPrandlIFrame(preset, false)}
        </div>`;
    }
    renderForm(preset) {
        // FIXME: refactor into components? bootstrap helpers + inputs etc?
        // FIXME: implement conditional select logic and more complex logic when customizing something
        return `
        <style type="text/css">
        .custom-tooltip {
          --bs-tooltip-bg: var(--bs-primary);
          --bs-tooltip-max-width: 400px;
        }
        span.custom-tooltip {
            /*color: #369 !important;*/
        }
/*        .bi::before {*/
/*  display: inline-block;*/
/*  content: "";*/
/*  vertical-align: -.125em;*/
/*  background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z' clip-rule='evenodd'/></svg>");*/
/*  background-repeat: no-repeat;*/
/*  background-size: 1rem 1rem;*/
/*}*/
</style>
<div id="airfoilSearcher">
 <div class="container my-4">
    <strong>Load plane preset:</strong> 
    ${this.renderPresetSelector()}
    <hr />
 </div>
        <div class="container my-4">
            <form id="aerodynamicsForm">
            
<h2>Step 1: Configure fixed weight and all rest (except wing size, airspeed & airfoil)</h2>

<div class="accordion" id="accordionExample">
  <div class="accordion-item">
  
    <h2 class="accordion-header" id="headingAirplane">
      <button class="accordion-button  fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAirplane" aria-expanded="true" aria-controls="collapseAirplane">
        Airplane: name, weight w/o battery
      </button>
    </h2>
    <div id="collapseAirplane" class="accordion-collapse collapse show" aria-labelledby="headingAirplane" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        
                <h5>Basics</h5>

                <div class="row mb-3">
                    <label for="airplaneName" class="col-sm-3 col-form-label">Airplane Name</label>
                    <div class="col-sm-9">
                    <!-- fixme: escape -->
                        <input type="text" class="form-control" id="airplaneName" name="airplaneName" value="${preset.airplaneName}">
                    </div>
                </div>
                <div class="row mb-3 d-none">
                    <label for="wingArea" class="col-sm-3 col-form-label">Wing Area <small class="text-muted">(m²)</small></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.001" class="form-control" id="wingArea" name="wingArea" value="0.45">
                    </div>
                </div>

                <div class="row mb-3 d-none">
                    <label for="wingSpan" class="col-sm-3 col-form-label">Wing Span <small class="text-muted">(m)</small></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.001" class="form-control" id="wingSpan" name="wingSpan" value="2.09">
                    </div>
                </div>
                
                <h5>Weight</h5>

                <div class="row mb-3">
                    <label for="emptyWeight" class="col-sm-3 col-form-label">Empty Weight <small class="text-muted">(kg, without battery)</small></label>
                    <div class="col-sm-9">
                        <input type="number" class="form-control" step="0.001" id="emptyWeight" name="emptyWeight" value="${preset.emptyWeight}">
                    </div>
                </div>
                
                <div class="row mb-3">
                    <label for="payloadWeight" class="col-sm-3 col-form-label">Payload Weight <small class="text-muted">(kg)</small><br /> 
                       <small class="text-muted">p.s. battery is not included into payload<br />
                       p.s. battery weight is calculated automatically, see section below</small></label>
                    <div class="col-sm-9">
                        <input type="number" class="form-control" step="0.001" id="payloadWeight" name="payloadWeight" value="0">
                    </div>
                </div>

<div class="d-none">
                <h5>Lift/Drag info <span class="text-muted">(used to approximate a lift/drag curve)</span></h5>
                <div class="row mb-3">
                    <label for="cd0" class="col-sm-3 col-form-label">CD0 <small class="text-muted">(Zero-Lift Drag Coefficient)<br />
                    <a href="https://en.wikipedia.org/wiki/Zero-lift_drag_coefficient">more info on CD0 here</a> and <a href="https://en.wikipedia.org/wiki/Zero-lift_axis">here</a> </small></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.001" class="form-control" id="cd0" name="cd0"  value="0.022">
                    </div>
                </div>

                <div class="row mb-3">
                    <label for="maxCl" class="col-sm-3 col-form-label">Max CL <small class="text-muted">(Maximum Lift Coefficient)</small></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.001" class="form-control" id="maxCl" name="maxCl" value="1.3">
                    </div>
                </div>

                <div class="row mb-3">
                    <label for="zeroAoACl" class="col-sm-3 col-form-label">0 AoA CL<br><small class="text-muted">(Zero Angle of attack Lift Coefficient)</small></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.001" class="form-control" id="zeroAoACl" name="zeroAoACl" value="0.45">
                    </div>
                </div>
</div>


                <!-- accordion closing -->
                </div>
            </div> <!-- accordion-body -->
    </div><!-- acordion-item -->
    <!-- closed -->  

  <div class="accordion-item">
  
  
  
    <h2 class="accordion-header" id="headingPower">
      <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePower" aria-expanded="false" aria-controls="collapsePower">
        Power-train: Motor, Prop, Battery weight & power (cells, % discharge)...
      </button>
    </h2>
    <div id="collapsePower" class="accordion-collapse collapse" aria-labelledby="headingPower" data-bs-parent="#accordionExample">
      <div class="accordion-body">

                <!--                <h5>Propulsion Details</h5>-->

                <div class="row mb-3">
                    <label for="propulsionType" class="col-sm-3 col-form-label">Propulsion Type</label>
                    <div class="col-sm-9">
                        <select class="form-select" id="propulsionType" name="propulsionType">
                            <option value="custom" selected>Custom motor &amp; propeller</option>
                            <option value="edfSchubeler128mm">EDF Schubeler 128mm DS-94-DIA HST with DSM6740-650 (71% efficiency)</option>
                            <option value="edfSchubeler70mm">EDF Schubeler 70mm DS-30-AXI 70mm + HET 2W-20 3400kV 10kg thrust (57% efficiency)</option>
                            <option value="jet_5kg_old" >Jet turbine - 5kW 1kg 0.17kg/min 5kg thrust</option>
                        </select>
                    </div>
                </div>
                
                <div class="row mb-3">
                        <label for="escEfficiency" class="col-sm-3 col-form-label">Esc Efficiency</label>
                        <div class="col-sm-9">
                            <input type="number" step="0.01" class="form-control" id="escEfficiency" name="escEfficiency" value="1.0">
                        </div>
                </div>
                    
                <div class="row mb-3">
                    <label for="maxMotorPower" class="col-sm-3 col-form-label">Max Electrical Power <span class="text-muted">(W)</span></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.01" class="form-control" id="maxMotorPower" name="maxMotorPower" value="${preset.maxMotorPower}">
                    </div>
                </div>

                <div id="custom-motor" class="row">
                    <small class="text-muted"><b>Custom motor & propeller params:</b><br/></small>
                    
                    <div class="row mb-3">
                        <label for="propellerEfficiency" class="col-sm-3 col-form-label">Propeller Efficiency</label>
                        <div class="col-sm-9">
                            <input type="number" step="0.01" class="form-control" id="propellerEfficiency" name="propellerEfficiency" value="0.7">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label for="motorEfficiency" class="col-sm-3 col-form-label">Motor Efficiency</label>
                        <div class="col-sm-9">
                            <input type="number" step="0.01" class="form-control" id="motorEfficiency" name="motorEfficiency" value="0.8">
                        </div>
                    </div>
                    <!-- FIXME -->
                    <div class="row mb-3 d-none">
                        <label for="motorMaxThrust" class="col-sm-3 col-form-label">Max Thrust<span class="text-muted">(kg)<br>0 - unlimited</span> </label>
                        <div class="col-sm-9">
                            <input type="number" step="0.01" class="form-control" id="motorMaxThrust" name="motorMaxThrust" value="0">
                        </div>
                    </div>
                </div>


                <h5>Battery</h5>
                <div class="row mb-3">
                    <label for="batteryType" class="col-sm-3 col-form-label">Battery Cell Type</label>
                    <div class="col-sm-9">
                        <select class="form-select" id="batteryType" name="batteryType">
                            <!-- <option value="samsung50E21700" selected>Samsung 50E 21700 5000mAh</option>
                            <option value="molicelP45B21700">Molicel P45B - 50A 4500mAh 21700</option> -->
                        </select>
                    </div>
                </div>

                <!--<h5>Battery Customization</h5>-->
                <div class="row mb-3">
                    <label for="batteryS" class="col-sm-3 col-form-label">S <small class="text-muted">(Battery Cells in Series)</small></label>
                    <div class="col-sm-9">
                        <input type="number" class="form-control" id="batteryS" name="batteryS" value="${preset.batteryS}">
                    </div>
                </div>
                <div class="row mb-3">
                    <label for="batteryP" class="col-sm-3 col-form-label">P <small class="text-muted">(Battery Cells in Parallel)</small></label>
                    <div class="col-sm-9">
                        <input type="number" class="form-control" id="batteryP" name="batteryP" value="${preset.batteryP}">
                    </div>
                </div>
                
                <div class="row mb-3">
                    <label for="batteryUsage" class="col-sm-3 col-form-label">Max Battery Discharge <small class="text-muted">(%)<br />
                    p.s. usually one don't discharge fully </small></label>
                    <div class="col-sm-9">
                        <input type="number" step="1" class="form-control" id="batteryUsage" name="batteryUsage" value="90">
                    </div>
                </div>
                
                
                <!-- accordion closing -->
                </div>
            </div> <!-- accordion-body -->
    </div><!-- acordion-item -->
    <!-- closed -->  

  <div class="accordion-item">
  
  
  
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button  fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
        More settings: FC power usage, environment, etc
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div class="accordion-body">


                <h5>Power usage</h5>

                <!-- hidden -->
                <div class="row mb-3 d-none">
                    <label for="payloadPowerUsage" class="col-sm-3 col-form-label">Payload Power Usage <small class="text-muted">(W)</small></label>
                    <div class="col-sm-9">
                        <input type="number" class="form-control" id="payloadPowerUsage" name="payloadPowerUsage" value="0">
                    </div>
                </div>
                
                <div class="row mb-3">
                    <label for="fcPower" class="col-sm-3 col-form-label">Flight Controller Power <small class="text-muted">(W)<br/>e.g. VTX, FC, servos</small></label>
                    <div class="col-sm-9">
                        <input type="number" class="form-control" id="fcPower" name="fcPower" value="3.5">
                    </div>
                </div>
                
                <!-- hidden -->
                <div class="row mb-3 d-none">
                    <label for="vtxPower" class="col-sm-3 col-form-label">Video Transmitter Power <small class="text-muted">(W)</small></label>
                    <div class="col-sm-9">
                        <input type="number" class="form-control" id="vtxPower" name="vtxPower" value="0">
                    </div>
                </div>


                <h5>Environmental Factors</h5>
                <div class="row mb-3">
                    <label for="airDensity" class="col-sm-3 col-form-label">Air Density <small class="text-muted">(kg/m³)</small></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.001" class="form-control" id="airDensity" name="airDensity" value="1.225">
                    </div>
                </div>
                <div class="row mb-3">
                    <label for="gravity" class="col-sm-3 col-form-label">Gravity <small class="text-muted">(m/s²)</small></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.00001" class="form-control" id="gravity" name="gravity"  value="9.80665">
                    </div>
                </div>
                
                
                <h5>Other Factors</h5>

                
                <div class="row mb-3">
                    <label for="dragFudgeFactor" class="col-sm-3 col-form-label">Drag Fudge Factor</label>
                    <div class="col-sm-9">
                        <input type="number" step="0.1" class="form-control" id="dragFudgeFactor" name="dragFudgeFactor" value="1.4">
                    </div>
                </div>
                
                <div class="row mb-3">
                    <label for="oswaldEfficiencyFactor" class="col-sm-3 col-form-label">Oswald Efficiency Factor<br /><small class="text-muted">(E, used for estimating lift-induced drag)</small></label>
                    <div class="col-sm-9">
                        <input type="number" step="0.001" class="form-control" id="oswaldEfficiencyFactor" name="oswaldEfficiencyFactor" value="0.85">
                    </div>
                </div>

                <!-- FIXME -->
                <div class="row mb-3 d-none">
                    <label for="maxSpeedToAnalyze" class="col-sm-3 col-form-label">Max Airspeed to analyse until <span class=text-muted>(km/h)</span></label>
                    <div class="col-sm-9">
                        <input type="number" step="1" class="form-control" id="maxSpeedToAnalyze" name="maxSpeedToAnalyze" value="400">
                    </div>
                </div>
                
                  
                
                <!-- accordion closing -->
                </div>
            </div> <!-- accordion-body -->
    </div><!-- acordion-item -->
    <!-- closed -->  
</div> <!-- close accordion fully-->



<!--  <div class="accordion-item">-->
<!--    <h2 class="accordion-header" id="headingAirfoiler">-->
<!--      <button class="accordion-button  fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAirfoiler" aria-expanded="false" aria-controls="collapseAirfoiler">-->
<!--        Better Airfoil finder:  find wingspan + aspect + airfoil for given weight, and speed range-->
<!--      </button>-->
<!--    </h2>-->
<!--    <div id="collapseAirfoiler" class="accordion-collapse collapse" aria-labelledby="headingAirfoiler" data-bs-parent="#accordionExample">-->
<!--      <div class="accordion-body"> -->
<!--      -->
      
      <br/>
      
      <h2>Step 2: Find airfoil, wing dimensions, speed</h2>
                  
                  Temperature: 10C<br> 
                  
                  <div class="row mb-3 d-none">
                    <div class="input-group mb-3" id="minmaxAspectRatio">
                      <span class="input-group-text">Extra CD0</span>
                      <input type="number" step="0.0001" class="form-control" id="extraZeroLiftDrag" name="extraZeroLiftDrag" value="${preset.extraZeroLiftDrag}">
                    </div>
                    <label for="extraZeroLiftDrag"><span class=text-muted>Extra zero-lift form-drag, to add in addition to pure wing drag, to account for stuff like fuselage drag, expressed in terms of Drag coefficient
                    <br />
                  P.S. we will also multiply the non-lift-induced drag by the drag fudge factor to account for possible surface imperfections, e.g. due to 3D printing</span></label>
                  </div>
                  
<!--                  <hr />-->
                  
                  <div class="row mb-3">
                    <div class="input-group mb-3" id="minmaxAspectRatio">
                      <span class="input-group-text">Airspeed range</span>
                          <input type="number" step="1" class="form-control" id="minAirspeed" name="minAirspeed" value="${preset.minAirspeed}">
                      <span class="input-group-text">km/h</span>
                      <input type="number" step="1" class="form-control" id="desiredAirspeed" name="desiredAirspeed" value="${preset.maxAirspeed}">
                      <span class="input-group-text">km/h</span>
                    </div>
<!--                  </div>-->
<!--                  -->
<!--                  -->
<!--                 <div class="row mb-3">-->
                    <div class="input-group mb-3" id="minmaxAspectRatio">
                      <span class="input-group-text">Aspect ratio range</span>
                          <input type="number" step="0.01" class="form-control" id="minAspectRatio" name="minAspectRatio"  value="${preset.minAspectRatio}">
                      
                          <input type="number" step="0.01" class="form-control" id="maxAspectRatio" name="maxAspectRatio" value="8">
                    </div>
<!--                  </div>-->

<!--                  -->
<!--                  <div class="row mb-3">-->
                    <div class="input-group mb-3" id="minmaxAspectRatio">
                      <span class="input-group-text">Chord length range</span></span>
                          <input type="number" step="0.0001" class="form-control" id="minChordLength" name="minChordLength" value="${preset.minChordLength}">
                          <span class="input-group-text">m</span>
                      <input type="number" step="0.0001" class="form-control" id="maxChordLength" name="maxChordLength" value="0.3">
                      <span class="input-group-text">m</span>
                    </div>
                  </div>
                  
                  <div class="row mb-3">
<!--                    <label for="checkOnlyMaxLDAlpha" class="col-sm-3 col-form-label">Shall we perform a fast search?</label>-->
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="checkOnlyMaxLDAlpha" name="checkOnlyMaxLDAlpha" value="1" checked>
                      <label class="form-check-label" for="checkOnlyMaxLDAlpha">Shall we perform a fast search?</label>
                    </div>
                    
<!--                    <div class="col-sm-9">-->
<!--                       <input type="checkbox" id="checkOnlyMaxLDAlpha" name="checkOnlyMaxLDAlpha" value="1" checked />-->
<!--                    </div>-->
                    <br>
                     <span class="text-muted"><strong>If enabled, will only check the airfoils' max LD alpha for each Re, speeding up the search greatly</strong> (this sort of requires less rigid requirements on search parameters above)<br />
                     Anyway, if the best result for the whole wing, is not at or close to the Airfoil's Max L/D point, 
                     it possibly means the airfoil or the conditions at which it was simulated in Xfoil (Re, Alpha, CL), is not the most optimal for the given setup (speed, aspect, weight, etc),
                     even though the wing's max L/D point gets shifted due to induced drag: CDi=CL² / (pi * AR * E)
                     <br />
                     P.S. this is because we don't interpolate currently XFoil results in between the Re's and Alpha's.
                     </span>
                </div>
                  
                  <div class="row mb-3">
                    <span  class="col-sm-3"><strong class="text-muted">Airplane type(s):</strong></span>
                    
                    
                     <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="supportTail" name="supportTail" value="1">
                      <label class="form-check-label" for="flexSwitchCheckDefault">With tail (Cm < 0)</label>
                    </div>
                    
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="supportPlank" name="supportPlank" value="1" checked>
                      <label class="form-check-label" for="flexSwitchCheckChecked">Tailless Plank (Cm > 0)</label>
                    </div>
                    
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="supportPlankDS" name="supportPlankDS" value="1">
                      <label class="form-check-label" for="flexSwitchCheckChecked">Tailless DS Plank (Dynamic soaring, Cm ~ 0)</label>
                    </div>
                    
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="supportAerobatics" name="supportAerobatics" value="1">
                      <label class="form-check-label" for="flexSwitchCheckChecked">Aerobatics ( CL > 0 @ alpha < 0 )</label>
                    </div>
                    
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="supportSweptWing" name="supportSweptWing" value="1">
                      <label class="form-check-label" for="flexSwitchCheckChecked">Tailless swept wing (Cm ~ 0)</label>
                    </div>
                    
<!--                    <div class="form-check form-switch">-->
<!--                      <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckCheckedDisabled" checked disabled>-->
<!--                      <label class="form-check-label" for="flexSwitchCheckCheckedDisabled">Disabled checked switch checkbox input</label>-->
<!--                    </div>-->
                 </div>
                  
                 <div class="row mb-3" id="airfoils-selector-div">
                    <span  class="col-sm-3"><strong class="text-muted">Enabled airfoil(s):</strong></span>
                    
                     <div class="form-check form-switch">
                      <input class="form-check-input supportTail supportSweptWing" type="checkbox" role="switch" id="enable-naca4-cfd" name="enable-naca4-cfd" value="1">
                      <label class="form-check-label" for="flexSwitchCheckDefault">NACA 4 Digit Generator (trained from CFD, more accurate, Cm unknown) <span class="badge rounded-pill text-bg-warning">tail</span> <span class="badge rounded-pill text-bg-info">swept-wing</span></label>
                    </div>
                    
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="enable-naca4-cfd" name="enable-naca4-xfoil" value="1">
                      <label class="form-check-label" for="flexSwitchCheckDefault">NACA 4 Digit Generator (trained from XFOIL, less accurate, Cm unknown) <span class="badge rounded-pill text-bg-warning">tail</span> <span class="badge rounded-pill text-bg-info">swept-wing</span></label>
                    </div>
                    
                    <div class="spinner-border text-success" role="status" id="airfoils-loading-spinner">
                      <span class="sr-only"></span>
                    </div>
                   
                 </div>
<!--                 P.S. HS airfoils, like HS130, that are not available on airfoiltools comming soon, hopefully...<br/>-->
                  
<!--                  <hr />-->
<!--                  <div class="row mb-3 form-check form-switch">-->
<!--                        <input type="checkbox" class="form-check-input" id="useCFD" name="useCFD" value="1" checked />-->
<!--                        <label for="useCFD" class="form-check-label">NACA 4 Digit Generator: Use model trained from CFD? (otherwise trained on XFOIL)-->
<!--                          <span class=text-muted>CFD model is said to be more accurate, and thus adviced to use. &lt;!&ndash;it seems I have some issues with retrieving NACA airfoil p param from it, but CFD is the adviced/more-accurate model-->
<!--                          <b>so if enabled the CFD model, paste there the Re & CL into <a href="https://aeroptimal.com/airfoil">https://aeroptimal.com/airfoil</a> to get actual airfoil!</b>&ndash;&gt;-->
<!--                          <br>P.S. CFD/XFOIL is not being run live!</span>-->
<!--                          </label>-->
<!--                  </div>-->
                  
                <br><button type="submit" class="btn btn-primary">Calculate</button><br /><br>

                  
                  
                 <b>SEARCH RESULTS: Airfoil, Chord/Aspect, Airspeed</b><br/>
                 
                 
                <div id="airfoil-results-preamble"></div>
                
                <div class="container">
                    <div class="row">
                        <div class="card" style="width: 14rem; margin: 0.2rem; padding: 0">
                          <div class="card-body">
                            <h5 class="card-title"><span>Fixed parameters</h5>
                            <p class="card-text">
                                Total weight: <span id="stats-auw" class="fw-bold"></span><br />
                                Battery weight: <span id="stats-battery-weight" class="fw-bold"></span><br />
                            </p>
                          </div>
                          <div class="card-footer small">
                                Battery:&nbsp;<span id="stats-energy-usable-wh"></span> <span class="text-muted">(usable)</span><br />
                                Battery vs AUW: <span id="stats-battery-percent-of-weight"></span><br />
                          </div>
                        </div>
                  
                      ${this.airfoilCardHtml('Max distance', 'finder-stats-max-dist')}
                      
                      ${this.airfoilCardHtml('Max speed within 15% max distance', 'finder-stats-max-dist-speed')}
                </div>
                </div>
                  
                  
                  
                  
<!--                  <button type="submit" class="btn btn-primary">Calculate</button><br />-->
                  
                  <br />
                  
                  
                  <b>How it works:</b><br />
                  <ul>
                    <li><strong>weight is always fixed</strong></li>
                    <li><strong>airfoil finder: well known airfoils (if enabled)</strong>
                        <ul>
                            <li>iterate through airfoils, speeds, Re's</li>
                            <li>using exact Re's/AOAs the XFOIL simulations were performed (there's no interpolation between intermediate Re's &amp; AOAs yet), calculate chord/aspect to yield required lift for level cruise</li>
                        </ul>
                    </li>
                    
                    <li><strong>airfoil finder: NACA 4 Digit Generator (if enabled)</strong>
                        <ul>
                            <li>iterate through all possible speeds, chord lengths, aspect ratios</li>
                            <li>limitation: this finder return results only if CL & Re is within the range of model - <strong class="text-muted">CL (0.2-1.8) & Reynolds (80k-500k)</strong></li>
                            <li>use a polynomial model from [1] to find optimal NACA4 airfoil for given CL (0.2-1.8) & Reynolds (80k-500k), which was trained using XFOIL</li>
                            <li>max L/D of each resulting airfoil is taken from this polynomial model <b class="text-muted">(we don't run real CFD nor XFOIL yet, so it might be lying a little bit!)</b>, but model's R^2 for L/D was rather good</li>
                            <li><strong class=text-muted>Limitations:</strong>
                                  <ul>
                                    <li><b class="text-muted">Airfoils are not guaranteed to be aerodynamically stable and probably do not have low <i>Cm</i>, thus no tailess Planks yet</b>. Model has no clue about <i>Cm</i> - further XFOIL/CFD checks needed</li>
                                    <li>Limitation: Nothing considered regarding wing twist/washout/washin</li>
                                    <li>I guess due to simplicity of the model used, manual CFD/XFOIL validation of few best results is quite a must to ensure estimates makes sense, and that airfoils are stable</li>
                                    <li>Limitation: It probably assumes Eliptical lift distribution (?). Bell-shaped might be more efficient if wing span is not limited</li>
                                  </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li><strong>calculating aircraft performance</strong>
                        <ul>
                            <li>using the result from enabled airfoil finder we calculate the max flight distance (using all other params from the other calculator tabs, keep in mind FC/VTX/servos is using some power,</li>
                            <li>so sometimes going at faster speed might be more efficient even because of that)</li>
                            <li>only the best flight distance result is currently reported (could be multiple)</li>
                        </ul>
                    </li>
                    
                  </ul><br>
                  
                  <b>Literature:</b> <br>
                  [1] <a href="https://link.springer.com/article/10.1007/s40430-022-03866-4">Springer: Optimal airfoil design through particle swarm optimization fed by CFD and XFOIL</a>
                 
                 
                 <div class="d-none">
                 Details of Max Distance airfoil:
                  <code id="airfoiler2_result" class="d-none">
                  LOADING...
                  </code>
                  <div id="airfoiler2_result_div" class="d-none">
                  </div><br />
                  </div>
                 
<!--                                   -->
<!--                  &lt;!&ndash; accordion closing &ndash;&gt;-->
<!--                </div>-->
<!--            </div> &lt;!&ndash; accordion-body &ndash;&gt;-->
<!--    </div>&lt;!&ndash; acordion-item &ndash;&gt;-->
<!--    &lt;!&ndash; closed &ndash;&gt;   -->
<!--                  -->
<!--                  -->
<!--                &lt;!&ndash; accordeon fully closing &ndash;&gt;  -->
<!--                  </div>-->
<!--                &lt;!&ndash; accordeon: closed &ndash;&gt;  -->
                

<!--                <div class="row mb-3" style="margin-top: 1em;">-->
<!--                    <div class="col-sm-9">-->
<!--                        <button type="submit" class="btn btn-primary">Calculate</button>-->
<!--                    </div>-->
<!--                </div>-->
            </form>
        </div>
</div>
    `;
    }
    airfoilCardHtml(title = 'Max distance', prefix = 'finder-stats-max-dist') {
        return `
                      <div class="card" style="width: 20rem; margin: 0.2rem; padding: 0">
                          <div class="card-body">
                            <h5 class="card-title"><span>${title}:</span> <span id="${prefix}-dist" class="badge bg-secondary">-</span></h5>
                            <p class="card-text">
                                Cruise Airspeed: <span id="${prefix}-speed" class="fw-bold"></span><br />
                                <!-- Distance: <span id="stats-max-dist-dist"></span><br /> -->
                                Flight duration: <span id="${prefix}-flight-time" class="fw-bold"></span><br />
                                L/D: <span id="${prefix}-ld">-</span><br />
                                Efficiency: <span id="${prefix}-wh-per-km" class="fw-bold">-</span>
    
                                <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#${prefix}-exampleModal">
                                  Airfoil: <span id="${prefix}-airfoil-name">-</span>
                                </button>
                                
                                
                                      
                                <!-- Modal -->
<div class="modal fade" id="${prefix}-exampleModal" tabindex="-1" aria-labelledby="${prefix}-exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen-lg-down modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="${prefix}-exampleModalLabel">Airfoil details: <span id="${prefix}-modal-airfoil-name"></span></h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" id="${prefix}-modal-airfoil-details">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
                                
                            </p>
                            <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
                          </div>
                          <div class="card-footer small">
                          <b>Aspect ratio: <span id="${prefix}-aspect">-</span><br />
                                Chord: <span id="${prefix}-airfoil-chord">-</span><br />
                                Wingspan: <span id="${prefix}-wingspan">-</span><br /></b><br>
                          
                                Power usage: <span id="${prefix}-watts">-</span>
                                <span 
                                    style="color: #369  "
                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                        data-bs-custom-class="custom-tooltip"
                                        data-bs-title="Power W = Drag N * airspeed * propulsion_efficiency">
                                    <i class="bi bi-info-circle-fill"></i></span>
                                
                                <br />
                                Thrust/Drag: <span id="${prefix}-drag">-</span><br />
                                AoA: <span id="${prefix}-aoa">-</span><br /><br />
                                
                                CL: <span id="${prefix}-cl">-</span><br />
                                <!--         const ApproxTotalCd = (ApproxAirfoilCd + extraZeroLiftDrag) * airplaine.miscFactorsData.dragFudgeFactor + Cdi;  -->
                                CD+Cdi: <span id="${prefix}-cd">-</span>
                                    <span  
                                        style="color: #369"
                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                        data-bs-custom-class="custom-tooltip"
                                        data-bs-title="Airfoil_CD * DragFudgeFactor + CDi">
                                    <i class="bi bi-info-circle-fill"></i></span><br />
                                CDi: <span id="${prefix}-cdi">-</span>
                                    <span 
                                        style="color: #369"
                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                        data-bs-custom-class="custom-tooltip"
                                        data-bs-title="CDi=CL² / (pi * AR * E)">
                                    <i class="bi bi-info-circle-fill"></i></span>
                                    <br />
                                Airfoil L/D: <span id="${prefix}-airfoil-ld">-</span>
                                <span 
                                    style="color: #369"
                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                        data-bs-custom-class="custom-tooltip"
                                        data-bs-title="Airfoil L/D at current Alpha">
                                    <i class="bi bi-info-circle-fill"></i></span>
                                <br />
                                Airfoil Max L/D: <span id="${prefix}-airfoil-max-ld">-</span><br />
                                Re: <span id="${prefix}-re">-</span>
                                <span 
                                    style="color: #369"
                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                        data-bs-custom-class="custom-tooltip"
                                        data-bs-title="Reynolds number">
                                    <i class="bi bi-info-circle-fill"></i></span>
                                <br /><br>
                                
                                
                                <div id="${prefix}-airfoil-link"></div>
                          </div>
                        </div>
`;
    }
    renderCharts() {
        return '';
        // Placeholder for multiple charts
        return `
            <div class="container">
                <div class="row">
                    <div class="card" style="width: 18rem; margin: 1rem; padding: 0">
                      <div class="card-body">
                        <h5 class="card-title"><span>General stats</h5>
                        <p class="card-text">
                            Total weight (AUW): <span id="stats-auw" class="fw-bold"></span><br />
                            Battery weight: <span id="stats-battery-weight" class="fw-bold"></span><br />
                            Stall speed: <span id="stats-stall-speed" class="fw-bold">-</span><br />
                            Max speed: <span id="stats-max-speed">-</span><br />
                            <!--Max climb: <span id="stats-max-climb">-</span><br />-->
                        </p>
                      </div>
                      <div class="card-footer small">
                            Aspect ratio: <span id="stats-aspect-ratio"></span><br />
                            Wing span: <span id="stats-wingspan"></span><br />
                            Battery:&nbsp;<span id="stats-energy-usable-wh"></span> <span class="text-muted">(usable)</span><br />
                            Battery vs AUW: <span id="stats-battery-percent-of-weight"></span><br />
                      </div>
                    </div>
                
                    <div class="card" style="width: 18rem; margin: 1rem; padding: 0">
                      <div class="card-body">
                        <h5 class="card-title"><span>Max duration:</span> <span id="stats-max-time-flight-time" class="badge bg-secondary">-</span></h5>
                        <p class="card-text">
                            Cruise Airspeed: <span id="stats-max-time-speed" class="fw-bold"></span><br />
                            Distance: <span id="stats-max-time-dist" class="fw-bold"></span><br />
                            Power usage: <span id="stats-max-time-watts" class="fw-bold">-</span>
                        </p>
                      </div>
                      <div class="card-footer small">
                            Efficiency: <span id="stats-max-time-wh-per-km">-</span><br />
                            Thrust/Drag: <span id="stats-max-time-drag">-</span><br />
                            AoA: <span id="stats-max-time-aoa">-</span><br />
                            <!--
                            <hr />
                            Optimal power: <span id="stats-max-time-optimal-power">-</span><br />
                            Optimal thrust: <span id="stats-max-time-optimal-thrust">-</span><br />
                            Optimal airspeed: <span id="stats-max-time-optimal-speed">-</span><br />
                            -->
                      </div>
                    </div>
                    
                    <div class="card" style="width: 18rem; margin: 1rem; padding: 0">
                      <div class="card-body">
                        <h5 class="card-title"><span>Max distance:</span> <span id="stats-max-dist-dist" class="badge bg-secondary">-</span></h5>
                        <p class="card-text">
                            Cruise Airspeed: <span id="stats-max-dist-speed" class="fw-bold"></span><br />
                            <!-- Distance: <span id="stats-max-dist-dist"></span><br /> -->
                            Flight duration: <span id="stats-max-dist-flight-time" class="fw-bold"></span><br />
                            Efficiency: <span id="stats-max-dist-wh-per-km" class="fw-bold">-</span>
                        </p>
                        <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
                      </div>
                      <div class="card-footer small">
                            Power usage: <span id="stats-max-dist-watts">-</span><br />
                            Trhust/Drag: <span id="stats-max-dist-drag">-</span><br />
                            AoA: <span id="stats-max-dist-aoa">-</span><br />
                            <!---
                            <hr />
                            Optimal power: <span id="stats-max-dist-optimal-power">-</span><br />
                            Optimal thrust: <span id="stats-max-dist-optimal-thrust">-</span><br />
                            Optimal airspeed: <span id="stats-max-dist-optimal-speed">-</span><br />
                            -->
                      </div>
                    </div>
                    
                </div>
            </div>
                

            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <canvas id="dragChart"></canvas>
                    </div>
                    
                    <div class="col-md-6">
                        <canvas id="flightChart"></canvas>
                    </div>
                    
                    <div class="col-md-6">
                        <canvas id="efficiencyChart"></canvas>
                    </div>
                    
                    
                    <div class="col-md-6">
                        <canvas id="aoaVsSpeed"></canvas>
                    </div>
                    
                    
                    
                </div>
                
                <div class="row">
                    <h5>Debug</h5>
                </div>
                
                <div class="row">
                
                    <div class="col-md-6">
                        <canvas id="CLsCDsChart"></canvas>
                    </div>
                    
                    <div class="col-md-6">
                        <canvas id="liftDragConstChart"></canvas>
                    </div>
                    
                    
                    <div class="col-md-6">
                        <canvas id="liftChart"></canvas>
                    </div>

                    <div class="col-md-6">
                        <canvas id="ldChart"></canvas>
                    </div>
                    
                    <!-- Add more charts as needed -->
                </div>
                
                
                <div class="row">
                <h5>How it works?</h5>
                
                <ul>
                    <li>Estimate an airfoil Lift (CL) & Drag (CD) coefficients for given angle of attack (quite limited, assumes sort of linear/quadratic curves). In future, it could use actual airfoil data, but more detailed data would need to be entered</li>
                    <li>For cruise (i.e. level flight, not going up nor down), for each speed and each angle of attack, compute airfoil lift and drag forces (assumes infinite wing aspect ratio) [1] [2] [3], then compute and add lift-induced drag (CDi) [4] to drag, get "Total Drag" which takes into account the actual aspect ratio, then for given airspeed, choose the angle of attack for which the lift force matches the aircraft weight</li>
                    <li>P.S. Lift drag ratio ("L/D"), is same as glide-ratio [1], the airspeed for max L/D will give the max flight distance</li>
                    <li>computing power usage for cruise, flight time distance & flight time:
                        <figure><blockquote class="blockquote">
                            <p>Power in Watts = Drag_Newtons * speed_m/s * prop_efficiency * motor_efficiency * esc_efficiency + flight_controller_power_usage</p>
                            <p>Flight time = available_battery_energy_in_watt_hours / Power in Watts</p>
                            <p>Flight distance = speed * flight_time</p>
                            </blockquote></figure> 
                        </li>
                </ul>
                
                More info:<br />
                <ul>
                    <li>[1] <a href="https://en.wikipedia.org/wiki/Lift-to-drag_ratio">https://en.wikipedia.org/wiki/Lift-to-drag_ratio</a></li>
                    <li>[2] <a href="https://en.wikipedia.org/wiki/Lift_(force)">https://en.wikipedia.org/wiki/Lift_(force)</a></li>
                    <li>[3] <a href="https://en.wikipedia.org/wiki/Drag_(physics)">https://en.wikipedia.org/wiki/Drag_(physics)</a></li>
                    <li>[4] <a href="https://en.wikipedia.org/wiki/Lift-induced_drag">https://en.wikipedia.org/wiki/Lift-induced_drag</a></li>
                </ul>
                
                </div>
            </div>
            
            
        `;
    }
    initializeCharts() {
        // Initialize more charts as needed
    }
    plotGraph(canvasId, label, xData, yData, color, chartTitle = undefined, xTitle = undefined, yTitle = undefined) {
        const ctx = document.getElementById(canvasId);
        this.plotMultiYGraph(canvasId, xData, [{
                label: label,
                data: yData,
                borderColor: color,
                tension: 0.1,
                pointStyle: false
            }], chartTitle, xTitle, yTitle);
    }
    scaleWithTitle(title, beginAtZero) {
        return {
            beginAtZero: false,
            display: true,
            title: {
                text: title,
                display: true,
            }
        };
    }
    plotMultiYGraph(canvasId, xData, datasets, chartTitle = undefined, xTitle = undefined, yTitle = undefined, y1Title = undefined) {
        const ctx = document.getElementById(canvasId);
        const maybeExistingChart = this.charts.get(canvasId);
        if (maybeExistingChart !== undefined) {
            maybeExistingChart.destroy();
        }
        var xScale = {
            beginAtZero: true
        };
        var yScale = {
            beginAtZero: true
        };
        if (xTitle) {
            xScale = this.scaleWithTitle(xTitle, true);
        }
        if (yTitle) {
            yScale = this.scaleWithTitle(yTitle, true);
        }
        const chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: xData,
                datasets: datasets
            },
            options: {
                scales: {
                    y: yScale,
                    x: xScale,
                    y1: {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        // grid line settings
                        grid: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                        title: {
                            display: true,
                            text: y1Title || ""
                        }
                    },
                },
                responsive: true,
                plugins: {
                    title: {
                        display: true,
                        text: chartTitle || undefined
                    },
                },
            }
        });
        this.charts.set(canvasId, chart);
    }
}
new AerodynamicsApp('app');
